export const wordLevels = {
  basic: 'basic',
  intermediate: 'intermediate',
  advanced: 'advanced'
}

export const wordStates = {
  state1: 'uncompleted',
  state2: 'completed'
}

export const wordType = {
  type1: "en",
  type2: "ko",
  type3: 'all'
}

export const words = [
  {id: 1, en: 'abate', ko: '(강도가)약해지다', level: 'intermediate'},
  {id: 2, en: 'abandon', ko: '버리다', level: 'intermediate'},
  {id: 3, en: 'able', ko: '할 수 있는', level: 'intermediate'},
  {id: 4, en: 'aboard', ko: '배로', level: 'intermediate'},
  {id: 5, en: 'abort', ko: '유산하다', level: 'advanced'},
  {id: 6, en: 'about', ko: '-에 대하여', level: 'basic'},
  {id: 7, en: 'above', ko: '-보다 위에', level: 'basic'},
  {id: 8, en: 'abroad', ko: '외국으로', level: 'intermediate'},
  {id: 9, en: 'absent', ko: '부재의', level: 'intermediate'},
  {id: 10, en: 'absolute', ko: '절대의', level: 'intermediate'},
  {id: 11, en: 'absorb', ko: '흡수하다', level: 'intermediate'},
  {id: 12, en: 'abstract', ko: '추상적인', level: 'intermediate'},
  {id: 13, en: 'absurd', ko: '불합리한', level: 'advanced'},
  {id: 14, en: 'abundant', ko: '풍부한', level: 'intermediate'},
  {id: 15, en: 'abuse', ko: '남용', level: 'intermediate'},
  {id: 16, en: 'academy', ko: '학술원', level: 'basic'},
  {id: 17, en: 'accelerate', ko: '가속하다 속도가 가해지다', level: 'intermediate'},
  {id: 18, en: 'accent', ko: '액센트', level: 'basic'},
  {id: 19, en: 'accept', ko: '받아들이다', level: 'intermediate'},
  {id: 20, en: 'access', ko: '접근', level: 'intermediate'},
  {id: 21, en: 'accident', ko: '뜻밖의 사건', level: 'basic'},
  {id: 22, en: 'accommodate', ko: '수용하다', level: 'intermediate'},
  {id: 23, en: 'accompany', ko: '동반하다', level: 'intermediate'},
  {id: 24, en: 'accomplish', ko: '이루다', level: 'intermediate'},
  {id: 25, en: 'accord', ko: '일치하다', level: 'advanced'},
  {id: 26, en: 'account', ko: '설명하다 계산', level: 'intermediate'},
  {id: 27, en: 'accumulate', ko: '축적하다', level: 'advanced'},
  {id: 28, en: 'accurate', ko: '정확한', level: 'intermediate'},
  {id: 29, en: 'accuse', ko: '고발하다', level: 'intermediate'},
  {id: 30, en: 'achieve', ko: '성취하다', level: 'intermediate'},
  {id: 31, en: 'acid', ko: '산, 신', level: 'intermediate'},
  {id: 32, en: 'acknowledge', ko: '인정하다', level: 'intermediate'},
  {id: 33, en: 'acquaint', ko: '알리다', level: 'advanced'},
  {id: 34, en: 'acquire', ko: '얻다', level: 'intermediate'},
  {id: 35, en: 'acquisition', ko: '획득', level: 'advanced'},
  {id: 36, en: 'across', ko: '가로질러', level: 'basic'},
  {id: 37, en: 'act', ko: '행동하다', level: 'basic'},
  {id: 38, en: 'activate', ko: '활동적으로 하다', level: 'intermediate'},
  {id: 39, en: 'actual', ko: '현실의', level: 'intermediate'},
  {id: 40, en: 'acute', ko: '날카로운', level: 'intermediate'},
  {id: 41, en: 'adapt', ko: '적용시키다', level: 'intermediate'},
  {id: 42, en: 'add', ko: '추가하다', level: 'basic'},
  {id: 43, en: 'addict', ko: '열중하게 하다', level: 'intermediate'},
  {id: 44, en: 'address', ko: '말을 걸다', level: 'basic'},
  {id: 45, en: 'adequate', ko: '충분한', level: 'intermediate'},
  {id: 46, en: 'adjust', ko: '맞추다', level: 'intermediate'},
  {id: 47, en: 'administer', ko: '관리하다', level: 'intermediate'},
  {id: 48, en: 'admire', ko: '감복하다', level: 'intermediate'},
  {id: 49, en: 'admission', ko: '입장', level: 'intermediate'},
  {id: 50, en: 'admit', ko: '받아들이다', level: 'intermediate'},
  {id: 51, en: 'adolescent', ko: '청년기의', level: 'intermediate'},
  {id: 52, en: 'adopt', ko: '채용하다', level: 'intermediate'},
  {id: 53, en: 'adult', ko: '성인', level: 'basic'},
  {id: 54, en: 'advance', ko: '나아가다', level: 'intermediate'},
  {id: 55, en: 'advantage', ko: '유리한 입장', level: 'intermediate'},
  {id: 56, en: 'adventure', ko: '모험 모험하다', level: 'basic'},
  {id: 57, en: 'adverse', ko: '거꾸로의', level: 'advanced'},
  {id: 58, en: 'advertise', ko: '광고하다', level: 'intermediate'},
  {id: 59, en: 'advise', ko: '충고하다', level: 'basic'},
  {id: 60, en: 'advocate', ko: '변호사', level: 'intermediate'},
  {id: 61, en: 'aesthetic', ko: '미적인', level: 'advanced'},
  {id: 62, en: 'affair', ko: '일', level: 'intermediate'},
  {id: 63, en: 'affect', ko: '영향을 주다', level: 'intermediate'},
  {id: 64, en: 'affection', ko: '애정', level: 'intermediate'},
  {id: 65, en: 'affiliate', ko: '회원으로 가입시키다', level: 'advanced'},
  {id: 66, en: 'afford', ko: '여유가 있다', level: 'intermediate'},
  {id: 67, en: 'afraid', ko: '두려워하여', level: 'basic'},
  {id: 68, en: 'after', ko: '후에', level: 'basic'},
  {id: 69, en: 'afternoon', ko: '오후', level: 'basic'},
  {id: 70, en: 'again', ko: '다시', level: 'basic'},
  {id: 71, en: 'against', ko: '…에 반대하여', level: 'basic'},
  {id: 72, en: 'age', ko: '연령', level: 'basic'},
  {id: 73, en: 'agency', ko: '기능', level: 'intermediate'},
  {id: 74, en: 'agenda', ko: '안건', level: 'intermediate'},
  {id: 75, en: 'agent', ko: '대리인', level: 'intermediate'},
  {id: 76, en: 'aggressive', ko: '침략적인', level: 'intermediate'},
  {id: 77, en: 'ago', ko: '이전에', level: 'basic'},
  {id: 78, en: 'agree', ko: '동의하다', level: 'basic'},
  {id: 79, en: 'agriculture', ko: '농업', level: 'intermediate'},
  {id: 80, en: 'ahead', ko: '전방에', level: 'basic'},
  {id: 81, en: 'aid', ko: '도와 주다', level: 'intermediate'},
  {id: 82, en: 'aim', ko: '겨누다', level: 'intermediate'},
  {id: 83, en: 'air', ko: '공기', level: 'basic'},
  {id: 84, en: 'airplane', ko: '비행기', level: 'basic'},
  {id: 85, en: 'aircraft', ko: '항공기', level: 'intermediate'},
  {id: 86, en: 'airline', ko: '정기항공', level: 'basic'},
  {id: 87, en: 'airport', ko: '공항', level: 'basic'},
  {id: 88, en: 'aisle', ko: '측면복도', level: 'intermediate'},
  {id: 89, en: 'alert', ko: '빈틈없는', level: 'intermediate'},
  {id: 90, en: 'alien', ko: '외국의', level: 'intermediate'},
  {id: 91, en: 'alike', ko: '비슷한', level: 'intermediate'},
  {id: 92, en: 'alive', ko: '살아있는', level: 'intermediate'},
  {id: 93, en: 'all', ko: '모든', level: 'basic'},
  {id: 94, en: 'allocate', ko: '할당하다', level: 'advanced'},
  {id: 95, en: 'allow', ko: '허락하다', level: 'intermediate'},
  {id: 96, en: 'ally', ko: '동맹하다', level: 'intermediate'},
  {id: 97, en: 'almost', ko: '거의', level: 'basic'},
  {id: 98, en: 'alone', ko: '다만 홀로(혼자서)', level: 'basic'},
  {id: 99, en: 'along', ko: '-을 따라', level: 'basic'},
  {id: 100, en: 'alongside', ko: '-의 곁에', level: 'intermediate'},
  {id: 101, en: 'aloud', ko: '큰 소리로', level: 'basic'},
  {id: 102, en: 'already', ko: '이미', level: 'basic'},
  {id: 103, en: 'alright', ko: '더할나위없이', level: 'basic'},
  {id: 104, en: 'also', ko: '-도 또한', level: 'basic'},
  {id: 105, en: 'alter', ko: '바꾸다', level: 'intermediate'},
  {id: 106, en: 'alternative', ko: '어느 한쪽의 양자택일', level: 'intermediate'},
  {id: 107, en: 'although', ko: '비록 -일지라도', level: 'intermediate'},
  {id: 108, en: 'altogether', ko: '전혀', level: 'intermediate'},
  {id: 109, en: 'always', ko: '늘', level: 'basic'},
  {id: 110, en: 'A.M.', ko: '오전', level: 'basic'},
  {id: 111, en: 'amaze', ko: '깜짝 놀라게 하다', level: 'intermediate'},
  {id: 112, en: 'ambassador', ko: '대사', level: 'intermediate'},
  {id: 113, en: 'ambition', ko: '야심', level: 'intermediate'},
  {id: 114, en: 'among', ko: '-중에', level: 'intermediate'},
  {id: 115, en: 'amount', ko: '(금액이)-이 되다', level: 'intermediate'},
  {id: 116, en: 'amplify', ko: '확대하다', level: 'advanced'},
  {id: 117, en: 'amuse', ko: '재미나게 하다', level: 'intermediate'},
  {id: 118, en: 'analyze', ko: '분해하다', level: 'intermediate'},
  {id: 119, en: 'anchor', ko: '닻', level: 'intermediate'},
  {id: 120, en: 'ancient', ko: '옛날의', level: 'intermediate'},
  {id: 121, en: 'and', ko: '및', level: 'basic'},
  {id: 122, en: 'angel', ko: '천사', level: 'basic'},
  {id: 123, en: 'anger', ko: '성', level: 'basic'},
  {id: 124, en: 'angle', ko: '각', level: 'intermediate'},
  {id: 125, en: 'animal', ko: '동물', level: 'basic'},
  {id: 126, en: 'anniversary', ko: '기념일 예년의', level: 'intermediate'},
  {id: 127, en: 'announce', ko: '알리다', level: 'intermediate'},
  {id: 128, en: 'annoy', ko: '귀찮게하다', level: 'intermediate'},
  {id: 129, en: 'annual', ko: '일년의', level: 'intermediate'},
  {id: 130, en: 'another', ko: '또 하나', level: 'basic'},
  {id: 131, en: 'answer', ko: '대답', level: 'basic'},
  {id: 132, en: 'ant', ko: '개미', level: 'basic'},
  {id: 133, en: 'anticipate', ko: '예기하다', level: 'intermediate'},
  {id: 134, en: 'anxiety', ko: '근심', level: 'intermediate'},
  {id: 135, en: 'anxious', ko: '걱정되는', level: 'intermediate'},
  {id: 136, en: 'any', ko: '어떤', level: 'basic'},
  {id: 137, en: 'apart', ko: '떨어져서', level: 'intermediate'},
  {id: 138, en: 'apology', ko: '사과, 양해를 구하는 말', level: 'intermediate'},
  {id: 139, en: 'apparent', ko: '명백한', level: 'intermediate'},
  {id: 140, en: 'appeal', ko: '간청하다', level: 'intermediate'},
  {id: 141, en: 'appear', ko: '나타나다', level: 'intermediate'},
  {id: 142, en: 'apple', ko: '사과', level: 'basic'},
  {id: 143, en: 'applicant', ko: '지원자', level: 'intermediate'},
  {id: 144, en: 'apply', ko: '(물건을)대다', level: 'intermediate'},
  {id: 145, en: 'appoint', ko: '지정하다', level: 'intermediate'},
  {id: 146, en: 'appreciate', ko: '감상하다', level: 'intermediate'},
  {id: 147, en: 'approach', ko: '다가가다', level: 'intermediate'},
  {id: 148, en: 'appropriate', ko: '적당한', level: 'intermediate'},
  {id: 149, en: 'approve', ko: '시인하다', level: 'intermediate'},
  {id: 150, en: 'approximate', ko: '어림셈의', level: 'intermediate'},
  {id: 151, en: 'architect', ko: '건축가', level: 'intermediate'},
  {id: 152, en: 'architecture', ko: '건축', level: 'intermediate'},
  {id: 153, en: 'archive', ko: '기록 보관소', level: 'advanced'},
  {id: 154, en: 'area', ko: '면적', level: 'basic'},
  {id: 155, en: 'argue', ko: '논하다', level: 'intermediate'},
  {id: 156, en: 'arise', ko: '생기다', level: 'intermediate'},
  {id: 157, en: 'arm', ko: '팔', level: 'basic'},
  {id: 158, en: 'army', ko: '육군', level: 'intermediate'},
  {id: 159, en: 'around', ko: '사방에', level: 'basic'},
  {id: 160, en: 'arrange', ko: '가지런히 하다', level: 'intermediate'},
  {id: 161, en: 'arrest', ko: '체포하다', level: 'intermediate'},
  {id: 162, en: 'arrive', ko: '도착하다', level: 'basic'},
  {id: 163, en: 'arrow', ko: '화살', level: 'intermediate'},
  {id: 164, en: 'art', ko: '예술', level: 'basic'},
  {id: 165, en: 'article', ko: '물품', level: 'intermediate'},
  {id: 166, en: 'artificial', ko: '인공의', level: 'intermediate'},
  {id: 167, en: 'as', ko: '-와 같은 정도로', level: 'basic'},
  {id: 168, en: 'ash', ko: '회', level: 'intermediate'},
  {id: 169, en: 'aside', ko: '곁에', level: 'intermediate'},
  {id: 170, en: 'ask', ko: '묻다', level: 'basic'},
  {id: 171, en: 'asleep', ko: '잠들은', level: 'intermediate'},
  {id: 172, en: 'aspect', ko: '관점', level: 'intermediate'},
  {id: 173, en: 'aspire', ko: '열망하다', level: 'intermediate'},
  {id: 174, en: 'assault', ko: '습격', level: 'advanced'},
  {id: 175, en: 'assemble', ko: '모으다', level: 'intermediate'},
  {id: 176, en: 'assert', ko: '단언하다', level: 'intermediate'},
  {id: 177, en: 'assess', ko: '(세금 등을)평가[사정]하다', level: 'intermediate'},
  {id: 178, en: 'asset', ko: '자산', level: 'intermediate'},
  {id: 179, en: 'assign', ko: '할당하다', level: 'intermediate'},
  {id: 180, en: 'assist', ko: '돕다', level: 'intermediate'},
  {id: 181, en: 'associate', ko: '연상하다', level: 'intermediate'},
  {id: 182, en: 'assume', ko: '취하다', level: 'intermediate'},
  {id: 183, en: 'assure', ko: '보증하다', level: 'intermediate'},
  {id: 184, en: 'astonish', ko: '놀라게 하다', level: 'intermediate'},
  {id: 185, en: 'at', ko: '-에서', level: 'basic'},
  {id: 186, en: 'athlete', ko: '운동가', level: 'intermediate'},
  {id: 187, en: 'atmosphere', ko: '대기', level: 'intermediate'},
  {id: 188, en: 'atom', ko: '원자', level: 'intermediate'},
  {id: 189, en: 'attach', ko: '붙이다', level: 'intermediate'},
  {id: 190, en: 'attack', ko: '공격하다', level: 'intermediate'},
  {id: 191, en: 'attain', ko: '이르다', level: 'intermediate'},
  {id: 192, en: 'attempt', ko: '시도하다', level: 'intermediate'},
  {id: 193, en: 'attend', ko: '출석하다', level: 'intermediate'},
  {id: 194, en: 'attention', ko: '주의', level: 'intermediate'},
  {id: 195, en: 'attitude', ko: '태도', level: 'intermediate'},
  {id: 196, en: 'attorney', ko: '변호사', level: 'advanced'},
  {id: 197, en: 'attract', ko: '끌어 당기다', level: 'intermediate'},
  {id: 198, en: 'attribute', ko: '속성', level: 'intermediate'},
  {id: 199, en: 'auction', ko: '경매', level: 'intermediate'},
  {id: 200, en: 'audience', ko: '청중', level: 'intermediate'},
  {id: 201, en: 'aunt', ko: '고모, 아주머니', level: 'basic'},
  {id: 202, en: 'authentic', ko: '진짜의', level: 'advanced'},
  {id: 203, en: 'author', ko: '저자', level: 'intermediate'},
  {id: 204, en: 'autobiography', ko: '자서전', level: 'intermediate'},
  {id: 205, en: 'automatic', ko: '자동의', level: 'intermediate'},
  {id: 206, en: 'automobile', ko: '자동차, 자동차의', level: 'intermediate'},
  {id: 207, en: 'available', ko: '쓸모있는', level: 'intermediate'},
  {id: 208, en: 'avenue', ko: '가로수길', level: 'intermediate'},
  {id: 209, en: 'average', ko: '평균', level: 'intermediate'},
  {id: 210, en: 'avoid', ko: '피하다', level: 'intermediate'},
  {id: 211, en: 'await', ko: '기다리다', level: 'intermediate'},
  {id: 212, en: 'awake', ko: '깨우다', level: 'intermediate'},
  {id: 213, en: 'award', ko: '상', level: 'intermediate'},
  {id: 214, en: 'aware', ko: '알고 있는', level: 'intermediate'},
  {id: 215, en: 'away', ko: '떨어져서', level: 'basic'},
  {id: 216, en: 'awesome', ko: '무서운', level: 'intermediate'},
  {id: 217, en: 'awful', ko: '두려운', level: 'intermediate'},
  {id: 218, en: 'awkward', ko: '어색한', level: 'intermediate'},
  {id: 219, en: 'baby', ko: '아기, 막내', level: 'basic'},
  {id: 220, en: 'back', ko: '등', level: 'basic'},
  {id: 221, en: 'background', ko: '배경', level: 'basic'},
  {id: 222, en: 'bad', ko: '나쁜', level: 'basic'},
  {id: 223, en: 'bake', ko: '굽다', level: 'basic'},
  {id: 224, en: 'balance', ko: '균형', level: 'intermediate'},
  {id: 225, en: 'ball', ko: '공', level: 'basic'},
  {id: 226, en: 'balloon', ko: '기구', level: 'basic'},
  {id: 227, en: 'ban', ko: '금지', level: 'intermediate'},
  {id: 228, en: 'band', ko: '그룹', level: 'basic'},
  {id: 229, en: 'bang', ko: '강타', level: 'intermediate'},
  {id: 230, en: 'bank', ko: '은행, 둑', level: 'basic'},
  {id: 231, en: 'bankrupt', ko: '파산자', level: 'advanced'},
  {id: 232, en: 'bar', ko: '막대기', level: 'intermediate'},
  {id: 233, en: 'bare', ko: '벌거벗은', level: 'intermediate'},
  {id: 234, en: 'bargain', ko: '매매', level: 'intermediate'},
  {id: 235, en: 'bark', ko: '짖다', level: 'intermediate'},
  {id: 236, en: 'barn', ko: '헛간', level: 'intermediate'},
  {id: 237, en: 'barrier', ko: '장벽', level: 'intermediate'},
  {id: 238, en: 'base', ko: '기초', level: 'basic'},
  {id: 239, en: 'baseball', ko: '야구', level: 'basic'},
  {id: 240, en: 'basic', ko: '기본의', level: 'basic'},
  {id: 241, en: 'basis', ko: '기초', level: 'intermediate'},
  {id: 242, en: 'basket', ko: '바구니', level: 'basic'},
  {id: 243, en: 'basketball', ko: '농구', level: 'basic'},
  {id: 244, en: 'bat', ko: '배트', level: 'basic'},
  {id: 245, en: 'bath', ko: '목욕', level: 'basic'},
  {id: 246, en: 'bathroom', ko: '욕실', level: 'basic'},
  {id: 247, en: 'battery', ko: '전지', level: 'basic'},
  {id: 248, en: 'battle', ko: '전투', level: 'basic'},
  {id: 249, en: 'bay', ko: '만', level: 'intermediate'},
  {id: 250, en: 'be', ko: '-이다', level: 'basic'},
  {id: 251, en: 'beach', ko: '해안', level: 'basic'},
  {id: 252, en: 'beam', ko: '광선', level: 'intermediate'},
  {id: 253, en: 'bean', ko: '콩', level: 'basic'},
  {id: 254, en: 'bear', ko: '나르다', level: 'basic'},
  {id: 255, en: 'beard', ko: '턱수염', level: 'intermediate'},
  {id: 256, en: 'beast', ko: '짐승', level: 'intermediate'},
  {id: 257, en: 'beat', ko: '치다', level: 'intermediate'},
  {id: 258, en: 'beauty', ko: '아름다움', level: 'basic'},
  {id: 259, en: 'because', ko: '왜냐하면', level: 'basic'},
  {id: 260, en: 'become', ko: '-이 되다', level: 'basic'},
  {id: 261, en: 'bed', ko: '침대', level: 'basic'},
  {id: 262, en: 'bedroom', ko: '침실, 방', level: 'basic'},
  {id: 263, en: 'bee', ko: '꿀벌', level: 'basic'},
  {id: 264, en: 'beef', ko: '쇠고기', level: 'basic'},
  {id: 265, en: 'beer', ko: '맥주', level: 'intermediate'},
  {id: 266, en: 'before', ko: '앞에', level: 'basic'},
  {id: 267, en: 'beg', ko: '청하다', level: 'intermediate'},
  {id: 268, en: 'begin', ko: '시작하다', level: 'basic'},
  {id: 269, en: 'behalf', ko: '위함', level: 'intermediate'},
  {id: 270, en: 'behave', ko: '행동하다', level: 'intermediate'},
  {id: 271, en: 'behavior', ko: '행동', level: 'intermediate'},
  {id: 272, en: 'behind', ko: '뒤에', level: 'basic'},
  {id: 273, en: 'believe', ko: '믿다', level: 'basic'},
  {id: 274, en: 'bell', ko: '종', level: 'basic'},
  {id: 275, en: 'belong', ko: '속하다', level: 'intermediate'},
  {id: 276, en: 'below', ko: '아래에', level: 'basic'},
  {id: 277, en: 'bend', ko: '구부리다', level: 'intermediate'},
  {id: 278, en: 'beneath', ko: '-의 바로 아래에', level: 'intermediate'},
  {id: 279, en: 'benefit', ko: '이익', level: 'intermediate'},
  {id: 280, en: 'berry', ko: '액과', level: 'intermediate'},
  {id: 281, en: 'beside', ko: '-의 곁에', level: 'basic'},
  {id: 282, en: 'bet', ko: '걸다', level: 'intermediate'},
  {id: 283, en: 'betray', ko: '배반하다', level: 'intermediate'},
  {id: 284, en: 'between', ko: '-의 사이에 사이에', level: 'basic'},
  {id: 285, en: 'beyond', ko: '저편에', level: 'intermediate'},
  {id: 286, en: 'bias', ko: '편견, 성향, 치우침', level: 'intermediate'},
  {id: 287, en: 'bible', ko: '성서, 성경', level: 'intermediate'},
  {id: 288, en: 'bicycle', ko: '자전거 자전거를 타다', level: 'basic'},
  {id: 289, en: 'big', ko: '큰', level: 'basic'},
  {id: 290, en: 'bill', ko: '계산서', level: 'basic'},
  {id: 291, en: 'billion', ko: '10억', level: 'intermediate'},
  {id: 292, en: 'bin', ko: '쓰레기통, 통', level: 'intermediate'},
  {id: 293, en: 'bind', ko: '매다', level: 'intermediate'},
  {id: 294, en: 'biography', ko: '전기', level: 'intermediate'},
  {id: 295, en: 'biology', ko: '생물학', level: 'intermediate'},
  {id: 296, en: 'bird', ko: '새', level: 'basic'},
  {id: 297, en: 'birth', ko: '출생', level: 'basic'},
  {id: 298, en: 'birthday', ko: '생일', level: 'basic'},
  {id: 299, en: 'bishop', ko: '주교', level: 'advanced'},
  {id: 300, en: 'bit', ko: '[bite의 과거(분사)] (이빨로) 물다, 조금, 작은 조각', level: 'intermediate'},
  {id: 301, en: 'bite', ko: '물다', level: 'basic'},
  {id: 302, en: 'bitter', ko: '쓴', level: 'intermediate'},
  {id: 303, en: 'black', ko: '검은', level: 'basic'},
  {id: 304, en: 'blame', ko: '책망하다', level: 'intermediate'},
  {id: 305, en: 'blank', ko: '공백', level: 'intermediate'},
  {id: 306, en: 'blanket', ko: '담요', level: 'intermediate'},
  {id: 307, en: 'blast', ko: '돌풍', level: 'advanced'},
  {id: 308, en: 'blend', ko: '혼합하다', level: 'intermediate'},
  {id: 309, en: 'bless', ko: '축복하다', level: 'intermediate'},
  {id: 310, en: 'blind', ko: '눈먼', level: 'intermediate'},
  {id: 311, en: 'blink', ko: '(눈을)깜빡거리다', level: 'intermediate'},
  {id: 312, en: 'block', ko: '사각형 덩어리, 건물', level: 'basic'},
  {id: 313, en: 'blonde', ko: '금발인, 금발 머리 여자', level: 'intermediate'},
  {id: 314, en: 'blood', ko: '피', level: 'basic'},
  {id: 315, en: 'bloom', ko: '쇳덩이', level: 'intermediate'},
  {id: 316, en: 'blossom', ko: '꽃, 꽃이 피다', level: 'intermediate'},
  {id: 317, en: 'blow', ko: '강타', level: 'intermediate'},
  {id: 318, en: 'blue', ko: '푸른', level: 'basic'},
  {id: 319, en: 'board', ko: '널빤지', level: 'basic'},
  {id: 320, en: 'boat', ko: '배', level: 'basic'},
  {id: 321, en: 'body', ko: '신체', level: 'basic'},
  {id: 322, en: 'boil', ko: '끓다', level: 'intermediate'},
  {id: 323, en: 'bold', ko: '대담한', level: 'intermediate'},
  {id: 324, en: 'bomb', ko: '폭탄 폭격하다', level: 'basic'},
  {id: 325, en: 'bond', ko: '결속', level: 'intermediate'},
  {id: 326, en: 'bone', ko: '뼈', level: 'basic'},
  {id: 327, en: 'book', ko: '책', level: 'basic'},
  {id: 328, en: 'boom', ko: '굉음', level: 'intermediate'},
  {id: 329, en: 'boost', ko: '뒤를 밀기', level: 'intermediate'},
  {id: 330, en: 'boot', ko: '목이 긴 구두', level: 'basic'},
  {id: 331, en: 'border', ko: '가장자리', level: 'intermediate'},
  {id: 332, en: 'bore', ko: '고조', level: 'intermediate'},
  {id: 333, en: 'borrow', ko: '빌다', level: 'basic'},
  {id: 334, en: 'boss', ko: '두목', level: 'basic'},
  {id: 335, en: 'both', ko: '쌍방의', level: 'basic'},
  {id: 336, en: 'bother', ko: '괴롭히다 근심하다 귀찮음', level: 'intermediate'},
  {id: 337, en: 'bottle', ko: '병', level: 'basic'},
  {id: 338, en: 'bottom', ko: '밑바닥', level: 'basic'},
  {id: 339, en: 'bounce', ko: '뛰어오르다', level: 'intermediate'},
  {id: 340, en: 'boundary', ko: '경계', level: 'intermediate'},
  {id: 341, en: 'bow', ko: '절', level: 'intermediate'},
  {id: 342, en: 'bowl', ko: '사발', level: 'basic'},
  {id: 343, en: 'boy', ko: '소년', level: 'basic'},
  {id: 344, en: 'brain', ko: '뇌', level: 'basic'},
  {id: 345, en: 'brake', ko: '브레이크', level: 'basic'},
  {id: 346, en: 'branch', ko: '가지', level: 'basic'},
  {id: 347, en: 'brand', ko: '상표', level: 'basic'},
  {id: 348, en: 'brave', ko: '용감한', level: 'basic'},
  {id: 349, en: 'bread', ko: '빵', level: 'basic'},
  {id: 350, en: 'break', ko: '부수다', level: 'basic'},
  {id: 351, en: 'breakfast', ko: '아침밥', level: 'basic'},
  {id: 352, en: 'breast', ko: '가슴', level: 'intermediate'},
  {id: 353, en: 'breathe', ko: '숨쉬다', level: 'intermediate'},
  {id: 354, en: 'breed', ko: '기르다', level: 'advanced'},
  {id: 355, en: 'breeze', ko: '미풍', level: 'intermediate'},
  {id: 356, en: 'brew', ko: '양조하다', level: 'advanced'},
  {id: 357, en: 'brick', ko: '벽돌', level: 'intermediate'},
  {id: 358, en: 'bride', ko: '신부', level: 'intermediate'},
  {id: 359, en: 'bridge', ko: '다리', level: 'basic'},
  {id: 360, en: 'brief', ko: '단시간의', level: 'intermediate'},
  {id: 361, en: 'bright', ko: '밝은', level: 'basic'},
  {id: 362, en: 'brilliant', ko: '빛나는', level: 'intermediate'},
  {id: 363, en: 'bring', ko: '가져오다', level: 'basic'},
  {id: 364, en: 'broad', ko: '(폭이)넓은', level: 'intermediate'},
  {id: 365, en: 'broadcast', ko: '방송하다', level: 'intermediate'},
  {id: 366, en: 'brother', ko: '형제', level: 'basic'},
  {id: 367, en: 'brown', ko: '갈색의, 갈색', level: 'basic'},
  {id: 368, en: 'brush', ko: '붓, 솔', level: 'basic'},
  {id: 369, en: 'brute', ko: '야수, 짐승같은', level: 'advanced'},
  {id: 370, en: 'bubble', ko: '거품 거품이 일다', level: 'basic'},
  {id: 371, en: 'budget', ko: '예산', level: 'intermediate'},
  {id: 372, en: 'bug', ko: '벌레', level: 'basic'},
  {id: 373, en: 'build', ko: '짓다', level: 'basic'},
  {id: 374, en: 'bulk', ko: '부피', level: 'advanced'},
  {id: 375, en: 'bull', ko: '황소', level: 'intermediate'},
  {id: 376, en: 'bullet', ko: '총알, 탄환', level: 'intermediate'},
  {id: 377, en: 'bully', ko: '괴롭히는 사람', level: 'intermediate'},
  {id: 378, en: 'bump', ko: '충돌 부딪치다', level: 'intermediate'},
  {id: 379, en: 'bunch', ko: '송이', level: 'intermediate'},
  {id: 380, en: 'bundle', ko: '다발', level: 'intermediate'},
  {id: 381, en: 'burden', ko: '후렴', level: 'intermediate'},
  {id: 382, en: 'burn', ko: "시내", level: 'basic'},
  {id: 383, en: "burst", ko: "파열하다", level: 'intermediate'},
  {id: 384, en: "bury", ko: "묻다", level: 'intermediate'},
  {id: 385, en: "bush", ko: "덤불", level: 'intermediate'},
  {id: 386, en: "business", ko: "직업", level: 'basic'},
  {id: 387, en: "busy", ko: "바쁜", level: 'basic'},
  {id: 388, en: "but", ko: "그러나, 다만, (-을)제외하고", level: 'basic'},
  {id: 389, en: "butcher", ko: "정육점주인", level: 'intermediate'},
  {id: 390, en: "button", ko: "단추 단추를 채우다 단추로 채워지다", level: 'basic'},
  {id: 391, en: "buy", ko: "사다", level: 'basic'},
  {id: 392, en: "buzz", ko: "윙윙거리는 소리", level: 'intermediate'},
  {id: 393, en: "by", ko: "곁에", level: 'basic'},
  {id: 394, en: "cab", ko: "택시", level: 'intermediate'},
  {id: 395, en: "cabin", ko: "선실", level: 'intermediate'},
  {id: 396, en: "cable", ko: "해저전신", level: 'intermediate'},
  {id: 397, en: "cage", ko: "새장", level: 'basic'},
  {id: 398, en: "calculate", ko: "계산하다", level: 'intermediate'},
  {id: 399, en: "calendar", ko: "달력", level: 'basic'},
  {id: 400, en: "call", ko: "부르다", level: 'basic'},
  {id: 401, en: "calm", ko: "평온한", level: 'basic'},
  {id: 402, en: "can", ko: "할 수 있다", level: 'basic'},
  {id: 403, en: "cancel", ko: "취소하다", level: 'intermediate'},
  {id: 404, en: "cancer", ko: "암", level: 'intermediate'},
  {id: 405, en: "candidate", ko: "지원자", level: 'intermediate'},
  {id: 406, en: "candy", ko: "사탕과자", level: 'basic'},
  {id: 407, en: "canvas", ko: "돛베", level: 'intermediate'},
  {id: 408, en: "cap", ko: "모자", level: 'basic'},
  {id: 409, en: "capable", ko: "할 수 있는", level: 'intermediate'},
  {id: 410, en: "cape", ko: "망토, 곶", level: 'intermediate'},
  {id: 411, en: "capital", ko: "수위의", level: 'intermediate'},
  {id: 412, en: "captain", ko: "우두머리(chief)", level: 'basic'},
  {id: 413, en: "caption", ko: "표제", level: 'advanced'},
  {id: 414, en: "capture", ko: "붙잡다(=catch)", level: 'intermediate'},
  {id: 415, en: "car", ko: "자동차", level: 'basic'},
  {id: 416, en: "care", ko: "걱정", level: 'basic'},
  {id: 417, en: "career", ko: "경력", level: 'intermediate'},
  {id: 418, en: "carrot", ko: "당근", level: 'basic'},
  {id: 419, en: "carry", ko: "나르다", level: 'basic'},
  {id: 420, en: "cart", ko: "수제, 마차", level: 'basic'},
  {id: 421, en: "carve", ko: "조각하다", level: 'intermediate'},
  {id: 422, en: "case", ko: "경우", level: 'basic'},
  {id: 423, en: "cash", ko: "현금 현금으로 바꾸다 현금의", level: 'basic'},
  {id: 424, en: "cast", ko: "던지다", level: 'intermediate'},
  {id: 425, en: "castle", ko: "성", level: 'basic'},
  {id: 426, en: "casual", ko: "우연한", level: 'intermediate'},
  {id: 427, en: "cat", ko: "고양이", level: 'basic'},
  {id: 428, en: "catch", ko: "붙잡다", level: 'basic'},
  {id: 429, en: "category", ko: "범주", level: 'intermediate'},
  {id: 430, en: "cater", ko: "음식물을 마련하다", level: 'advanced'},
  {id: 431, en: "cathedral", ko: "대성당", level: 'advanced'},
  {id: 432, en: "cattle", ko: "소", level: 'intermediate'},
  {id: 433, en: "causal", ko: "원인의", level: 'intermediate'},
  {id: 434, en: "cause", ko: "원인", level: 'intermediate'},
  {id: 435, en: "caution", ko: "조심", level: 'intermediate'},
  {id: 436, en: "cave", ko: "동굴 굴을 파다 꺼지다", level: 'intermediate'},
  {id: 437, en: "cease", ko: "그만두다 그치다 중지", level: 'intermediate'},
  {id: 438, en: "ceiling", ko: "천장", level: 'intermediate'},
  {id: 439, en: "celebrate", ko: "기념하다, 축하하다", level: 'intermediate'},
  {id: 440, en: "celebrity", ko: "유명 인사, 명성", level: 'intermediate'},
  {id: 441, en: "cell", ko: "감방, 작은 방, 세포", level: 'intermediate'},
  {id: 442, en: "censor", ko: "검열관", level: 'intermediate'},
  {id: 443, en: "century", ko: "1세기", level: 'intermediate'},
  {id: 444, en: "certain", ko: "확신하는", level: 'basic'},
  {id: 445, en: "certificate", ko: "증명서", level: 'intermediate'},
  {id: 446, en: "chain", ko: "사슬", level: 'basic'},
  {id: 447, en: "chair", ko: "의자", level: 'basic'},
  {id: 448, en: "chairman", ko: "의장", level: 'intermediate'},
  {id: 449, en: "challenge", ko: "도전", level: 'intermediate'},
  {id: 450, en: "chamber", ko: "회의실, 방, 실내", level: 'advanced'},
  {id: 451, en: "chance", ko: "가능성 기회", level: 'basic'},
  {id: 452, en: "change", ko: "변화", level: 'basic'},
  {id: 453, en: "chaos", ko: "혼돈", level: 'intermediate'},
  {id: 454, en: "character", ko: "인격", level: 'intermediate'},
  {id: 455, en: "characteristic", ko: "특유의", level: 'intermediate'},
  {id: 456, en: "charge", ko: "요금", level: 'intermediate'},
  {id: 457, en: "charity", ko: "자비", level: 'intermediate'},
  {id: 458, en: "charm", ko: "매력", level: 'intermediate'},
  {id: 459, en: "chase", ko: "쫓다", level: 'intermediate'},
  {id: 460, en: "chat", ko: "잡담", level: 'intermediate'},
  {id: 461, en: "cheap", ko: "값싼", level: 'basic'},
  {id: 462, en: "check", ko: "살피다 알아보다 확인", level: 'basic'},
  {id: 463, en: "cheek", ko: "볼", level: 'intermediate'},
  {id: 464, en: "cheer", ko: "환호, 응원", level: 'intermediate'},
  {id: 465, en: "chef", ko: "셰프, 요리사", level: 'intermediate'},
  {id: 466, en: "chemical", ko: "화학의", level: 'intermediate'},
  {id: 467, en: "chemistry", ko: "화학", level: 'intermediate'},
  {id: 468, en: "chest", ko: "가슴팍", level: 'intermediate'},
  {id: 469, en: "chew", ko: "씹다", level: 'intermediate'},
  {id: 470, en: "chief", ko: "우두머리", level: 'intermediate'},
  {id: 471, en: "child", ko: "아이", level: 'basic'},
  {id: 472, en: "chill", ko: "차가움", level: 'intermediate'},
  {id: 473, en: "chin", ko: "턱(끝) 턱에 대다", level: 'intermediate'},
  {id: 474, en: "chip", ko: "(나무)토막", level: 'intermediate'},
  {id: 475, en: "choir", ko: "(교회의)성가대", level: 'intermediate'},
  {id: 476, en: "choose", ko: "고르다", level: 'basic'},
  {id: 477, en: "chop", ko: "(도끼 등으로)자르다", level: 'intermediate'},
  {id: 478, en: "chorus", ko: "합창", level: 'intermediate'},
  {id: 479, en: "chronic", ko: "만성의", level: 'advanced'},
  {id: 480, en: "church", ko: "교회", level: 'basic'},
  {id: 481, en: "cigarette", ko: "담배", level: 'intermediate'},
  {id: 482, en: "cinema", ko: "영화관", level: 'basic'},
  {id: 483, en: "circle", ko: "원", level: 'basic'},
  {id: 484, en: "circulate", ko: "순환하다", level: 'intermediate'},
  {id: 485, en: "circumstance", ko: "환경", level: 'intermediate'},
  {id: 486, en: "cite", ko: "인용하다(quote)", level: 'intermediate'},
  {id: 487, en: "citizen", ko: "시민", level: 'intermediate'},
  {id: 488, en: "city", ko: "도시", level: 'basic'},
  {id: 489, en: "civil", ko: "시민의", level: 'intermediate'},
  {id: 490, en: "claim", ko: "요구하다", level: 'intermediate'},
  {id: 491, en: "clap", ko: "짝짝", level: 'intermediate'},
  {id: 492, en: "clarify", ko: "맑게 하다", level: 'intermediate'},
  {id: 493, en: "clash", ko: "충돌하다", level: 'intermediate'},
  {id: 494, en: "class", ko: "계급", level: 'basic'},
  {id: 495, en: "classic", ko: "고전의", level: 'intermediate'},
  {id: 496, en: "classify", ko: "분류하다", level: 'intermediate'},
  {id: 497, en: "classroom", ko: "교실", level: 'basic'},
  {id: 498, en: "clause", ko: "조항", level: 'intermediate'},
  {id: 499, en: "clay", ko: "찰흙", level: 'intermediate'},
  {id: 500, en: "clean", ko: "청결한", level: 'basic'},
  {id: 501, en: "clear", ko: "맑은", level: 'basic'},
  {id: 502, en: "clerk", ko: "서기", level: 'basic'},
  {id: 503, en: "clever", ko: "영리한", level: 'basic'},
  {id: 504, en: "client", ko: "소송의뢰인", level: 'intermediate'},
  {id: 505, en: "cliff", ko: "절벽", level: 'intermediate'},
  {id: 506, en: "climate", ko: "기후", level: 'intermediate'},
  {id: 507, en: "climb", ko: "기어 오르다", level: 'basic'},
  {id: 508, en: "cling", ko: "밀착하다", level: 'intermediate'},
  {id: 509, en: "clinic", ko: "병원", level: 'intermediate'},
  {id: 510, en: "clip", ko: "가위로 자르다", level: 'basic'},
  {id: 511, en: "clock", ko: "시계", level: 'basic'},
  {id: 512, en: "close", ko: "닫다", level: 'basic'},
  {id: 513, en: "cloth", ko: "천", level: 'basic'},
  {id: 514, en: "cloud", ko: "구름", level: 'basic'},
  {id: 515, en: "club", ko: "클럽", level: 'basic'},
  {id: 516, en: "clue", ko: "단서", level: 'intermediate'},
  {id: 517, en: "cluster", ko: "떼", level: 'intermediate'},
  {id: 518, en: "coach", ko: "역마차", level: 'intermediate'},
  {id: 519, en: "coal", ko: "석탄", level: 'intermediate'},
  {id: 520, en: "coast", ko: "연안", level: 'intermediate'},
  {id: 521, en: "code", ko: "법전", level: 'intermediate'},
  {id: 522, en: "coin", ko: "화폐", level: 'basic'},
  {id: 523, en: "coincide", ko: "일치하다", level: 'intermediate'},
  {id: 524, en: "cold", ko: "추운", level: 'basic'},
  {id: 525, en: "collaborate", ko: "공동으로 일하다", level: 'intermediate'},
  {id: 526, en: "collapse", ko: "붕괴", level: 'intermediate'},
  {id: 527, en: "collar", ko: "칼라, 깃", level: 'intermediate'},
  {id: 528, en: "colleague", ko: "동료", level: 'intermediate'},
  {id: 529, en: "collect", ko: "모으다", level: 'basic'},
  {id: 530, en: "college", ko: "단과대학", level: 'basic'},
  {id: 531, en: "colony", ko: "식민지", level: 'intermediate'},
  {id: 532, en: "color", ko: "착색하다", level: 'basic'},
  {id: 533, en: "column", ko: "기둥, (신문 등의)단", level: 'intermediate'},
  {id: 534, en: "combat", ko: "격투하다", level: 'intermediate'},
  {id: 535, en: "combine", ko: "결합하다", level: 'intermediate'},
  {id: 536, en: "come", ko: "오다", level: 'basic'},
  {id: 537, en: "comedy", ko: "희극", level: 'basic'},
  {id: 538, en: "comfort", ko: "위안", level: 'intermediate'},
  {id: 539, en: "command", ko: "명령하다", level: 'intermediate'},
  {id: 540, en: "commence", ko: "시작하다", level: 'advanced'},
  {id: 541, en: "comment", ko: "논평", level: 'intermediate'},
  {id: 542, en: "commerce", ko: "상업", level: 'intermediate'},
  {id: 543, en: "commission", ko: "위임", level: 'intermediate'},
  {id: 544, en: "commit", ko: "위탁하다", level: 'intermediate'},
  {id: 545, en: "committee", ko: "위원회", level: 'intermediate'},
  {id: 546, en: "commodity", ko: "상품", level: 'advanced'},
  {id: 547, en: "communicate", ko: "알리다", level: 'intermediate'},
  {id: 548, en: "communist", ko: "공산주의자", level: 'intermediate'},
  {id: 549, en: "community", ko: "공동생활체", level: 'intermediate'},
  {id: 550, en: "companion", ko: "동료", level: 'intermediate'},
  {id: 551, en: "company", ko: "교제", level: 'basic'},
  {id: 552, en: "compare", ko: "비교하다", level: 'intermediate'},
  {id: 553, en: "compatible", ko: "양립할 수 있는", level: 'advanced'},
  {id: 554, en: "compel", ko: "억지로 -시키다", level: 'advanced'},
  {id: 555, en: "compensate", ko: "배상하다", level: 'advanced'},
  {id: 556, en: "compete", ko: "경쟁하다", level: 'intermediate'},
  {id: 557, en: "competent", ko: "능력있는", level: 'intermediate'},
  {id: 558, en: "compile", ko: "편찬하다", level: 'advanced'},
  {id: 559, en: "complain", ko: "불평하다", level: 'intermediate'},
  {id: 560, en: "complement", ko: "보완하는 것", level: 'intermediate'},
  {id: 561, en: "complete", ko: "완성하다", level: 'intermediate'},
  {id: 562, en: "complex", ko: "합성물", level: 'intermediate'},
  {id: 563, en: "complicate", ko: "복잡하게 하다", level: 'intermediate'},
  {id: 564, en: "component", ko: "구성하는 성분", level: 'advanced'},
  {id: 565, en: "compose", ko: "구성하다", level: 'intermediate'},
  {id: 566, en: "compound", ko: "성분 등을 혼합하다", level: 'advanced'},
  {id: 567, en: "comprehensive", ko: "이해력있는", level: 'intermediate'},
  {id: 568, en: "comprise", ko: "포함하다", level: 'advanced'},
  {id: 569, en: "compromise", ko: "타협 타협하다", level: 'advanced'},
  {id: 570, en: "compulsory", ko: "의무적인", level: 'advanced'},
  {id: 571, en: "conceal", ko: "숨기다", level: 'intermediate'},
  {id: 572, en: "conceive", ko: "상상하다", level: 'advanced'},
  {id: 573, en: "concentrate", ko: "집중하다", level: 'intermediate'},
  {id: 574, en: "concept", ko: "개념", level: 'intermediate'},
  {id: 575, en: "concern", ko: "관계하다", level: 'intermediate'},
  {id: 576, en: "concert", ko: "연주회", level: 'basic'},
  {id: 577, en: "conclude", ko: "결정하다", level: 'intermediate'},
  {id: 578, en: "concrete", ko: "구체적인 응고물", level: 'intermediate'},
  {id: 579, en: "condemn", ko: "나무라다", level: 'advanced'},
  {id: 580, en: "condition", ko: "조건", level: 'basic'},
  {id: 581, en: "conduct", ko: "행위 이끌다", level: 'intermediate'},
  {id: 582, en: "confer", ko: "주다", level: 'advanced'},
  {id: 583, en: "confess", ko: "실토하다", level: 'intermediate'},
  {id: 584, en: "confident", ko: "확신하는", level: 'intermediate'},
  {id: 585, en: "confine", ko: "국경", level: 'intermediate'},
  {id: 586, en: "confirm", ko: "확인하다", level: 'intermediate'},
  {id: 587, en: "conflict", ko: "투쟁", level: 'intermediate'},
  {id: 588, en: "conform", ko: "일치시키다", level: 'intermediate'},
  {id: 589, en: "confront", ko: "직면하다", level: 'intermediate'},
  {id: 590, en: "confuse", ko: "혼란시키다", level: 'intermediate'},
  {id: 591, en: "congratulate", ko: "축하하다", level: 'basic'},
  {id: 592, en: "congress", ko: "회의", level: 'intermediate'},
  {id: 593, en: "connect", ko: "잇다 이어지다", level: 'intermediate'},
  {id: 594, en: "conscience", ko: "양심", level: 'intermediate'},
  {id: 595, en: "conscious", ko: "의식적인", level: 'intermediate'},
  {id: 596, en: "consensus", ko: "(의견 등의)일치", level: 'advanced'},
  {id: 597, en: "consent", ko: "승낙하다", level: 'advanced'},
  {id: 598, en: "conserve", ko: "보존하다", level: 'advanced'},
  {id: 599, en: "consider", ko: "숙고하다", level: 'intermediate'},
  {id: 600, en: "consist", ko: "-으로 이루어지다", level: 'intermediate'},
  {id: 601, en: "consistent", ko: "시종일관한", level: 'intermediate'},
  {id: 602, en: "constant", ko: "불변의", level: 'intermediate'},
  {id: 603, en: "constitute", ko: "구성하다", level: 'advanced'},
  {id: 604, en: "constrain", ko: "강제하다", level: 'advanced'},
  {id: 605, en: "construct", ko: "건설하다 구성하다", level: 'intermediate'},
  {id: 606, en: "consult", ko: "상의하다", level: 'intermediate'},
  {id: 607, en: "consume", ko: "소비하다", level: 'intermediate'},
  {id: 608, en: "contact", ko: "접촉", level: 'intermediate'},
  {id: 609, en: "contain", ko: "내포하다", level: 'intermediate'},
  {id: 610, en: "contemporary", ko: "현대의", level: 'advanced'},
  {id: 611, en: "contend", ko: "싸우다", level: 'advanced'},
  {id: 612, en: "content", ko: "만족하여", level: 'intermediate'},
  {id: 613, en: "contest", ko: "겨루다", level: 'basic'},
  {id: 614, en: "context", ko: "문맥", level: 'intermediate'},
  {id: 615, en: "continent", ko: "자제심이 있는", level: 'intermediate'},
  {id: 616, en: "continue", ko: "계속하다", level: 'intermediate'},
  {id: 617, en: "contract", ko: "계약", level: 'intermediate'},
  {id: 618, en: "contradict", ko: "반박하다", level: 'advanced'},
  {id: 619, en: "contrary", ko: "반대의 반대 거꾸로", level: 'intermediate'},
  {id: 620, en: "contrast", ko: "대조", level: 'intermediate'},
  {id: 621, en: "contribute", ko: "기부하다", level: 'intermediate'},
  {id: 622, en: "control", ko: "억제하다", level: 'basic'},
  {id: 623, en: "controversy", ko: "논쟁", level: 'intermediate'},
  {id: 624, en: "convenient", ko: "편리한", level: 'intermediate'},
  {id: 625, en: "convention", ko: "관례", level: 'advanced'},
  {id: 626, en: "conversation", ko: "회화", level: 'intermediate'},
  {id: 627, en: "convert", ko: "바꾸다", level: 'advanced'},
  {id: 628, en: "convey", ko: "나르다", level: 'intermediate'},
  {id: 629, en: "convict", ko: "유죄로 판결하다 죄수", level: 'intermediate'},
  {id: 630, en: "convince", ko: "확신시키다", level: 'intermediate'},
  {id: 631, en: "cook", ko: "요리하다 요리사", level: 'basic'},
  {id: 632, en: "cookie", ko: "쿠키", level: 'basic'},
  {id: 633, en: "cool", ko: "시원한, 서늘한", level: 'basic'},
  {id: 634, en: "cooperate", ko: "협동하다", level: 'intermediate'},
  {id: 635, en: "coordinate", ko: "조직화, 조정하다", level: 'advanced'},
  {id: 636, en: "cop", ko: "경찰관, 겪다, 당하다", level: 'intermediate'},
  {id: 637, en: "cope", ko: "코우프(성직자의 긴 겉옷)", level: 'intermediate'},
  {id: 638, en: "copy", ko: "사본", level: 'basic'},
  {id: 639, en: "copyright", ko: "저작권, 판권", level: 'intermediate'},
  {id: 640, en: "cord", ko: "밧줄", level: 'intermediate'},
  {id: 641, en: "core", ko: "핵심", level: 'intermediate'},
  {id: 642, en: "corn", ko: "곡식, 티눈", level: 'intermediate'},
  {id: 643, en: "corner", ko: "모퉁이", level: 'basic'},
  {id: 644, en: "corporate", ko: "기업의, 법인의", level: 'intermediate'},
  {id: 645, en: "correct", ko: "옳은", level: 'intermediate'},
  {id: 646, en: "correspond", ko: "일치하다", level: 'intermediate'},
  {id: 647, en: "corridor", ko: "복도", level: 'advanced'},
  {id: 648, en: "corrupt", ko: "타락한", level: 'intermediate'},
  {id: 649, en: "cost", ko: "가격", level: 'basic'},
  {id: 650, en: "costume", ko: "복장", level: 'intermediate'},
  {id: 651, en: "cottage", ko: "시골집", level: 'intermediate'},
  {id: 652, en: "cotton", ko: "목화", level: 'basic'},
  {id: 653, en: "couch", ko: "소파, 침상", level: 'intermediate'},
  {id: 654, en: "cough", ko: "기침 기침을 하다 기침을 하여 -을 뱉어내다", level: 'intermediate'},
  {id: 655, en: "could", ko: "[can의 과거] ...할 수 있다", level: 'basic'},
  {id: 656, en: "council", ko: "회의", level: 'intermediate'},
  {id: 657, en: "counsel", ko: "조언, 의논", level: 'intermediate'},
  {id: 658, en: "count", ko: "계산", level: 'intermediate'},
  {id: 659, en: "counter", ko: "계산하는 사람", level: 'intermediate'},
  {id: 660, en: "counterpart", ko: "상대자", level: 'advanced'},
  {id: 661, en: "country", ko: "나라", level: 'basic'},
  {id: 662, en: "countryside", ko: "시골", level: 'basic'},
  {id: 663, en: "county", ko: "주", level: 'advanced'},
  {id: 664, en: "couple", ko: "한 쌍", level: 'basic'},
  {id: 665, en: "courage", ko: "용기", level: 'intermediate'},
  {id: 666, en: "cousin", ko: "사촌", level: 'basic'},
  {id: 667, en: "cover", ko: "덮다", level: 'basic'},
  {id: 668, en: "cow", ko: "위협하다 암소", level: 'basic'},
  {id: 669, en: "cowboy", ko: "목동", level: 'intermediate'},
  {id: 670, en: "crack", ko: "찰싹 소리내다 금가다 날카로운소리", level: 'intermediate'},
  {id: 671, en: "craft", ko: "솜씨", level: 'intermediate'},
  {id: 672, en: "crash", ko: "사고, 굉음, 충돌하다", level: 'intermediate'},
  {id: 673, en: "crawl", ko: "(엎드려) 기다", level: 'intermediate'},
  {id: 674, en: "crazy", ko: "미친", level: 'basic'},
  {id: 675, en: "create", ko: "창조하다", level: 'intermediate'},
  {id: 676, en: "creature", ko: "창조물", level: 'intermediate'},
  {id: 677, en: "credible", ko: "믿을 수 있는", level: 'intermediate'},
  {id: 678, en: "credit", ko: "신용", level: 'intermediate'},
  {id: 679, en: "creek", ko: "시내", level: 'advanced'},
  {id: 680, en: "creep", ko: "기다", level: 'advanced'},
  {id: 681, en: "crew", ko: "승무원", level: 'intermediate'},
  {id: 682, en: "cricket", ko: "크리켓, 귀뚜라미", level: 'intermediate'},
  {id: 683, en: "crime", ko: "범죄", level: 'intermediate'},
  {id: 684, en: "criminal", ko: "죄의", level: 'intermediate'},
  {id: 685, en: "crisis", ko: "위기", level: 'intermediate'},
  {id: 686, en: "crisp", ko: "바삭바삭한", level: 'intermediate'},
  {id: 687, en: "criterion", ko: "(판단이나 결정을 위한)기준", level: 'advanced'},
  {id: 688, en: "critic", ko: "비평가", level: 'intermediate'},
  {id: 689, en: "criticize", ko: "비평하다", level: 'intermediate'},
  {id: 690, en: "criticism", ko: "비평", level: 'intermediate'},
  {id: 691, en: "crop", ko: "수확", level: 'intermediate'},
  {id: 692, en: "cross", ko: "십자형", level: 'basic'},
  {id: 693, en: "crowd", ko: "군중", level: 'basic'},
  {id: 694, en: "crown", ko: "왕관", level: 'basic'},
  {id: 695, en: "crucial", ko: "결정적인", level: 'intermediate'},
  {id: 696, en: "cruel", ko: "잔인한", level: 'intermediate'},
  {id: 697, en: "cruise", ko: "순항하다", level: 'intermediate'},
  {id: 698, en: "crush", ko: "눌러 부수다", level: 'intermediate'},
  {id: 699, en: "cry", ko: "울다, 외치다", level: 'basic'},
  {id: 700, en: "crystal", ko: "수정", level: 'intermediate'},
  {id: 701, en: "cultivate", ko: "경작하다", level: 'intermediate'},
  {id: 702, en: "culture", ko: "문화", level: 'basic'},
  {id: 703, en: "cupboard", ko: "찬장", level: 'intermediate'},
  {id: 704, en: "cure", ko: "낫게하다, 치유", level: 'intermediate'},
  {id: 705, en: "curious", ko: "궁금한, 호기심이 많은", level: 'basic'},
  {id: 706, en: "curl", ko: "곱슬곱슬하다, 감기다, 곱슬", level: 'intermediate'},
  {id: 707, en: "currency", ko: "통화, 통용", level: 'advanced'},
  {id: 708, en: "current", ko: "현재의, 지금의, 통용되는", level: 'intermediate'},
  {id: 709, en: "curriculum", ko: "교육과정", level: 'advanced'},
  {id: 710, en: "curry", ko: "카레요리 카레로 맛을 내다", level: 'intermediate'},
  {id: 711, en: "curse", ko: "저주", level: 'advanced'},
  {id: 712, en: "curtain", ko: "커튼", level: 'basic'},
  {id: 713, en: "curve", ko: "곡선", level: 'intermediate'},
  {id: 714, en: "custody", ko: "보호", level: 'advanced'},
  {id: 715, en: "custom", ko: "습관", level: 'intermediate'},
  {id: 716, en: "customer", ko: "고객", level: 'basic'},
  {id: 717, en: "cut", ko: "베다", level: 'basic'},
  {id: 718, en: "cute", ko: "귀여운", level: 'basic'},
  {id: 719, en: "cycle", ko: "순환", level: 'basic'},
  {id: 720, en: "cynical", ko: "냉소적인", level: 'advanced'},
  {id: 721, en: "dad", ko: "아빠", level: 'basic'},
  {id: 722, en: "dairy", ko: "낙농장", level: 'intermediate'},
  {id: 723, en: "dam", ko: "댐", level: 'intermediate'},
  {id: 724, en: "damage", ko: "손해", level: 'intermediate'},
  {id: 725, en: "damp", ko: "축축한 습기 적시다", level: 'intermediate'},
  {id: 726, en: "dance", ko: "댄스", level: 'basic'},
  {id: 727, en: "danger", ko: "위험", level: 'basic'},
  {id: 728, en: "dare", ko: "감히 -하다", level: 'intermediate'},
  {id: 729, en: "dark", ko: "어두운", level: 'basic'},
  {id: 730, en: "darling", ko: "귀여운", level: 'intermediate'},
  {id: 731, en: "dash", ko: "돌진", level: 'intermediate'},
  {id: 732, en: "database", ko: "데이터베이스", level: 'intermediate'},
  {id: 733, en: "date", ko: "날짜", level: 'basic'},
  {id: 734, en: "daughter", ko: "딸", level: 'basic'},
  {id: 735, en: "dawn", ko: "새벽 날이 새다", level: 'intermediate'},
  {id: 736, en: "day", ko: "낮", level: 'basic'},
  {id: 737, en: "dead", ko: "죽은", level: 'basic'},
  {id: 738, en: "deal", ko: "양", level: 'intermediate'},
  {id: 739, en: "death", ko: "죽음", level: 'basic'},
  {id: 740, en: "debate", ko: "토론 토론하다", level: 'intermediate'},
  {id: 741, en: "debt", ko: "빚", level: 'intermediate'},
  {id: 742, en: "decade", ko: "10년간", level: 'intermediate'},
  {id: 743, en: "decay", ko: "쇠퇴하다", level: 'intermediate'},
  {id: 744, en: "decent", ko: "점잖은", level: 'advanced'},
  {id: 745, en: "decide", ko: "결정하다", level: 'basic'},
  {id: 746, en: "decision", ko: "결정", level: 'intermediate'},
  {id: 747, en: "deck", ko: "갑판", level: 'intermediate'},
  {id: 748, en: "declare", ko: "선언하다", level: 'intermediate'},
  {id: 749, en: "decline", ko: "기울다", level: 'intermediate'},
  {id: 750, en: "decorate", ko: "장식하다", level: 'intermediate'},
  {id: 751, en: "decrease", ko: "감소하다", level: 'intermediate'},
  {id: 752, en: "dedicate", ko: "봉납하다", level: 'advanced'},
  {id: 753, en: "deep", ko: "깊은", level: 'basic'},
  {id: 754, en: "defeat", ko: "패배", level: 'intermediate'},
  {id: 755, en: "defense", ko: "방어", level: 'intermediate'},
  {id: 756, en: "defend", ko: "방어하다", level: 'intermediate'},
  {id: 757, en: "defendant", ko: "피고 피고의", level: 'intermediate'},
  {id: 758, en: "deficiency", ko: "결핍", level: 'advanced'},
  {id: 759, en: "deficit", ko: "결손", level: 'advanced'},
  {id: 760, en: "define", ko: "정의하다", level: 'intermediate'},
  {id: 761, en: "definite", ko: "일정한", level: 'intermediate'},
  {id: 762, en: "degrade", ko: "지위를 낮추다", level: 'advanced'},
  {id: 763, en: "degree", ko: "도", level: 'intermediate'},
  {id: 764, en: "delay", ko: "늦추다", level: 'intermediate'},
  {id: 765, en: "delegate", ko: "파견하다", level: 'advanced'},
  {id: 766, en: "delete", ko: "삭제하다", level: 'intermediate'},
  {id: 767, en: "deliberate", ko: "숙고하다", level: 'advanced'},
  {id: 768, en: "delicate", ko: "미묘한", level: 'intermediate'},
  {id: 769, en: "delicious", ko: "맛있는", level: 'basic'},
  {id: 770, en: "delight", ko: "즐겁게하다 즐거워하다", level: 'intermediate'},
  {id: 771, en: "deliver", ko: "배달하다", level: 'intermediate'},
  {id: 772, en: "demand", ko: "요구하다", level: 'intermediate'},
  {id: 773, en: "democracy", ko: "민주주의", level: 'intermediate'},
  {id: 774, en: "democrat", ko: "민주주의자", level: 'intermediate'},
  {id: 775, en: "demon", ko: "악령, 악마", level: 'intermediate'},
  {id: 776, en: "demonstrate", ko: "증명하다", level: 'intermediate'},
  {id: 777, en: "dense", ko: "짙은", level: 'intermediate'},
  {id: 778, en: "dentist", ko: "치과의사", level: 'basic'},
  {id: 779, en: "deny", ko: "부정하다", level: 'intermediate'},
  {id: 780, en: "department", ko: "부서", level: 'intermediate'},
  {id: 781, en: "departure", ko: "출발", level: 'intermediate'},
  {id: 782, en: "depend", ko: "의존하다, 좌우되다", level: 'intermediate'},
  {id: 783, en: "dependence", ko: "의존, 의지", level: 'intermediate'},
  {id: 784, en: "depict", ko: "그리다, 묘사하다", level: 'advanced'},
  {id: 785, en: "deposit", ko: "예금", level: 'advanced'},
  {id: 786, en: "depress", ko: "억압하다", level: 'intermediate'},
  {id: 787, en: "deprive", ko: "빼앗다", level: 'advanced'},
  {id: 788, en: "derive", ko: "이끌어 내다", level: 'intermediate'},
  {id: 789, en: "descend", ko: "내려오다", level: 'intermediate'},
  {id: 790, en: "describe", ko: "기술하다", level: 'intermediate'},
  {id: 791, en: "description", ko: "서술", level: 'intermediate'},
  {id: 792, en: "desert", ko: "사막, 버리다", level: 'intermediate'},
  {id: 793, en: "deserve", ko: " -할 만하다", level: 'intermediate'},
  {id: 794, en: "design", ko: "디자인", level: 'basic'},
  {id: 795, en: "designate", ko: "지정하다, 선정하다", level: 'advanced'},
  {id: 796, en: "desire", ko: "바라다", level: 'intermediate'},
  {id: 797, en: "desk", ko: "책상", level: 'basic'},
  {id: 798, en: "despair", ko: "절망하다", level: 'intermediate'},
  {id: 799, en: "desperate", ko: "절망적인", level: 'intermediate'},
  {id: 800, en: "despite", ko: "-에도 불구하고 모욕", level: 'intermediate'},
  {id: 801, en: "destination", ko: "목적지", level: 'intermediate'},
  {id: 802, en: "destiny", ko: "운명", level: 'intermediate'},
  {id: 803, en: "destroy", ko: "파괴하다", level: 'intermediate'},
  {id: 804, en: "destruction", ko: "파괴", level: 'intermediate'},
  {id: 805, en: "detach", ko: "분리하다", level: 'intermediate'},
  {id: 806, en: "detail", ko: "세부 사항,", level: 'intermediate'},
  {id: 807, en: "detect", ko: "간파하다", level: 'intermediate'},
  {id: 808, en: "determine", ko: "결정하다", level: 'intermediate'},
  {id: 809, en: "develop", ko: "발달하다", level: 'intermediate'},
  {id: 810, en: "device", ko: "장치", level: 'intermediate'},
  {id: 811, en: "devil", ko: "악마", level: 'intermediate'},
  {id: 812, en: "devise", ko: "고안하다", level: 'intermediate'},
  {id: 813, en: "devote", ko: "바치다", level: 'intermediate'},
  {id: 814, en: "diabetes", ko: "당뇨병", level: 'advanced'},
  {id: 815, en: "dialogue", ko: "대화", level: 'basic'},
  {id: 816, en: "diary", ko: "일기", level: 'basic'},
  {id: 817, en: "dictate", ko: "받아쓰게 하다", level: 'advanced'},
  {id: 818, en: "dictionary", ko: "사전", level: 'intermediate'},
  {id: 819, en: "die", ko: "죽다", level: 'basic'},
  {id: 820, en: "different", ko: "다른", level: 'basic'},
  {id: 821, en: "difficult", ko: "곤란한", level: 'basic'},
  {id: 822, en: "dig", ko: "파다", level: 'intermediate'},
  {id: 823, en: "dignity", ko: "위엄", level: 'advanced'},
  {id: 824, en: "dimension", ko: "치수", level: 'advanced'},
  {id: 825, en: "diminish", ko: "감소하다", level: 'intermediate'},
  {id: 826, en: "dine", ko: "저녁식사를 하다", level: 'advanced'},
  {id: 827, en: "dinner", ko: "정찬", level: 'basic'},
  {id: 828, en: "dip", ko: "담그다", level: 'intermediate'},
  {id: 829, en: "diplomat", ko: "외교관", level: 'intermediate'},
  {id: 830, en: "direct", ko: "지도하다", level: 'intermediate'},
  {id: 831, en: "dirty", ko: "더러운", level: 'basic'},
  {id: 832, en: "disabled", ko: "불구가 된", level: 'intermediate'},
  {id: 833, en: "disadvantage", ko: "불리한 점, 약점", level: 'intermediate'},
  {id: 834, en: "disagree", ko: "의견이 다르다, 동의하지 않다", level: 'intermediate'},
  {id: 835, en: "disappear", ko: "안보이게 되다", level: 'intermediate'},
  {id: 836, en: "disappoint", ko: "실망시키다", level: 'intermediate'},
  {id: 837, en: "disaster", ko: "참사, 재난, 재해", level: 'intermediate'},
  {id: 838, en: "discharge", ko: "떠나는 것을 허락하다, 해고하다, 석방하다", level: 'advanced'},
  {id: 839, en: "discipline", ko: "훈련", level: 'intermediate'},
  {id: 840, en: "disclose", ko: "밝히다 드러내다", level: 'intermediate'},
  {id: 841, en: "discount", ko: "할인", level: 'intermediate'},
  {id: 842, en: "discourse", ko: "담론, 담화", level: 'advanced'},
  {id: 843, en: "discover", ko: "발견하다", level: 'intermediate'},
  {id: 844, en: "discriminate", ko: "분별하다", level: 'advanced'},
  {id: 845, en: "discuss", ko: "토론하다", level: 'basic'},
  {id: 846, en: "disease", ko: "병", level: 'intermediate'},
  {id: 847, en: "disgust", ko: "불쾌하게 하다", level: 'intermediate'},
  {id: 848, en: "dish", ko: "접시", level: 'basic'},
  {id: 849, en: "dismiss", ko: "떠나게 하다", level: 'intermediate'},
  {id: 850, en: "disorder", ko: "엉망, 난잡, 장애", level: 'intermediate'},
  {id: 851, en: "displace", ko: "대신하다, 쫓아내다", level: 'advanced'},
  {id: 852, en: "display", ko: "전시하다, 내보이다", level: 'intermediate'},
  {id: 853, en: "dispose", ko: "배치하다", level: 'intermediate'},
  {id: 854, en: "dispute", ko: "논쟁하다", level: 'advanced'},
  {id: 855, en: "disrupt", ko: "분열시키다", level: 'advanced'},
  {id: 856, en: "distant", ko: "먼, 떨어진", level: 'intermediate'},
  {id: 857, en: "distort", ko: "비틀다, 찌그러뜨리다", level: 'advanced'},
  {id: 858, en: "distract", ko: "집중이 안되게 하다, 혼란시키다", level: 'intermediate'},
  {id: 859, en: "distribute", ko: "분배하다", level: 'intermediate'},
  {id: 860, en: "district", ko: "지구, 구역", level: 'intermediate'},
  {id: 861, en: "disturb", ko: "교란하다", level: 'intermediate'},
  {id: 862, en: "dive", ko: "뛰어들다", level: 'intermediate'},
  {id: 863, en: "diverse", ko: "다양한", level: 'intermediate'},
  {id: 864, en: "divide", ko: "나누다", level: 'basic'},
  {id: 865, en: "divine", ko: "신의", level: 'advanced'},
  {id: 866, en: "divorce", ko: "이혼", level: 'intermediate'},
  {id: 867, en: "do", ko: "하다", level: 'basic'},
  {id: 868, en: "doctor", ko: "박사", level: 'basic'},
  {id: 869, en: "document", ko: "서류", level: 'intermediate'},
  {id: 870, en: "dog", ko: "개", level: 'basic'},
  {id: 871, en: "doll", ko: "인형", level: 'basic'},
  {id: 872, en: "dolphin", ko: "돌고래", level: 'basic'},
  {id: 873, en: "domain", ko: "영토", level: 'intermediate'},
  {id: 874, en: "domestic", ko: "가정의", level: 'intermediate'},
  {id: 875, en: "dominant", ko: "우세한", level: 'advanced'},
  {id: 876, en: "donate", ko: "기부하다, 증여하다", level: 'intermediate'},
  {id: 877, en: "door", ko: "문", level: 'basic'},
  {id: 878, en: "dose", ko: "(약의) 복용량, 투약하다", level: 'advanced'},
  {id: 879, en: "dot", ko: "점", level: 'intermediate'},
  {id: 880, en: "double", ko: "2배의", level: 'basic'},
  {id: 881, en: "doubt", ko: "의심", level: 'intermediate'},
  {id: 882, en: "down", ko: "아래로", level: 'basic'},
  {id: 883, en: "dozen", ko: "12개짜리 한 묶음, 다스", level: 'intermediate'},
  {id: 884, en: "draft", ko: "원고, 초안", level: 'advanced'},
  {id: 885, en: "drag", ko: "끌다", level: 'intermediate'},
  {id: 886, en: "drain", ko: "물을 빼내다, 배수하다", level: 'advanced'},
  {id: 887, en: "draw", ko: "그리다, 당기다", level: 'basic'},
  {id: 888, en: "drawer", ko: "서랍", level: 'intermediate'},
  {id: 889, en: "dread", ko: "두려워하다 두려움", level: 'advanced'},
  {id: 890, en: "dream", ko: "꿈", level: 'basic'},
  {id: 891, en: "drink", ko: "마시다", level: 'basic'},
  {id: 892, en: "drive", ko: "운전하다", level: 'basic'},
  {id: 893, en: "drop", ko: "방울", level: 'basic'},
  {id: 894, en: "drown", ko: "물에빠뜨리다", level: 'intermediate'},
  {id: 895, en: "drug", ko: "약물", level: 'intermediate'},
  {id: 896, en: "dry", ko: "마른, 마르다", level: 'basic'},
  {id: 897, en: "dual", ko: "이중의", level: 'advanced'},
  {id: 898, en: "duck", ko: "오리, (머리나 몸을)휙 수그리다", level: 'basic'},
  {id: 899, en: "due", ko: "~로 인한, ~때문에, 만기가 된", level: 'intermediate'},
  {id: 900, en: "dull", ko: "따분한, 재미없는", level: 'intermediate'},
  {id: 901, en: "dump", ko: "버리다", level: 'intermediate'},
  {id: 902, en: "during", ko: "-동안에", level: 'basic'},
  {id: 903, en: "dust", ko: "먼지", level: 'intermediate'},
  {id: 904, en: "duty", ko: "의무", level: 'intermediate'},
  {id: 905, en: "dwell", ko: "거주하다", level: 'intermediate'},
  {id: 906, en: "dynamic", ko: "동적인", level: 'intermediate'},
  {id: 907, en: "each", ko: "각각의", level: 'intermediate'},
  {id: 908, en: "eager", ko: "열심인", level: 'intermediate'},
  {id: 909, en: "ear", ko: "귀", level: 'basic'},
  {id: 910, en: "early", ko: "이른", level: 'basic'},
  {id: 911, en: "earn", ko: "일하여 벌다", level: 'intermediate'},
  {id: 912, en: "earth", ko: "지구", level: 'basic'},
  {id: 913, en: "ease", ko: "안락", level: 'intermediate'},
  {id: 914, en: "east", ko: "동쪽 동쪽의 동쪽으로", level: 'basic'},
  {id: 915, en: "easy", ko: "쉬운", level: 'basic'},
  {id: 916, en: "eat", ko: "먹다", level: 'basic'},
  {id: 917, en: "economy", ko: "절약", level: 'intermediate'},
  {id: 918, en: "edge", ko: "끝머리", level: 'intermediate'},
  {id: 919, en: "edit", ko: "편집하다", level: 'intermediate'},
  {id: 920, en: "educate", ko: "교육하다", level: 'intermediate'},
  {id: 921, en: "effect", ko: "결과", level: 'intermediate'},
  {id: 922, en: "effective", ko: "효과적인", level: 'intermediate'},
  {id: 923, en: "efficient", ko: "능률적인", level: 'intermediate'},
  {id: 924, en: "effort", ko: "노력", level: 'intermediate'},
  {id: 925, en: "egg", ko: "알, 달걀", level: 'basic'},
  {id: 926, en: "either", ko: "어느 하나의", level: 'intermediate'},
  {id: 927, en: "elaborate", ko: "정교한, 공들인", level: 'advanced'},
  {id: 928, en: "elect", ko: "선거하다", level: 'intermediate'},
  {id: 929, en: "electric", ko: "전기의", level: 'intermediate'},
  {id: 930, en: "electronic", ko: "전자(학)의", level: 'intermediate'},
  {id: 931, en: "elegant", ko: "우아한", level: 'intermediate'},
  {id: 932, en: "element", ko: "요소", level: 'intermediate'},
  {id: 933, en: "elementary", ko: "기본의", level: 'basic'},
  {id: 934, en: "elephant", ko: "코끼리", level: 'basic'},
  {id: 935, en: "eliminate", ko: "제거하다", level: 'intermediate'},
  {id: 936, en: "else", ko: "그 밖에", level: 'intermediate'},
  {id: 937, en: "embarrass", ko: "난처하게 하다", level: 'intermediate'},
  {id: 938, en: "embassy", ko: "대사관", level: 'intermediate'},
  {id: 939, en: "embrace", ko: "포옹하다", level: 'advanced'},
  {id: 940, en: "emerge", ko: "나오다, 드러나다", level: 'intermediate'},
  {id: 941, en: "emergency", ko: "비상사태", level: 'intermediate'},
  {id: 942, en: "emit", ko: "(빛·열·가스·소리 등을) 내다[내뿜다]", level: 'advanced'},
  {id: 943, en: "emotion", ko: "감정", level: 'intermediate'},
  {id: 944, en: "emphasis", ko: "강조", level: 'intermediate'},
  {id: 945, en: "empire", ko: "제국", level: 'intermediate'},
  {id: 946, en: "employ", ko: "고용하다", level: 'intermediate'},
  {id: 947, en: "empty", ko: "빈", level: 'intermediate'},
  {id: 948, en: "enclose", ko: "에워싸다", level: 'intermediate'},
  {id: 949, en: "encounter", ko: "조우", level: 'intermediate'},
  {id: 950, en: "encourage", ko: "용기를 돋우다", level: 'intermediate'},
  {id: 951, en: "end", ko: "끝", level: 'basic'},
  {id: 952, en: "endure", ko: "견디다", level: 'intermediate'},
  {id: 953, en: "enemy", ko: "적", level: 'intermediate'},
  {id: 954, en: "enforce", ko: "실시하다", level: 'advanced'},
  {id: 955, en: "engage", ko: "약속하다", level: 'intermediate'},
  {id: 956, en: "engine", ko: "엔진", level: 'basic'},
  {id: 957, en: "engineer", ko: "기사", level: 'basic'},
  {id: 958, en: "enhance", ko: "향상하다", level: 'intermediate'},
  {id: 959, en: "enjoy", ko: "즐기다", level: 'basic'},
  {id: 960, en: "enormous", ko: "거대한", level: 'intermediate'},
  {id: 961, en: "enough", ko: "충분한", level: 'basic'},
  {id: 962, en: "enroll", ko: "명부에 올리다", level: 'advanced'},
  {id: 963, en: "ensure", ko: "-을 책임지다", level: 'intermediate'},
  {id: 964, en: "enter", ko: "들어가다", level: 'basic'},
  {id: 965, en: "enterprise", ko: "기획", level: 'intermediate'},
  {id: 966, en: "entertain", ko: "즐겁게 하다", level: 'intermediate'},
  {id: 967, en: "enthusiastic", ko: "열심인", level: 'intermediate'},
  {id: 968, en: "entire", ko: "전체의", level: 'intermediate'},
  {id: 969, en: "entitle", ko: "자격을 주다", level: 'advanced'},
  {id: 970, en: "entry", ko: "들어감", level: 'intermediate'},
  {id: 971, en: "envelope", ko: "봉투", level: 'intermediate'},
  {id: 972, en: "environment", ko: "환경", level: 'intermediate'},
  {id: 973, en: "envy", ko: "질투", level: 'intermediate'},
  {id: 974, en: "episode", ko: "삽화", level: 'intermediate'},
  {id: 975, en: "equal", ko: "같은", level: 'intermediate'},
  {id: 976, en: "equate", ko: "같게하다", level: 'advanced'},
  {id: 977, en: "equipment", ko: "장비", level: 'intermediate'},
  {id: 978, en: "era", ko: "시대", level: 'intermediate'},
  {id: 979, en: "eraser", ko: "지우개", level: 'basic'},
  {id: 980, en: "erect", ko: "똑바로 선", level: 'advanced'},
  {id: 981, en: "error", ko: "잘못", level: 'basic'},
  {id: 982, en: "escape", ko: "도망하다", level: 'intermediate'},
  {id: 983, en: "escort", ko: "호위하다", level: 'intermediate'},
  {id: 984, en: "especially", ko: "특히", level: 'intermediate'},
  {id: 985, en: "essential", ko: "본질적인", level: 'intermediate'},
  {id: 986, en: "establish", ko: "확립하다", level: 'intermediate'},
  {id: 987, en: "estate", ko: "토지", level: 'advanced'},
  {id: 988, en: "estimate", ko: "어림잡다", level: 'intermediate'},
  {id: 989, en: "etc", ko: "등등", level: 'intermediate'},
  {id: 990, en: "ethical", ko: "도덕상의", level: 'advanced'},
  {id: 991, en: "ethnic", ko: "인종의", level: 'advanced'},
  {id: 992, en: "evacuate", ko: "비우다", level: 'advanced'},
  {id: 993, en: "evaluate", ko: "평가하다", level: 'intermediate'},
  {id: 994, en: "eve", ko: "저녁, 밤", level: 'intermediate'},
  {id: 995, en: "even", ko: "-조차", level: 'intermediate'},
  {id: 996, en: "evening", ko: "저녁", level: 'basic'},
  {id: 997, en: "eventually", ko: "결국", level: 'intermediate'},
  {id: 998, en: "ever", ko: "언제나, 항상", level: 'intermediate'},
  {id: 999, en: "every", ko: "모든", level: 'basic'},
  {id: 1000, en: "evident", ko: "명백한", level: 'intermediate'},
  {id: 1001, en: "evil", ko: "사악한", level: 'intermediate'},
  {id: 1002, en: "evolution", ko: "진화", level: 'intermediate'},
  {id: 1003, en: "evolve", ko: "진화하다", level: 'intermediate'},
  {id: 1004, en: "exact", ko: "정확한", level: 'intermediate'},
  {id: 1005, en: "exaggerate", ko: "과장하다", level: 'intermediate'},
  {id: 1006, en: "exam", ko: "시험", level: 'basic'},
  {id: 1007, en: "examine", ko: "시험하다", level: 'intermediate'},
  {id: 1008, en: "example", ko: "예, 본보기", level: 'basic'},
  {id: 1009, en: "exceed", ko: "넘다", level: 'intermediate'},
  {id: 1010, en: "excellent", ko: "우수한", level: 'intermediate'},
  {id: 1011, en: "except", ko: "-을 제외하고는 제외하다", level: 'intermediate'},
  {id: 1012, en: "excess", ko: "초과", level: 'intermediate'},
  {id: 1013, en: "exchange", ko: "교환하다", level: 'intermediate'},
  {id: 1014, en: "excite", ko: "흥분시키다", level: 'intermediate'},
  {id: 1015, en: "exclude", ko: "배척하다", level: 'intermediate'},
  {id: 1016, en: "exclusive", ko: "배타적인", level: 'advanced'},
  {id: 1017, en: "excuse", ko: "변명", level: 'intermediate'},
  {id: 1018, en: "executive", ko: "집행의", level: 'advanced'},
  {id: 1019, en: "exercise", ko: "운동", level: 'basic'},
  {id: 1020, en: "exhaust", ko: "다 써버리다", level: 'intermediate'},
  {id: 1021, en: "exhibit", ko: "보이다", level: 'intermediate'},
  {id: 1022, en: "exist", ko: "존재하다", level: 'intermediate'},
  {id: 1023, en: "exit", ko: "출구", level: 'basic'},
  {id: 1024, en: "exotic", ko: "외국의, 이국적인", level: 'intermediate'},
  {id: 1025, en: "expand", ko: "펴다", level: 'intermediate'},
  {id: 1026, en: "expect", ko: "기대하다", level: 'intermediate'},
  {id: 1027, en: "expense", ko: "지출", level: 'intermediate'},
  {id: 1028, en: "expensive", ko: "비용이 드는", level: 'intermediate'},
  {id: 1029, en: "experience", ko: "경험", level: 'intermediate'},
  {id: 1030, en: "experiment", ko: "실험", level: 'intermediate'},
  {id: 1031, en: "expert", ko: "숙련가", level: 'intermediate'},
  {id: 1032, en: "expertise", ko: "대가의 의견", level: 'advanced'},
  {id: 1033, en: "explain", ko: "설명하다", level: 'intermediate'},
  {id: 1034, en: "explicit", ko: "명백한", level: 'advanced'},
  {id: 1035, en: "explode", ko: "폭발시키다", level: 'intermediate'},
  {id: 1036, en: "explore", ko: "탐험하다", level: 'intermediate'},
  {id: 1037, en: "export", ko: "수출하다 수출", level: 'intermediate'},
  {id: 1038, en: "expose", ko: "쐬다, 드러내다, 맞히다", level: 'intermediate'},
  {id: 1039, en: "express", ko: "발표하다", level: 'intermediate'},
  {id: 1040, en: "extend", ko: "뻗다", level: 'intermediate'},
  {id: 1041, en: "extent", ko: "넓이", level: 'intermediate'},
  {id: 1042, en: "external", ko: "외부의", level: 'intermediate'},
  {id: 1043, en: "extinct", ko: "꺼진", level: 'intermediate'},
  {id: 1044, en: "extra", ko: "가외의", level: 'intermediate'},
  {id: 1045, en: "extract", ko: "뽑아내다", level: 'advanced'},
  {id: 1046, en: "extraordinary", ko: "이상한", level: 'advanced'},
  {id: 1047, en: "extreme", ko: "극단의", level: 'intermediate'},
  {id: 1048, en: "eye", ko: "눈", level: 'basic'},
  {id: 1049, en: "eyebrow", ko: "눈썹", level: 'intermediate'},
  {id: 1050, en: "fabric", ko: "천", level: 'intermediate'},
  {id: 1051, en: "face", ko: "얼굴", level: 'basic'},
  {id: 1052, en: "facilitate", ko: "쉽게하다", level: 'advanced'},
  {id: 1053, en: "facility", ko: "쉬움", level: 'intermediate'},
  {id: 1054, en: "fact", ko: "사실", level: 'basic'},
  {id: 1055, en: "factor", ko: "요소", level: 'intermediate'},
  {id: 1056, en: "factory", ko: "공장", level: 'basic'},
  {id: 1057, en: "faculty", ko: "능력", level: 'advanced'},
  {id: 1058, en: "fade", ko: "바래다", level: 'intermediate'},
  {id: 1059, en: "fail", ko: "실패하다", level: 'basic'},
  {id: 1060, en: "faint", ko: "기절하다", level: 'intermediate'},
  {id: 1061, en: "fair", ko: "공평한", level: 'intermediate'},
  {id: 1062, en: "faith", ko: "신용", level: 'intermediate'},
  {id: 1063, en: "fall", ko: "떨어지다", level: 'basic'},
  {id: 1064, en: "false", ko: "거짓", level: 'intermediate'},
  {id: 1065, en: "fame", ko: "명성", level: 'intermediate'},
  {id: 1066, en: "familiar", ko: "친한", level: 'intermediate'},
  {id: 1067, en: "family", ko: "가족", level: 'basic'},
  {id: 1068, en: "famous", ko: "유명한", level: 'basic'},
  {id: 1069, en: "fan", ko: "(영화 등의)팬", level: 'basic'},
  {id: 1070, en: "fancy", ko: "공상", level: 'intermediate'},
  {id: 1071, en: "fantastic", ko: "환상적인", level: 'basic'},
  {id: 1072, en: "far", ko: "멀리", level: 'basic'},
  {id: 1073, en: "fare", ko: "요금", level: 'intermediate'},
  {id: 1074, en: "farm", ko: "농장", level: 'basic'},
  {id: 1075, en: "fascinate", ko: "황홀케 하다", level: 'intermediate'},
  {id: 1076, en: "fast", ko: "빠른", level: 'basic'},
  {id: 1077, en: "fasten", ko: "단단히 고정시키다", level: 'intermediate'},
  {id: 1078, en: "fat", ko: "살찐", level: 'basic'},
  {id: 1079, en: "fatal", ko: "치명적인", level: 'advanced'},
  {id: 1080, en: "fate", ko: "숙명", level: 'intermediate'},
  {id: 1081, en: "father", ko: "아버지", level: 'basic'},
  {id: 1082, en: "fault", ko: "결점", level: 'intermediate'},
  {id: 1083, en: "favor", ko: "호의", level: 'intermediate'},
  {id: 1084, en: "favorite", ko: "마음에 드는 좋아하는 물건", level: 'basic'},
  {id: 1085, en: "fear", ko: "두려움", level: 'intermediate'},
  {id: 1086, en: "feature", ko: "얼굴의 생김새", level: 'intermediate'},
  {id: 1087, en: "federal", ko: "연방의", level: 'advanced'},
  {id: 1088, en: "fee", ko: "요금", level: 'intermediate'},
  {id: 1089, en: "feed", ko: "음식(먹이)을 주다", level: 'intermediate'},
  {id: 1090, en: "feel", ko: "만져보다", level: 'basic'},
  {id: 1091, en: "fellow", ko: "동무", level: 'intermediate'},
  {id: 1092, en: "female", ko: "여성", level: 'intermediate'},
  {id: 1093, en: "ferry", ko: "나루터", level: 'intermediate'},
  {id: 1094, en: "fertile", ko: "비옥한", level: 'advanced'},
  {id: 1095, en: "fever", ko: "열", level: 'basic'},
  {id: 1096, en: "few", ko: "소수의", level: 'intermediate'},
  {id: 1097, en: "fiber", ko: "섬유", level: 'intermediate'},
  {id: 1098, en: "field", ko: "들", level: 'basic'},
  {id: 1099, en: "fierce", ko: "흉포한", level: 'intermediate'},
  {id: 1100, en: "fight", ko: "싸움", level: 'basic'},
  {id: 1101, en: "figure", ko: "모습", level: 'intermediate'},
  {id: 1102, en: "file", ko: "종이끼우개", level: 'basic'},
  {id: 1103, en: "fill", ko: "가득 채우다", level: 'basic'},
  {id: 1104, en: "filter", ko: "여과기 여과하다", level: 'intermediate'},
  {id: 1105, en: "final", ko: "최후의", level: 'intermediate'},
  {id: 1106, en: "finance", ko: "재정", level: 'intermediate'},
  {id: 1107, en: "find", ko: "발견하다", level: 'basic'},
  {id: 1108, en: "fine", ko: "훌륭한", level: 'basic'},
  {id: 1109, en: "finger", ko: "손가락 손가락을 대다", level: 'basic'},
  {id: 1110, en: "finish", ko: "끝내다", level: 'basic'},
  {id: 1111, en: "finite", ko: "한정되어 있는", level: 'intermediate'},
  {id: 1112, en: "fire", ko: "불", level: 'basic'},
  {id: 1113, en: "firm", ko: "굳은", level: 'intermediate'},
  {id: 1114, en: "fish", ko: "물고기", level: 'basic'},
  {id: 1115, en: "fist", ko: "주먹", level: 'intermediate'},
  {id: 1116, en: "fit", ko: "맞는", level: 'intermediate'},
  {id: 1117, en: "fix", ko: "고정시키다", level: 'basic'},
  {id: 1118, en: "flag", ko: "기", level: 'basic'},
  {id: 1119, en: "flame", ko: "불꽃", level: 'intermediate'},
  {id: 1120, en: "flash", ko: "번쩍임", level: 'intermediate'},
  {id: 1121, en: "flat", ko: "편평한", level: 'intermediate'},
  {id: 1122, en: "flavor", ko: "(독특한)맛", level: 'intermediate'},
  {id: 1123, en: "flaw", ko: "금", level: 'intermediate'},
  {id: 1124, en: "flee", ko: "달아나다", level: 'advanced'},
  {id: 1125, en: "flesh", ko: "살", level: 'intermediate'},
  {id: 1126, en: "flexible", ko: "구부리기 쉬운", level: 'intermediate'},
  {id: 1127, en: "flight", ko: "날기", level: 'intermediate'},
  {id: 1128, en: "flip", ko: "튀기다 홱 움직이다 튀기기", level: 'advanced'},
  {id: 1129, en: "float", ko: "뜨다", level: 'intermediate'},
  {id: 1130, en: "flock", ko: "무리", level: 'intermediate'},
  {id: 1131, en: "flood", ko: "홍수", level: 'intermediate'},
  {id: 1132, en: "floor", ko: "마룻바닥", level: 'basic'},
  {id: 1133, en: "flourish", ko: "번창하다", level: 'intermediate'},
  {id: 1134, en: "flow", ko: "흐르다", level: 'intermediate'},
  {id: 1135, en: "flower", ko: "꽃", level: 'basic'},
  {id: 1136, en: "fluid", ko: "유동성의", level: 'advanced'},
  {id: 1137, en: "flush", ko: "왈칵흐르다", level: 'advanced'},
  {id: 1138, en: "fly", ko: "날다", level: 'basic'},
  {id: 1139, en: "focus", ko: "초점", level: 'basic'},
  {id: 1140, en: "fog", ko: "안개", level: 'basic'},
  {id: 1141, en: "fold", ko: "주름", level: 'intermediate'},
  {id: 1142, en: "folk", ko: "사람들", level: 'intermediate'},
  {id: 1143, en: "follow", ko: "쫓다", level: 'intermediate'},
  {id: 1144, en: "fond", ko: "좋아하는", level: 'advanced'},
  {id: 1145, en: "food", ko: "음식", level: 'basic'},
  {id: 1146, en: "fool", ko: "바보", level: 'basic'},
  {id: 1147, en: "foot", ko: "발", level: 'basic'},
  {id: 1148, en: "football", ko: "축구", level: 'basic'},
  {id: 1149, en: "for", ko: "대신에", level: 'basic'},
  {id: 1150, en: "forbid", ko: "금하다", level: 'intermediate'},
  {id: 1151, en: "force", ko: "힘", level: 'intermediate'},
  {id: 1152, en: "forecast", ko: "예상", level: 'intermediate'},
  {id: 1153, en: "forehead", ko: "이마", level: 'intermediate'},
  {id: 1154, en: "foreign", ko: "외국의", level: 'intermediate'},
  {id: 1155, en: "forest", ko: "숲", level: 'basic'},
  {id: 1156, en: "forever", ko: "영원히", level: 'basic'},
  {id: 1157, en: "forget", ko: "잊다", level: 'basic'},
  {id: 1158, en: "forgive", ko: "용서하다", level: 'intermediate'},
  {id: 1159, en: "form", ko: "모양", level: 'basic'},
  {id: 1160, en: "formal", ko: "형식상의", level: 'intermediate'},
  {id: 1161, en: "format", ko: "(서적의)체제", level: 'intermediate'},
  {id: 1162, en: "formation", ko: "형성", level: 'intermediate'},
  {id: 1163, en: "former", ko: "이전의", level: 'intermediate'},
  {id: 1164, en: "formula", ko: "공식", level: 'advanced'},
  {id: 1165, en: "forth", ko: "앞으로", level: 'intermediate'},
  {id: 1166, en: "fortunate", ko: "운좋은", level: 'intermediate'},
  {id: 1167, en: "fortune", ko: "운", level: 'intermediate'},
  {id: 1168, en: "forum", ko: "공개토론회", level: 'intermediate'},
  {id: 1169, en: "forward", ko: "앞쪽에", level: 'intermediate'},
  {id: 1170, en: "foster", ko: "기르다", level: 'advanced'},
  {id: 1171, en: "foundation", ko: "기초", level: 'intermediate'},
  {id: 1172, en: "fountain", ko: "샘", level: 'intermediate'},
  {id: 1173, en: "fox", ko: "교활한 사람", level: 'basic'},
  {id: 1174, en: "fraction", ko: "분수", level: 'advanced'},
  {id: 1175, en: "frame", ko: "구조", level: 'intermediate'},
  {id: 1176, en: "framework", ko: "뼈대", level: 'intermediate'},
  {id: 1177, en: "frankly", ko: "솔직히", level: 'intermediate'},
  {id: 1178, en: "free", ko: "자유로운", level: 'basic'},
  {id: 1179, en: "freeze", ko: "얼다", level: 'intermediate'},
  {id: 1180, en: "frequent", ko: "빈번한", level: 'intermediate'},
  {id: 1181, en: "fresh", ko: "새로운", level: 'basic'},
  {id: 1182, en: "friend", ko: "친구", level: 'basic'},
  {id: 1183, en: "fright", ko: "(갑자기 엄습하는)공포", level: 'intermediate'},
  {id: 1184, en: "frog", ko: "개구리", level: 'basic'},
  {id: 1185, en: "from", ko: "(분리,이탈,출발점,기점)-로 부터", level: 'basic'},
  {id: 1186, en: "front", ko: "정면", level: 'basic'},
  {id: 1187, en: "frost", ko: "서리", level: 'advanced'},
  {id: 1188, en: "frown", ko: "눈살을 찌푸리다", level: 'intermediate'},
  {id: 1189, en: "fruit", ko: "과일", level: 'basic'},
  {id: 1190, en: "frustrate", ko: "(계획 등을)좌절시키다", level: 'intermediate'},
  {id: 1191, en: "fry", ko: "기름으로 튀기다", level: 'basic'},
  {id: 1192, en: "fuel", ko: "연료", level: 'intermediate'},
  {id: 1193, en: "fulfil", ko: "이행하다", level: 'intermediate'},
  {id: 1194, en: "full", ko: "가득찬", level: 'basic'},
  {id: 1195, en: "fun", ko: "즐거운 생각", level: 'basic'},
  {id: 1196, en: "function", ko: "기능", level: 'intermediate'},
  {id: 1197, en: "fund", ko: "기금", level: 'intermediate'},
  {id: 1198, en: "fundamental", ko: "기초(기준)의", level: 'intermediate'},
  {id: 1199, en: "funeral", ko: "장사", level: 'intermediate'},
  {id: 1200, en: "fur", ko: "모피", level: 'intermediate'},
  {id: 1201, en: "furious", ko: "노하여 펄펄뛰는", level: 'advanced'},
  {id: 1202, en: "furnish", ko: "공급하다", level: 'advanced'},
  {id: 1203, en: "furniture", ko: "가구", level: 'intermediate'},
  {id: 1204, en: "furthermore", ko: "더우기", level: 'intermediate'},
  {id: 1205, en: "fuse", ko: "신관", level: 'advanced'},
  {id: 1206, en: "future", ko: "미래", level: 'basic'},
  {id: 1207, en: "gain", ko: "얻다", level: 'intermediate'},
  {id: 1208, en: "gamble", ko: "도박하다 도박 도박해서 잃다", level: 'intermediate'},
  {id: 1209, en: "gang", ko: "한 떼", level: 'intermediate'},
  {id: 1210, en: "gap", ko: "갈라진 틈", level: 'intermediate'},
  {id: 1211, en: "garage", ko: "차고", level: 'intermediate'},
  {id: 1212, en: "garden", ko: "뜰", level: 'basic'},
  {id: 1213, en: "gasoline", ko: "가솔린", level: 'advanced'},
  {id: 1214, en: "gate", ko: "문", level: 'basic'},
  {id: 1215, en: "gather", ko: "그러모으다", level: 'intermediate'},
  {id: 1216, en: "gaze", ko: "지켜보다", level: 'advanced'},
  {id: 1217, en: "gear", ko: "톱니바퀴", level: 'intermediate'},
  {id: 1218, en: "gender", ko: "성", level: 'intermediate'},
  {id: 1219, en: "gene", ko: "유전(인)자", level: 'intermediate'},
  {id: 1220, en: "general", ko: "일반적인", level: 'intermediate'},
  {id: 1221, en: "generate", ko: "낳다", level: 'advanced'},
  {id: 1222, en: "generation", ko: "일대", level: 'intermediate'},
  {id: 1223, en: "generous", ko: "광대한", level: 'intermediate'},
  {id: 1224, en: "genius", ko: "천재", level: 'intermediate'},
  {id: 1225, en: "genre", ko: "유형", level: 'intermediate'},
  {id: 1226, en: "gentle", ko: "온화한", level: 'intermediate'},
  {id: 1227, en: "gentleman", ko: "신사", level: 'basic'},
  {id: 1228, en: "genuine", ko: "진짜의", level: 'intermediate'},
  {id: 1229, en: "geography", ko: "지리", level: 'intermediate'},
  {id: 1230, en: "geology", ko: "지질학", level: 'intermediate'},
  {id: 1231, en: "gesture", ko: "몸짓", level: 'basic'},
  {id: 1232, en: "get", ko: "얻다", level: 'basic'},
  {id: 1233, en: "ghost", ko: "유령", level: 'basic'},
  {id: 1234, en: "giant", ko: "거인", level: 'basic'},
  {id: 1235, en: "gift", ko: "선물", level: 'basic'},
  {id: 1236, en: "giraffe", ko: "기린", level: 'basic'},
  {id: 1237, en: "girl", ko: "소녀", level: 'basic'},
  {id: 1238, en: "give", ko: "주다", level: 'basic'},
  {id: 1239, en: "glad", ko: "기쁜", level: 'basic'},
  {id: 1240, en: "glance", ko: "흘긋 봄", level: 'intermediate'},
  {id: 1241, en: "glare", ko: "번쩍이는 빛", level: 'advanced'},
  {id: 1242, en: "glass", ko: "유리", level: 'basic'},
  {id: 1243, en: "glimpse", ko: "흘끗 봄", level: 'advanced'},
  {id: 1244, en: "global", ko: "공모양의", level: 'intermediate'},
  {id: 1245, en: "glory", ko: "영광", level: 'intermediate'},
  {id: 1246, en: "glove", ko: "장갑", level: 'basic'},
  {id: 1247, en: "glow", ko: "타다", level: 'intermediate'},
  {id: 1248, en: "glue", ko: "아교", level: 'basic'},
  {id: 1249, en: "go", ko: "가다", level: 'basic'},
  {id: 1250, en: "goal", ko: "결승점", level: 'basic'},
  {id: 1251, en: "goat", ko: "염소", level: 'intermediate'},
  {id: 1252, en: "god", ko: "신", level: 'basic'},
  {id: 1253, en: "gold", ko: "금", level: 'basic'},
  {id: 1254, en: "good", ko: "좋은", level: 'basic'},
  {id: 1255, en: "goodbye", ko: "안녕히 가세요", level: 'basic'},
  {id: 1256, en: "goods", ko: "상품", level: 'intermediate'},
  {id: 1257, en: "gorgeous", ko: "호화로운", level: 'intermediate'},
  {id: 1258, en: "govern", ko: "다스리다", level: 'intermediate'},
  {id: 1259, en: "grab", ko: "붙잡다(=snatch)", level: 'intermediate'},
  {id: 1260, en: "grace", ko: "은총", level: 'intermediate'},
  {id: 1261, en: "grade", ko: "품질, 등급", level: 'intermediate'},
  {id: 1262, en: "gradual", ko: "점차적인", level: 'intermediate'},
  {id: 1263, en: "graduate", ko: "학위를 수여하다", level: 'intermediate'},
  {id: 1264, en: "grain", ko: "곡물", level: 'intermediate'},
  {id: 1265, en: "grand", ko: "위대한", level: 'intermediate'},
  {id: 1266, en: "grandfather", ko: "할아버지", level: 'basic'},
  {id: 1267, en: "grant", ko: "받아들이다", level: 'intermediate'},
  {id: 1268, en: "grape", ko: "포도", level: 'basic'},
  {id: 1269, en: "graphic", ko: "그려 놓은 듯한", level: 'intermediate'},
  {id: 1270, en: "grasp", ko: "붙잡다", level: 'advanced'},
  {id: 1271, en: "grass", ko: "풀밭", level: 'basic'},
  {id: 1272, en: "grateful", ko: "고맙게 생각하는", level: 'intermediate'},
  {id: 1273, en: "grave", ko: "무덤", level: 'intermediate'},
  {id: 1274, en: "great", ko: "커다란", level: 'basic'},
  {id: 1275, en: "greed", ko: "탐욕", level: 'intermediate'},
  {id: 1276, en: "green", ko: "초록색", level: 'basic'},
  {id: 1277, en: "greet", ko: "인사하다", level: 'intermediate'},
  {id: 1278, en: "grey", ko: "회색의", level: 'basic'},
  {id: 1279, en: "grief", ko: "심한 슬픔(deep sorrow)", level: 'intermediate'},
  {id: 1280, en: "grip", ko: "잡기", level: 'intermediate'},
  {id: 1281, en: "grocery", ko: "식품잡화류", level: 'intermediate'},
  {id: 1282, en: "gross", ko: "총계의", level: 'advanced'},
  {id: 1283, en: "ground", ko: "땅", level: 'basic'},
  {id: 1284, en: "group", ko: "집단", level: 'basic'},
  {id: 1285, en: "grow", ko: "성장하다", level: 'basic'},
  {id: 1286, en: "guarantee", ko: "보증하다", level: 'intermediate'},
  {id: 1287, en: "guardian", ko: "보호자", level: 'advanced'},
  {id: 1288, en: "guess", ko: "추측(짐작)하다", level: 'basic'},
  {id: 1289, en: "guest", ko: "손님", level: 'intermediate'},
  {id: 1290, en: "guide", ko: "이끌다", level: 'basic'},
  {id: 1291, en: "guideline", ko: "지침", level: 'intermediate'},
  {id: 1292, en: "guilty", ko: "죄지은", level: 'intermediate'},
  {id: 1293, en: "gulf", ko: "만", level: 'advanced'},
  {id: 1294, en: "gun", ko: "총", level: 'intermediate'},
  {id: 1295, en: "guy", ko: "녀석", level: 'basic'},
  {id: 1296, en: "gymnasium", ko: "실내체조장", level: 'intermediate'},
  {id: 1297, en: "habit", ko: "습관", level: 'basic'},
  {id: 1298, en: "habitat", ko: "(동물의)자연번식지", level: 'advanced'},
  {id: 1299, en: "hair", ko: "털", level: 'basic'},
  {id: 1300, en: "half", ko: "반", level: 'intermediate'},
  {id: 1301, en: "hall", ko: "회관", level: 'intermediate'},
  {id: 1302, en: "halt", ko: "멈춰서다", level: 'advanced'},
  {id: 1303, en: "hammer", ko: "망치", level: 'intermediate'},
  {id: 1304, en: "hand", ko: "손", level: 'basic'},
  {id: 1305, en: "handicap", ko: "불리한 조건", level: 'intermediate'},
  {id: 1306, en: "handle", ko: "손잡이", level: 'intermediate'},
  {id: 1307, en: "handsome", ko: "얼굴(자태)이 잘생긴", level: 'basic'},
  {id: 1308, en: "hang", ko: "걸다", level: 'basic'},
  {id: 1309, en: "happen", ko: "(사건 등이)일어나다", level: 'intermediate'},
  {id: 1310, en: "happy", ko: "행운의", level: 'basic'},
  {id: 1311, en: "harbor", ko: "항구", level: 'intermediate'},
  {id: 1312, en: "hard", ko: "단단한", level: 'basic'},
  {id: 1313, en: "hardly", ko: "거의 -아니다", level: 'intermediate'},
  {id: 1314, en: "harm", ko: "해", level: 'intermediate'},
  {id: 1315, en: "harsh", ko: "거친", level: 'intermediate'},
  {id: 1316, en: "harvest", ko: "수확", level: 'intermediate'},
  {id: 1317, en: "haste", ko: "급함", level: 'intermediate'},
  {id: 1318, en: "hat", ko: "(테있는)모자 모자를 씌우다", level: 'basic'},
  {id: 1319, en: "hate", ko: "미워하다", level: 'basic'},
  {id: 1320, en: "haunt", ko: "자주가다", level: 'advanced'},
  {id: 1321, en: "have", ko: "가지(고 있)다", level: 'basic'},
  {id: 1322, en: "hazard", ko: "위험", level: 'intermediate'},
  {id: 1323, en: "he", ko: "(3인칭단수 남성)그", level: 'basic'},
  {id: 1324, en: "head", ko: "머리", level: 'basic'},
  {id: 1325, en: "headache", ko: "두통", level: 'basic'},
  {id: 1326, en: "headquarters", ko: "본부", level: 'advanced'},
  {id: 1327, en: "heal", ko: "고치다", level: 'intermediate'},
  {id: 1328, en: "health", ko: "건강", level: 'intermediate'},
  {id: 1329, en: "hear", ko: "듣다", level: 'intermediate'},
  {id: 1330, en: "heart", ko: "심장", level: 'basic'},
  {id: 1331, en: "heat", ko: "열", level: 'basic'},
  {id: 1332, en: "heaven", ko: "하늘", level: 'basic'},
  {id: 1333, en: "heavy", ko: "무거운", level: 'basic'},
  {id: 1334, en: "heel", ko: "발뒤꿈치", level: 'intermediate'},
  {id: 1335, en: "height", ko: "높이", level: 'intermediate'},
  {id: 1336, en: "heir", ko: "상속인", level: 'advanced'},
  {id: 1337, en: "helicopter", ko: "헬리콥터", level: 'basic'},
  {id: 1338, en: "hell", ko: "지옥", level: 'intermediate'},
  {id: 1339, en: "hello", ko: "여보", level: 'basic'},
  {id: 1340, en: "help", ko: "돕다", level: 'basic'},
  {id: 1341, en: "hence", ko: "그러므로", level: 'advanced'},
  {id: 1342, en: "here", ko: "여기에", level: 'basic'},
  {id: 1343, en: "heritage", ko: "세습 재산", level: 'advanced'},
  {id: 1344, en: "hero", ko: "영웅", level: 'basic'},
  {id: 1345, en: "hesitate", ko: "주저하다", level: 'intermediate'},
  {id: 1346, en: "hide", ko: "감추다", level: 'intermediate'},
  {id: 1347, en: "high", ko: "높은", level: 'basic'},
  {id: 1348, en: "highway", ko: "대도", level: 'intermediate'},
  {id: 1349, en: "hill", ko: "언덕, 낮은 산 인도 고지", level: 'basic'},
  {id: 1350, en: "hip", ko: "엉덩이", level: 'intermediate'},
  {id: 1351, en: "hire", ko: "고용하다", level: 'intermediate'},
  {id: 1352, en: "history", ko: "역사", level: 'basic'},
  {id: 1353, en: "hit", ko: "명중하다", level: 'basic'},
  {id: 1354, en: "hobby", ko: "취미", level: 'basic'},
  {id: 1355, en: "hold", ko: "손에 갖고 있다", level: 'basic'},
  {id: 1356, en: "hole", ko: "구멍", level: 'intermediate'},
  {id: 1357, en: "holiday", ko: "휴일", level: 'basic'},
  {id: 1358, en: "holy", ko: "신성한", level: 'intermediate'},
  {id: 1359, en: "home", ko: "가정", level: 'basic'},
  {id: 1360, en: "homework", ko: "숙제", level: 'basic'},
  {id: 1361, en: "honest", ko: "정직한", level: 'basic'},
  {id: 1362, en: "honey", ko: "벌꿀", level: 'basic'},
  {id: 1363, en: "honor", ko: "명예", level: 'intermediate'},
  {id: 1364, en: "hook", ko: "갈고리", level: 'advanced'},
  {id: 1365, en: "hope", ko: "희망", level: 'basic'},
  {id: 1366, en: "horizon", ko: "지평선", level: 'intermediate'},
  {id: 1367, en: "horn", ko: "뿔", level: 'advanced'},
  {id: 1368, en: "horror", ko: "공포", level: 'intermediate'},
  {id: 1369, en: "horse", ko: "말", level: 'basic'},
  {id: 1370, en: "hospital", ko: "병원", level: 'basic'},
  {id: 1371, en: "host", ko: "주인, 집주인 노릇, 호스트", level: 'intermediate'},
  {id: 1372, en: "hostage", ko: "볼모", level: 'advanced'},
  {id: 1373, en: "hostile", ko: "반대하는", level: 'advanced'},
  {id: 1374, en: "hot", ko: "뜨거운", level: 'basic'},
  {id: 1375, en: "hour", ko: "시간", level: 'basic'},
  {id: 1376, en: "house", ko: "집", level: 'basic'},
  {id: 1377, en: "household", ko: "가족", level: 'intermediate'},
  {id: 1378, en: "how", ko: "어떻게", level: 'basic'},
  {id: 1379, en: "however", ko: "아무리", level: 'basic'},
  {id: 1380, en: "hug", ko: "꼭 껴안다", level: 'intermediate'},
  {id: 1381, en: "huge", ko: "거대한", level: 'intermediate'},
  {id: 1382, en: "human", ko: "인간의", level: 'basic'},
  {id: 1383, en: "humor", ko: "유머", level: 'basic'},
  {id: 1384, en: "hundred", ko: "100 100의", level: 'basic'},
  {id: 1385, en: "hungry", ko: "배고픈", level: 'basic'},
  {id: 1386, en: "hunt", ko: "사냥하다", level: 'basic'},
  {id: 1387, en: "hurry", ko: "서두르다", level: 'basic'},
  {id: 1388, en: "hurt", ko: "상처내다", level: 'intermediate'},
  {id: 1389, en: "husband", ko: "남편 절약하다", level: 'basic'},
  {id: 1390, en: "hut", ko: "오두막", level: 'intermediate'},
  {id: 1391, en: "hypothesis", ko: "가설", level: 'advanced'},
  {id: 1392, en: "I", ko: "나는, 내가", level: 'basic'},
  {id: 1393, en: "ice", ko: "얼음", level: 'basic'},
  {id: 1394, en: "idea", ko: "관념", level: 'basic'},
  {id: 1395, en: "ideal", ko: "이상", level: 'intermediate'},
  {id: 1396, en: "identical", ko: "아주 동일한", level: 'intermediate'},
  {id: 1397, en: "identify", ko: "동일시하다", level: 'intermediate'},
  {id: 1398, en: "ideology", ko: "공리", level: 'advanced'},
  {id: 1399, en: "if", ko: "만일 -이라면", level: 'basic'},
  {id: 1400, en: "ignore", ko: "무시하다", level: 'intermediate'},
  {id: 1401, en: "ill", ko: "병든", level: 'intermediate'},
  {id: 1402, en: "illusion", ko: "환영", level: 'advanced'},
  {id: 1403, en: "illustrate", ko: "설명하다", level: 'intermediate'},
  {id: 1404, en: "imagine", ko: "상상하다", level: 'intermediate'},
  {id: 1405, en: "imitate", ko: "흉내내다", level: 'intermediate'},
  {id: 1406, en: "immediate", ko: "직접의", level: 'intermediate'},
  {id: 1407, en: "immense", ko: "무한한", level: 'advanced'},
  {id: 1408, en: "immigrate", ko: "이주하다", level: 'advanced'},
  {id: 1409, en: "immune", ko: "면역성의", level: 'intermediate'},
  {id: 1410, en: "impact", ko: "충격", level: 'intermediate'},
  {id: 1411, en: "imperial", ko: "제국의", level: 'intermediate'},
  {id: 1412, en: "implement", ko: "기구", level: 'advanced'},
  {id: 1413, en: "imply", ko: "함축하다", level: 'advanced'},
  {id: 1414, en: "import", ko: "수입하다", level: 'intermediate'},
  {id: 1415, en: "important", ko: "중요한", level: 'basic'},
  {id: 1416, en: "impose", ko: "부과하다", level: 'advanced'},
  {id: 1417, en: "impress", ko: "인상지우다", level: 'intermediate'},
  {id: 1418, en: "improve", ko: "개선하다", level: 'intermediate'},
  {id: 1419, en: "in", ko: "-안[속]에", level: 'basic'},
  {id: 1420, en: "incentive", ko: "장려[우대]책", level: 'intermediate'},
  {id: 1421, en: "incident", ko: "사건", level: 'intermediate'},
  {id: 1422, en: "incline", ko: "기울이다", level: 'advanced'},
  {id: 1423, en: "include", ko: "포함하다", level: 'intermediate'},
  {id: 1424, en: "income", ko: "수입", level: 'intermediate'},
  {id: 1425, en: "incorporate", ko: "합동시키다", level: 'advanced'},
  {id: 1426, en: "increase", ko: "늘다", level: 'intermediate'},
  {id: 1427, en: "incredible", ko: "믿을 수 없는", level: 'intermediate'},
  {id: 1428, en: "indeed", ko: "정말[확실히], 사실", level: 'intermediate'},
  {id: 1429, en: "independent", ko: "독립한", level: 'intermediate'},
  {id: 1430, en: "index", ko: "색인", level: 'advanced'},
  {id: 1431, en: "indicate", ko: "지적하다", level: 'intermediate'},
  {id: 1432, en: "individual", ko: "개인", level: 'intermediate'},
  {id: 1433, en: "induce", ko: "설득하다, 유도하다, 유발하다", level: 'advanced'},
  {id: 1434, en: "industry", ko: "공업", level: 'intermediate'},
  {id: 1435, en: "inevitable", ko: "피할 수 없는", level: 'advanced'},
  {id: 1436, en: "infant", ko: "유아", level: 'intermediate'},
  {id: 1437, en: "infect", ko: "감염시키다", level: 'advanced'},
  {id: 1438, en: "infer", ko: "추론하다", level: 'advanced'},
  {id: 1439, en: "inflate", ko: "부풀게 하다", level: 'advanced'},
  {id: 1440, en: "influence", ko: "영향력", level: 'intermediate'},
  {id: 1441, en: "inform", ko: "알리다", level: 'intermediate'},
  {id: 1442, en: "informal", ko: "비공식의", level: 'intermediate'},
  {id: 1443, en: "ingredient", ko: "성분", level: 'intermediate'},
  {id: 1444, en: "inhabit", ko: "살다", level: 'intermediate'},
  {id: 1445, en: "inherent", ko: "생태의", level: 'advanced'},
  {id: 1446, en: "inhibit", ko: "금하다", level: 'advanced'},
  {id: 1447, en: "initial", ko: "처음의", level: 'intermediate'},
  {id: 1448, en: "initiate", ko: "시작하다", level: 'intermediate'},
  {id: 1449, en: "inject", ko: "주사하다", level: 'intermediate'},
  {id: 1450, en: "injure", ko: "해치다", level: 'intermediate'},
  {id: 1451, en: "inn", ko: "주막, 여관", level: 'intermediate'},
  {id: 1452, en: "innocent", ko: "아무 잘못이 없는, 결백한, 무고한", level: 'intermediate'},
  {id: 1453, en: "innovate", ko: "혁신하다, 새롭게 하다", level: 'intermediate'},
  {id: 1454, en: "input", ko: "투입, 입력", level: 'intermediate'},
  {id: 1455, en: "inquire", ko: "묻다", level: 'advanced'},
  {id: 1456, en: "insect", ko: "곤충", level: 'intermediate'},
  {id: 1457, en: "insert", ko: "끼워넣다", level: 'intermediate'},
  {id: 1458, en: "inside", ko: "안쪽", level: 'basic'},
  {id: 1459, en: "insight", ko: "통찰(력)", level: 'intermediate'},
  {id: 1460, en: "insist", ko: "주장하다", level: 'intermediate'},
  {id: 1461, en: "inspect", ko: "검사하다", level: 'intermediate'},
  {id: 1462, en: "inspire", ko: "영감을 주다", level: 'intermediate'},
  {id: 1463, en: "install", ko: "설치하다", level: 'intermediate'},
  {id: 1464, en: "instance", ko: "사례, 경우, ...을 예로 들다", level: 'intermediate'},
  {id: 1465, en: "instant", ko: "즉시의", level: 'intermediate'},
  {id: 1466, en: "instead", ko: "그 대신에", level: 'intermediate'},
  {id: 1467, en: "instinct", ko: "본능", level: 'intermediate'},
  {id: 1468, en: "institute", ko: "만들다", level: 'intermediate'},
  {id: 1469, en: "instruct", ko: "가르치다", level: 'intermediate'},
  {id: 1470, en: "instrument", ko: "기구", level: 'intermediate'},
  {id: 1471, en: "insult", ko: "모욕하다", level: 'intermediate'},
  {id: 1472, en: "insure", ko: "보증하다", level: 'intermediate'},
  {id: 1473, en: "integrate", ko: "통합하다", level: 'advanced'},
  {id: 1474, en: "intellectual", ko: "지적인", level: 'intermediate'},
  {id: 1475, en: "intelligent", ko: "지적인", level: 'intermediate'},
  {id: 1476, en: "intend", ko: "-할 작정이다", level: 'intermediate'},
  {id: 1477, en: "intense", ko: "강렬한", level: 'intermediate'},
  {id: 1478, en: "intent", ko: "의향", level: 'intermediate'},
  {id: 1479, en: "interact", ko: "서로 작용하다", level: 'intermediate'},
  {id: 1480, en: "interest", ko: "흥미", level: 'intermediate'},
  {id: 1481, en: "interfere", ko: "간섭하다", level: 'intermediate'},
  {id: 1482, en: "intermediate", ko: "중간의 중간물", level: 'intermediate'},
  {id: 1483, en: "internal", ko: "내부의", level: 'intermediate'},
  {id: 1484, en: "international", ko: "국제적인", level: 'intermediate'},
  {id: 1485, en: "interpret", ko: "해석하다", level: 'intermediate'},
  {id: 1486, en: "interrupt", ko: "훼방놓다", level: 'intermediate'},
  {id: 1487, en: "interval", ko: "간격", level: 'intermediate'},
  {id: 1488, en: "intervene", ko: "사이에 들다", level: 'advanced'},
  {id: 1489, en: "intimate", ko: "친밀한", level: 'intermediate'},
  {id: 1490, en: "into", ko: "-안으로", level: 'basic'},
  {id: 1491, en: "intrigue", ko: "음모", level: 'advanced'},
  {id: 1492, en: "introduce", ko: "안으로 들이다", level: 'basic'},
  {id: 1493, en: "invade", ko: "침입하다", level: 'intermediate'},
  {id: 1494, en: "invent", ko: "발명하다", level: 'intermediate'},
  {id: 1495, en: "invest", ko: "투자하다", level: 'intermediate'},
  {id: 1496, en: "investigate", ko: "조사하다", level: 'intermediate'},
  {id: 1497, en: "invite", ko: "초대하다", level: 'basic'},
  {id: 1498, en: "involve", ko: "말아넣다", level: 'intermediate'},
  {id: 1499, en: "iron", ko: "쇠", level: 'intermediate'},
  {id: 1500, en: "irony", ko: "반어", level: 'intermediate'},
  {id: 1501, en: "irritate", ko: "노하게 하다", level: 'intermediate'},
  {id: 1502, en: "island", ko: "섬", level: 'intermediate'},
  {id: 1503, en: "isolate", ko: "고립시키다", level: 'intermediate'},
  {id: 1504, en: "it", ko: "그것은", level: 'basic'},
  {id: 1505, en: "item", ko: "조항", level: 'intermediate'},
  {id: 1506, en: "jail", ko: "교도소", level: 'intermediate'},
  {id: 1507, en: "jar", ko: "(아가리가 넓은)항아리", level: 'intermediate'},
  {id: 1508, en: "jaw", ko: "턱", level: 'intermediate'},
  {id: 1509, en: "jeans", ko: "청바지", level: 'basic'},
  {id: 1510, en: "jet", ko: "(가스등의)분출", level: 'intermediate'},
  {id: 1511, en: "job", ko: "일", level: 'basic'},
  {id: 1512, en: "jog", ko: "살짝 밀다 덜커덕 움직이다 고르지 않음", level: 'intermediate'},
  {id: 1513, en: "join", ko: "결합하다", level: 'basic'},
  {id: 1514, en: "joint", ko: "공동의, 관절, 연결 부위", level: 'intermediate'},
  {id: 1515, en: "joke", ko: "농담", level: 'intermediate'},
  {id: 1516, en: "journal", ko: "일간신문", level: 'intermediate'},
  {id: 1517, en: "journey", ko: "여행", level: 'intermediate'},
  {id: 1518, en: "joy", ko: "즐거움", level: 'basic'},
  {id: 1519, en: "judge", ko: "재판관", level: 'intermediate'},
  {id: 1520, en: "judicial", ko: "사법의", level: 'advanced'},
  {id: 1521, en: "junior", ko: "하급의, 주니어의", level: 'intermediate'},
  {id: 1522, en: "jury", ko: "배심원단", level: 'intermediate'},
  {id: 1523, en: "just", ko: "(정확히라는 뜻의)딱, 공정한, 올바른", level: 'basic'},
  {id: 1524, en: "justice", ko: "정의", level: 'intermediate'},
  {id: 1525, en: "justify", ko: "옳다고 하다", level: 'intermediate'},
  {id: 1526, en: "keen", ko: "...을 열망하는, 날카로운", level: 'advanced'},
  {id: 1527, en: "keep", ko: "계속하다", level: 'basic'},
  {id: 1528, en: "key", ko: "열쇠", level: 'basic'},
  {id: 1529, en: "kick", ko: "걷어차다", level: 'basic'},
  {id: 1530, en: "kid", ko: "아이", level: 'basic'},
  {id: 1531, en: "kill", ko: "죽이다", level: 'basic'},
  {id: 1532, en: "kind", ko: "친절한", level: 'basic'},
  {id: 1533, en: "king", ko: "왕", level: 'basic'},
  {id: 1534, en: "kit", ko: "조립용품 세트", level: 'intermediate'},
  {id: 1535, en: "kitchen", ko: "부엌", level: 'basic'},
  {id: 1536, en: "knee", ko: "무릎", level: 'intermediate'},
  {id: 1537, en: "knife", ko: "나이프", level: 'basic'},
  {id: 1538, en: "knight", ko: "(중세의)기사", level: 'intermediate'},
  {id: 1539, en: "knock", ko: "치다", level: 'intermediate'},
  {id: 1540, en: "knot", ko: "매듭(=tie)", level: 'advanced'},
  {id: 1541, en: "know", ko: "알다", level: 'basic'},
  {id: 1542, en: "label", ko: "라벨", level: 'intermediate'},
  {id: 1543, en: "labor", ko: "노동", level: 'intermediate'},
  {id: 1544, en: "laboratory", ko: "실험실", level: 'intermediate'},
  {id: 1545, en: "lack", ko: "결핍", level: 'intermediate'},
  {id: 1546, en: "ladder", ko: "사다리", level: 'intermediate'},
  {id: 1547, en: "lady", ko: "귀부인", level: 'basic'},
  {id: 1548, en: "lake", ko: "호수", level: 'basic'},
  {id: 1549, en: "lamb", ko: "어린 양", level: 'intermediate'},
  {id: 1550, en: "lamp", ko: "램프, 등", level: 'intermediate'},
  {id: 1551, en: "land", ko: "육지, 뭍, 땅", level: 'basic'},
  {id: 1552, en: "landscape", ko: "풍경", level: 'intermediate'},
  {id: 1553, en: "lane", ko: "좁은길, 도로, 길, 차선", level: 'intermediate'},
  {id: 1554, en: "language", ko: "언어", level: 'intermediate'},
  {id: 1555, en: "lap", ko: "무릎", level: 'intermediate'},
  {id: 1556, en: "large", ko: "큰", level: 'basic'},
  {id: 1557, en: "last", ko: "계속하다", level: 'basic'},
  {id: 1558, en: "late", ko: "늦은", level: 'basic'},
  {id: 1559, en: "latter", ko: "뒤쪽의", level: 'intermediate'},
  {id: 1560, en: "laugh", ko: "(소리내어)웃다", level: 'intermediate'},
  {id: 1561, en: "launch", ko: "시작[개시/착수]하다, 출시하다", level: 'intermediate'},
  {id: 1562, en: "laundry", ko: "세탁물", level: 'intermediate'},
  {id: 1563, en: "law", ko: "법률", level: 'intermediate'},
  {id: 1564, en: "lawn", ko: "잔디밭", level: 'intermediate'},
  {id: 1565, en: "lawyer", ko: "법률가", level: 'intermediate'},
  {id: 1566, en: "lay", ko: "눕히다", level: 'intermediate'},
  {id: 1567, en: "layer", ko: "층", level: 'intermediate'},
  {id: 1568, en: "lazy", ko: "게으른", level: 'basic'},
  {id: 1569, en: "lead", ko: "이끌다", level: 'intermediate'},
  {id: 1570, en: "leaf", ko: "잎", level: 'basic'},
  {id: 1571, en: "leak", ko: "새다, 누출", level: 'intermediate'},
  {id: 1572, en: "lean", ko: "기대다", level: 'intermediate'},
  {id: 1573, en: "leap", ko: "(높이길게)뛰다, 뛰어오르다", level: 'intermediate'},
  {id: 1574, en: "learn", ko: "배우다", level: 'basic'},
  {id: 1575, en: "lease", ko: "임대차", level: 'advanced'},
  {id: 1576, en: "leather", ko: "가죽, 레더", level: 'intermediate'},
  {id: 1577, en: "leave", ko: "남기고가다", level: 'intermediate'},
  {id: 1578, en: "lecture", ko: "강의", level: 'intermediate'},
  {id: 1579, en: "left", ko: "왼쪽의", level: 'basic'},
  {id: 1580, en: "leg", ko: "다리", level: 'basic'},
  {id: 1581, en: "legal", ko: "법률상의", level: 'intermediate'},
  {id: 1582, en: "legend", ko: "전설", level: 'intermediate'},
  {id: 1583, en: "legislate", ko: "법률을 제정하다", level: 'advanced'},
  {id: 1584, en: "legitimate", ko: "합법의", level: 'advanced'},
  {id: 1585, en: "leisure", ko: "여가", level: 'intermediate'},
  {id: 1586, en: "lend", ko: "빌리다", level: 'intermediate'},
  {id: 1587, en: "lesson", ko: "학과", level: 'basic'},
  {id: 1588, en: "let", ko: "시키다", level: 'intermediate'},
  {id: 1589, en: "letter", ko: "편지", level: 'basic'},
  {id: 1590, en: "level", ko: "수평의", level: 'intermediate'},
  {id: 1591, en: "liberal", ko: "자유주의의", level: 'intermediate'},
  {id: 1592, en: "liberty", ko: "자유", level: 'intermediate'},
  {id: 1593, en: "library", ko: "도서관", level: 'basic'},
  {id: 1594, en: "license", ko: "면허", level: 'intermediate'},
  {id: 1595, en: "lid", ko: "뚜껑", level: 'intermediate'},
  {id: 1596, en: "lie", ko: "눕다", level: 'basic'},
  {id: 1597, en: "lift", ko: "끌어올리다", level: 'intermediate'},
  {id: 1598, en: "light", ko: "빛", level: 'basic'},
  {id: 1599, en: "like", ko: "좋아하다", level: 'basic'},
  {id: 1600, en: "likely", ko: "있을 법한", level: 'intermediate'},
  {id: 1601, en: "likewise", ko: "같이, 마찬가지로", level: 'intermediate'},
  {id: 1602, en: "limit", ko: "한계", level: 'intermediate'},
  {id: 1603, en: "line", ko: "선", level: 'basic'},
  {id: 1604, en: "linguistic", ko: "언어의, 언어학의", level: 'intermediate'},
  {id: 1605, en: "link", ko: "사슬의 고리", level: 'intermediate'},
  {id: 1606, en: "lion", ko: "사자", level: 'basic'},
  {id: 1607, en: "lip", ko: "입술", level: 'basic'},
  {id: 1608, en: "liquid", ko: "액체", level: 'intermediate'},
  {id: 1609, en: "list", ko: "리스트, 목록, 명단", level: 'intermediate'},
  {id: 1610, en: "listen", ko: "경청하다", level: 'basic'},
  {id: 1611, en: "literal", ko: "문자의", level: 'advanced'},
  {id: 1612, en: "literature", ko: "문학", level: 'intermediate'},
  {id: 1613, en: "little", ko: "작은", level: 'basic'},
  {id: 1614, en: "live", ko: "살다", level: 'basic'},
  {id: 1615, en: "living room", ko: "거실", level: 'basic'},
  {id: 1616, en: "load", ko: "짐", level: 'intermediate'},
  {id: 1617, en: "loan", ko: "대출, 대여", level: 'intermediate'},
  {id: 1618, en: "local", ko: "지역의, 현지의", level: 'intermediate'},
  {id: 1619, en: "locate", ko: "…의 정확한 위치를 찾아내다, 두다", level: 'intermediate'},
  {id: 1620, en: "lock", ko: "자물쇠", level: 'intermediate'},
  {id: 1621, en: "log", ko: "통나무", level: 'intermediate'},
  {id: 1622, en: "logic", ko: "논리, 논리학", level: 'intermediate'},
  {id: 1623, en: "lone", ko: "혼자인, 단독의", level: 'advanced'},
  {id: 1624, en: "long", ko: "(길이,시간 등)긴", level: 'basic'},
  {id: 1625, en: "look", ko: "보다", level: 'basic'},
  {id: 1626, en: "loose", ko: "풀어진", level: 'intermediate'},
  {id: 1627, en: "lose", ko: "잃다", level: 'intermediate'},
  {id: 1628, en: "loss", ko: "잃음", level: 'intermediate'},
  {id: 1629, en: "lot", ko: "많음, 다량, 많은, 제비(추첨)", level: 'intermediate'},
  {id: 1630, en: "loud", ko: "시끄러운", level: 'intermediate'},
  {id: 1631, en: "lounge", ko: "라운지, 휴게실, 느긋하게 서[앉아/누워]있다", level: 'intermediate'},
  {id: 1632, en: "love", ko: "사랑", level: 'basic'},
  {id: 1633, en: "low", ko: "낮은", level: 'basic'},
  {id: 1634, en: "loyal", ko: "충성스러운", level: 'intermediate'},
  {id: 1635, en: "luck", ko: "운", level: 'basic'},
  {id: 1636, en: "lump", ko: "덩어리", level: 'advanced'},
  {id: 1637, en: "lunch", ko: "점심", level: 'basic'},
  {id: 1638, en: "luxury", ko: "사치", level: 'intermediate'},
  {id: 1639, en: "machine", ko: "기계", level: 'intermediate'},
  {id: 1640, en: "mad", ko: "미친", level: 'basic'},
  {id: 1641, en: "magazine", ko: "잡지", level: 'intermediate'},
  {id: 1642, en: "magnet", ko: "자석", level: 'intermediate'},
  {id: 1643, en: "magnificent", ko: "장대한", level: 'advanced'},
  {id: 1644, en: "mail", ko: "우편물", level: 'basic'},
  {id: 1645, en: "main", ko: "주요한", level: 'intermediate'},
  {id: 1646, en: "maintain", ko: "계속하다", level: 'intermediate'},
  {id: 1647, en: "major", ko: "큰쪽의", level: 'intermediate'},
  {id: 1648, en: "majority", ko: "대다수", level: 'intermediate'},
  {id: 1649, en: "make", ko: "만들다", level: 'basic'},
  {id: 1650, en: "male", ko: "남성의", level: 'intermediate'},
  {id: 1651, en: "man", ko: "남자", level: 'basic'},
  {id: 1652, en: "manage", ko: "관리하다", level: 'intermediate'},
  {id: 1653, en: "manifest", ko: "명백히 하다", level: 'advanced'},
  {id: 1654, en: "manipulate", ko: "(손으로)다루다", level: 'advanced'},
  {id: 1655, en: "manner", ko: "방식, 태도, 예의", level: 'intermediate'},
  {id: 1656, en: "manufacture", ko: "제조하다", level: 'intermediate'},
  {id: 1657, en: "many", ko: "많은", level: 'basic'},
  {id: 1658, en: "map", ko: "지도", level: 'basic'},
  {id: 1659, en: "margin", ko: "여백 가장자리", level: 'intermediate'},
  {id: 1660, en: "marine", ko: "바다의", level: 'intermediate'},
  {id: 1661, en: "mark", ko: "표시하다, 자국", level: 'intermediate'},
  {id: 1662, en: "marry", ko: "결혼하다", level: 'basic'},
  {id: 1663, en: "marvel", ko: "경이", level: 'intermediate'},
  {id: 1664, en: "mass", ko: "덩어리", level: 'intermediate'},
  {id: 1665, en: "master", ko: "주인, 석사", level: 'intermediate'},
  {id: 1666, en: "match", ko: "성냥", level: 'intermediate'},
  {id: 1667, en: "mate", ko: "친구, 짝", level: 'intermediate'},
  {id: 1668, en: "material", ko: "원료", level: 'intermediate'},
  {id: 1669, en: "mathematics", ko: "수학", level: 'basic'},
  {id: 1670, en: "matter", ko: "물질", level: 'intermediate'},
  {id: 1671, en: "mature", ko: "익은", level: 'intermediate'},
  {id: 1672, en: "maximum", ko: "최고점", level: 'intermediate'},
  {id: 1673, en: "may", ko: "5월, 청춘", level: 'basic'},
  {id: 1674, en: "maybe", ko: "아마", level: 'intermediate'},
  {id: 1675, en: "mayor", ko: "시장", level: 'intermediate'},
  {id: 1676, en: "meal", ko: "식사", level: 'intermediate'},
  {id: 1677, en: "mean", ko: "의미하다", level: 'intermediate'},
  {id: 1678, en: "meantime", ko: "그동안 그 사이에", level: 'intermediate'},
  {id: 1679, en: "meanwhile", ko: "그동안", level: 'advanced'},
  {id: 1680, en: "measure", ko: "재다", level: 'intermediate'},
  {id: 1681, en: "meat", ko: "고기", level: 'basic'},
  {id: 1682, en: "mechanic", ko: "정비공, 역학", level: 'intermediate'},
  {id: 1683, en: "mechanism", ko: "(기계)장치", level: 'intermediate'},
  {id: 1684, en: "mediate", ko: "중재하다", level: 'intermediate'},
  {id: 1685, en: "medical", ko: "의학의", level: 'intermediate'},
  {id: 1686, en: "medicine", ko: "약", level: 'intermediate'},
  {id: 1687, en: "medieval", ko: "중세(풍)의", level: 'advanced'},
  {id: 1688, en: "medium", ko: "중간", level: 'intermediate'},
  {id: 1689, en: "meet", ko: "-을 만나다", level: 'basic'},
  {id: 1690, en: "melt", ko: "녹다", level: 'intermediate'},
  {id: 1691, en: "memory", ko: "기억", level: 'basic'},
  {id: 1692, en: "mental", ko: "마음의", level: 'intermediate'},
  {id: 1693, en: "mention", ko: "말하다", level: 'intermediate'},
  {id: 1694, en: "merchant", ko: "상인", level: 'intermediate'},
  {id: 1695, en: "mere", ko: "단순한", level: 'advanced'},
  {id: 1696, en: "merge", ko: "합병하다", level: 'advanced'},
  {id: 1697, en: "merit", ko: "장점", level: 'intermediate'},
  {id: 1698, en: "mess", ko: "혼란", level: 'intermediate'},
  {id: 1699, en: "metal", ko: "금속", level: 'intermediate'},
  {id: 1700, en: "method", ko: "방법", level: 'intermediate'},
  {id: 1701, en: "metropolitan", ko: "수도권(의)", level: 'advanced'},
  {id: 1702, en: "microphone", ko: "확성기", level: 'intermediate'},
  {id: 1703, en: "microwave", ko: "극초단파 전자레인지로 요리하다", level: 'intermediate'},
  {id: 1704, en: "middle", ko: "한복판의", level: 'basic'},
  {id: 1705, en: "might", ko: "힘", level: 'basic'},
  {id: 1706, en: "migrate", ko: "이주하다", level: 'advanced'},
  {id: 1707, en: "mild", ko: "온후한", level: 'intermediate'},
  {id: 1708, en: "military", ko: "군의", level: 'intermediate'},
  {id: 1709, en: "milk", ko: "젖", level: 'basic'},
  {id: 1710, en: "mill", ko: "멧돌", level: 'intermediate'},
  {id: 1711, en: "million", ko: "백만", level: 'intermediate'},
  {id: 1712, en: "mind", ko: "마음", level: 'basic'},
  {id: 1713, en: "miner", ko: "광산업자", level: 'intermediate'},
  {id: 1714, en: "mineral", ko: "광물", level: 'intermediate'},
  {id: 1715, en: "minimal", ko: "최소(한도)의", level: 'intermediate'},
  {id: 1716, en: "minimum", ko: "최소 한도", level: 'intermediate'},
  {id: 1717, en: "ministry", ko: "장관(목사)의 직(소임)", level: 'intermediate'},
  {id: 1718, en: "minor", ko: "작은 편의", level: 'intermediate'},
  {id: 1719, en: "minute", ko: "분", level: 'intermediate'},
  {id: 1720, en: "miracle", ko: "기적", level: 'intermediate'},
  {id: 1721, en: "mirror", ko: "거울", level: 'basic'},
  {id: 1722, en: "miss", ko: "미혼 여성 실수하다", level: 'basic'},
  {id: 1723, en: "missile", ko: "미사일", level: 'intermediate'},
  {id: 1724, en: "mission", ko: "사명", level: 'intermediate'},
  {id: 1725, en: "mistake", ko: "틀리다", level: 'intermediate'},
  {id: 1726, en: "mix", ko: "섞다", level: 'intermediate'},
  {id: 1727, en: "mobile", ko: "움직이기 쉬운", level: 'intermediate'},
  {id: 1728, en: "mock", ko: "조롱하다", level: 'advanced'},
  {id: 1729, en: "mode", ko: "방법", level: 'intermediate'},
  {id: 1730, en: "moderate", ko: "절제하는", level: 'advanced'},
  {id: 1731, en: "modern", ko: "현대의", level: 'intermediate'},
  {id: 1732, en: "modest", ko: "겸손한", level: 'advanced'},
  {id: 1733, en: "modify", ko: "변경하다", level: 'advanced'},
  {id: 1734, en: "moisture", ko: "습기", level: 'intermediate'},
  {id: 1735, en: "molecule", ko: "분자", level: 'advanced'},
  {id: 1736, en: "moment", ko: "순간", level: 'intermediate'},
  {id: 1737, en: "money", ko: "금전", level: 'basic'},
  {id: 1738, en: "monitor", ko: "충고자", level: 'intermediate'},
  {id: 1739, en: "monkey", ko: "원숭이", level: 'basic'},
  {id: 1740, en: "monster", ko: "괴물", level: 'intermediate'},
  {id: 1741, en: "month", ko: "월", level: 'basic'},
  {id: 1742, en: "monument", ko: "기념비", level: 'advanced'},
  {id: 1743, en: "mood", ko: "(일시적인)기분", level: 'intermediate'},
  {id: 1744, en: "moon", ko: "달", level: 'basic'},
  {id: 1745, en: "moral", ko: "도덕의", level: 'intermediate'},
  {id: 1746, en: "moreover", ko: "그 위에", level: 'intermediate'},
  {id: 1747, en: "morning", ko: "아침", level: 'basic'},
  {id: 1748, en: "mortal", ko: "죽을운명의", level: 'advanced'},
  {id: 1749, en: "mother", ko: "어머니", level: 'basic'},
  {id: 1750, en: "motion", ko: "운동", level: 'intermediate'},
  {id: 1751, en: "motive", ko: "동기", level: 'intermediate'},
  {id: 1752, en: "mount", ko: "산", level: 'intermediate'},
  {id: 1753, en: "mountain", ko: "산", level: 'basic'},
  {id: 1754, en: "mouse", ko: "새앙쥐", level: 'basic'},
  {id: 1755, en: "mouth", ko: "입", level: 'basic'},
  {id: 1756, en: "move", ko: "움직이다", level: 'basic'},
  {id: 1757, en: "movie", ko: "영화", level: 'basic'},
  {id: 1758, en: "much", ko: "많은", level: 'basic'},
  {id: 1759, en: "mud", ko: "진흙", level: 'intermediate'},
  {id: 1760, en: "multiple", ko: "복합의", level: 'intermediate'},
  {id: 1761, en: "multiply", ko: "늘리다", level: 'intermediate'},
  {id: 1762, en: "murder", ko: "살인", level: 'intermediate'},
  {id: 1763, en: "muscle", ko: "근육", level: 'intermediate'},
  {id: 1764, en: "museum", ko: "박물관", level: 'basic'},
  {id: 1765, en: "mushroom", ko: "버섯", level: 'intermediate'},
  {id: 1766, en: "music", ko: "음악", level: 'basic'},
  {id: 1767, en: "must", ko: "-해야 한다", level: 'basic'},
  {id: 1768, en: "mutual", ko: "상호의", level: 'advanced'},
  {id: 1769, en: "myth", ko: "신화", level: 'intermediate'},
  {id: 1770, en: "nail", ko: "손톱", level: 'intermediate'},
  {id: 1771, en: "naive", ko: "소박한", level: 'advanced'},
  {id: 1772, en: "naked", ko: "발가벗은", level: 'intermediate'},
  {id: 1773, en: "name", ko: "이름", level: 'basic'},
  {id: 1774, en: "nanny", ko: "유모", level: 'advanced'},
  {id: 1775, en: "narrate", ko: "이야기하다", level: 'intermediate'},
  {id: 1776, en: "narrow", ko: "좁은", level: 'intermediate'},
  {id: 1777, en: "nasty", ko: "불쾌한", level: 'advanced'},
  {id: 1778, en: "nation", ko: "국가", level: 'basic'},
  {id: 1779, en: "native", ko: "타고난", level: 'intermediate'},
  {id: 1780, en: "nature", ko: "자연", level: 'basic'},
  {id: 1781, en: "navy", ko: "해군(력)", level: 'intermediate'},
  {id: 1782, en: "near", ko: "가까이 -의 가까이에 가까운 접근하다", level: 'basic'},
  {id: 1783, en: "neat", ko: "산뜻한", level: 'intermediate'},
  {id: 1784, en: "necessary", ko: "필요한", level: 'intermediate'},
  {id: 1785, en: "neck", ko: "목", level: 'basic'},
  {id: 1786, en: "need", ko: "필요", level: 'basic'},
  {id: 1787, en: "needle", ko: "바늘 바늘로 꿰매다 바느질하다 아슬아슬한", level: 'intermediate'},
  {id: 1788, en: "negative", ko: "부정적인", level: 'intermediate'},
  {id: 1789, en: "neglect", ko: "게을리 하다", level: 'intermediate'},
  {id: 1790, en: "negotiate", ko: "교섭하다", level: 'intermediate'},
  {id: 1791, en: "neighbor", ko: "이웃사람(나라)", level: 'intermediate'},
  {id: 1792, en: "neither", ko: "(둘중)어느쪽도 -아니다 -도 아니다", level: 'intermediate'},
  {id: 1793, en: "nephew", ko: "조카", level: 'intermediate'},
  {id: 1794, en: "nervous", ko: "신경의", level: 'intermediate'},
  {id: 1795, en: "nest", ko: "보금자리", level: 'intermediate'},
  {id: 1796, en: "net", ko: "그물", level: 'intermediate'},
  {id: 1797, en: "network", ko: "그물세공", level: 'intermediate'},
  {id: 1798, en: "neutral", ko: "중립의", level: 'intermediate'},
  {id: 1799, en: "never", ko: "결코 -아니다", level: 'basic'},
  {id: 1800, en: "nevertheless", ko: "그럼에도 불구하고", level: 'intermediate'},
  {id: 1801, en: "new", ko: "새로운", level: 'basic'},
  {id: 1802, en: "newspaper", ko: "신문", level: 'basic'},
  {id: 1803, en: "next", ko: "다음의", level: 'basic'},
  {id: 1804, en: "nice", ko: "니스(프랑스 남부의 항구도시)", level: 'basic'},
  {id: 1805, en: "night", ko: "밤", level: 'basic'},
  {id: 1806, en: "nightmare", ko: "악몽", level: 'intermediate'},
  {id: 1807, en: "nothing", ko: "아무것도", level: 'basic'},
  {id: 1808, en: "noble", ko: "고귀한", level: 'intermediate'},
  {id: 1809, en: "nobody", ko: "아무도 -않다 하찮은 사람", level: 'intermediate'},
  {id: 1810, en: "nod", ko: "끄덕이다", level: 'intermediate'},
  {id: 1811, en: "noise", ko: "소리", level: 'intermediate'},
  {id: 1812, en: "nominate", ko: "추천하다", level: 'advanced'},
  {id: 1813, en: "none", ko: "아무도(조금도)-않다 조금도(결코)-않다", level: 'intermediate'},
  {id: 1814, en: "nonetheless", ko: "역시", level: 'advanced'},
  {id: 1815, en: "nonsense", ko: "허튼 소리", level: 'intermediate'},
  {id: 1816, en: "noon", ko: "정오", level: 'basic'},
  {id: 1817, en: "nor", ko: "-도 또한-않다", level: 'intermediate'},
  {id: 1818, en: "norm", ko: "표준", level: 'advanced'},
  {id: 1819, en: "normal", ko: "표준(의)", level: 'intermediate'},
  {id: 1820, en: "north", ko: "북, 북 쪽, 북부", level: 'basic'},
  {id: 1821, en: "nose", ko: "코", level: 'basic'},
  {id: 1822, en: "not", ko: "아니다", level: 'basic'},
  {id: 1823, en: "note", ko: "기록", level: 'basic'},
  {id: 1824, en: "nothing", ko: "아무것도 …없다", level: 'basic'},
  {id: 1825, en: "notice", ko: "통지, 통보", level: 'intermediate'},
  {id: 1826, en: "notion", ko: "n,관념", level: 'advanced'},
  {id: 1827, en: "novel", ko: "소설", level: 'intermediate'},
  {id: 1828, en: "now", ko: "지금", level: 'basic'},
  {id: 1829, en: "nowadays", ko: "오늘날에는, 요즈음에는", level: 'intermediate'},
  {id: 1830, en: "nowhere", ko: "아무데도 …없다", level: 'intermediate'},
  {id: 1831, en: "nuclear", ko: "핵의, 핵을 형성하는 원자핵의", level: 'intermediate'},
  {id: 1832, en: "number", ko: "수", level: 'basic'},
  {id: 1833, en: "numerous", ko: "다 수의, 수많은, 셀 수 없이 많은", level: 'advanced'},
  {id: 1834, en: "nun", ko: "수녀 집비둘기의 일종", level: 'advanced'},
  {id: 1835, en: "nurse", ko: "유모", level: 'basic'},
  {id: 1836, en: "nut", ko: "견과", level: 'intermediate'},
  {id: 1837, en: "oak", ko: "참나무", level: 'intermediate'},
  {id: 1838, en: "obey", ko: "따르다", level: 'intermediate'},
  {id: 1839, en: "object", ko: "사물", level: 'intermediate'},
  {id: 1840, en: "objective", ko: "객관적인", level: 'intermediate'},
  {id: 1841, en: "oblige", ko: "(의무를)별수없이 -하게하다", level: 'advanced'},
  {id: 1842, en: "observe", ko: "관찰하다", level: 'intermediate'},
  {id: 1843, en: "obsess", ko: "늘러붙다", level: 'advanced'},
  {id: 1844, en: "obtain", ko: "얻다", level: 'intermediate'},
  {id: 1845, en: "obvious", ko: "명백한", level: 'intermediate'},
  {id: 1846, en: "occasion", ko: "경우", level: 'intermediate'},
  {id: 1847, en: "occupation", ko: "일직업", level: 'intermediate'},
  {id: 1848, en: "occupy", ko: "차지하다", level: 'intermediate'},
  {id: 1849, en: "occur", ko: "일어나다", level: 'intermediate'},
  {id: 1850, en: "ocean", ko: "대양", level: 'basic'},
  {id: 1851, en: "odd", ko: "묘한", level: 'intermediate'},
  {id: 1852, en: "of", ko: "출신의", level: 'basic'},
  {id: 1853, en: "off", ko: "떨어져", level: 'basic'},
  {id: 1854, en: "offend", ko: "성나게 하다", level: 'intermediate'},
  {id: 1855, en: "offer", ko: "권하다", level: 'intermediate'},
  {id: 1856, en: "office", ko: "임무", level: 'basic'},
  {id: 1857, en: "officer", ko: "공무원", level: 'intermediate'},
  {id: 1858, en: "official", ko: "공무원", level: 'intermediate'},
  {id: 1859, en: "often", ko: "자주", level: 'basic'},
  {id: 1860, en: "oil", ko: "기름", level: 'basic'},
  {id: 1861, en: "old", ko: "늙은", level: 'basic'},
  {id: 1862, en: "olive", ko: "올리브나무", level: 'intermediate'},
  {id: 1863, en: "on", ko: "위에", level: 'basic'},
  {id: 1864, en: "once", ko: "한번", level: 'intermediate'},
  {id: 1865, en: "one", ko: "하나(의)", level: 'basic'},
  {id: 1866, en: "only", ko: "유일한", level: 'basic'},
  {id: 1867, en: "open", ko: "열다", level: 'basic'},
  {id: 1868, en: "operate", ko: "움직이다", level: 'intermediate'},
  {id: 1869, en: "opinion", ko: "의견", level: 'intermediate'},
  {id: 1870, en: "opportunity", ko: "기회", level: 'intermediate'},
  {id: 1871, en: "oppose", ko: "반대하다", level: 'intermediate'},
  {id: 1872, en: "optimist", ko: "낙천가", level: 'intermediate'},
  {id: 1873, en: "option", ko: "선택(권의 자유)", level: 'intermediate'},
  {id: 1874, en: "or", ko: "혹은", level: 'basic'},
  {id: 1875, en: "oral", ko: "구두의", level: 'intermediate'},
  {id: 1876, en: "orbit", ko: "궤도", level: 'advanced'},
  {id: 1877, en: "orchestra", ko: "관현악단", level: 'intermediate'},
  {id: 1878, en: "order", ko: "순서", level: 'intermediate'},
  {id: 1879, en: "ordinary", ko: "보통의", level: 'intermediate'},
  {id: 1880, en: "organ", ko: "(생물의)기관", level: 'intermediate'},
  {id: 1881, en: "organic", ko: "유기체의", level: 'intermediate'},
  {id: 1882, en: "organize", ko: "조직하다", level: 'intermediate'},
  {id: 1883, en: "orient", ko: "동양 동양의 동쪽으로 향하게 하다", level: 'intermediate'},
  {id: 1884, en: "origin", ko: "기원", level: 'intermediate'},
  {id: 1885, en: "other", ko: "다른 다른 것 그렇지 않고", level: 'intermediate'},
  {id: 1886, en: "otherwise", ko: "딴 방법으로는", level: 'intermediate'},
  {id: 1887, en: "ought", ko: "해야만 하다", level: 'intermediate'},
  {id: 1888, en: "ounce", ko: "삵괭이", level: 'advanced'},
  {id: 1889, en: "out", ko: "밖으로", level: 'basic'},
  {id: 1890, en: "outcome", ko: "결과", level: 'intermediate'},
  {id: 1891, en: "outline", ko: "윤곽", level: 'intermediate'},
  {id: 1892, en: "output", ko: "산출", level: 'intermediate'},
  {id: 1893, en: "outrage", ko: "불법(적인 행위)", level: 'advanced'},
  {id: 1894, en: "outstanding", ko: "눈에 띄는", level: 'intermediate'},
  {id: 1895, en: "over", ko: "위쪽", level: 'basic'},
  {id: 1896, en: "overall", ko: "포괄(전면)적인 덧옷", level: 'intermediate'},
  {id: 1897, en: "overcome", ko: "이기다", level: 'intermediate'},
  {id: 1898, en: "overhead", ko: "머리위에 머리 위의", level: 'intermediate'},
  {id: 1899, en: "overlap", ko: "겹치다", level: 'intermediate'},
  {id: 1900, en: "overlook", ko: "내려다 보다", level: 'intermediate'},
  {id: 1901, en: "overnight", ko: "전날밤의", level: 'intermediate'},
  {id: 1902, en: "oversea", ko: "해외(로부터)의", level: 'intermediate'},
  {id: 1903, en: "overwhelm", ko: "압도하다", level: 'advanced'},
  {id: 1904, en: "owe", ko: "지불할 의무가 있다", level: 'intermediate'},
  {id: 1905, en: "own", ko: "자기자신의 소유하다", level: 'intermediate'},
  {id: 1906, en: "pace", ko: "한걸음", level: 'intermediate'},
  {id: 1907, en: "pack", ko: "꾸러미", level: 'intermediate'},
  {id: 1908, en: "packet", ko: "다발", level: 'intermediate'},
  {id: 1909, en: "pad", ko: "(및에)덧대는 것", level: 'intermediate'},
  {id: 1910, en: "pain", ko: "고통", level: 'intermediate'},
  {id: 1911, en: "paint", ko: "도료", level: 'basic'},
  {id: 1912, en: "pair", ko: "한쌍", level: 'intermediate'},
  {id: 1913, en: "palace", ko: "궁전", level: 'basic'},
  {id: 1914, en: "pale", ko: "창백한", level: 'intermediate'},
  {id: 1915, en: "palm", ko: "손바닥", level: 'intermediate'},
  {id: 1916, en: "pan", ko: "남비 사금 등을 남비로 가려내다", level: 'intermediate'},
  {id: 1917, en: "panel", ko: "판벽널", level: 'advanced'},
  {id: 1918, en: "panic", ko: "돌연한공포", level: 'intermediate'},
  {id: 1919, en: "pants", ko: "바지", level: 'basic'},
  {id: 1920, en: "paper", ko: "종이", level: 'basic'},
  {id: 1921, en: "paragraph", ko: "(문장의)절", level: 'intermediate'},
  {id: 1922, en: "parallel", ko: "평행의", level: 'advanced'},
  {id: 1923, en: "pardon", ko: "용서하다 용서", level: 'intermediate'},
  {id: 1924, en: "parent", ko: "부모(어버이)", level: 'basic'},
  {id: 1925, en: "park", ko: "공원", level: 'basic'},
  {id: 1926, en: "parliament", ko: "의회", level: 'advanced'},
  {id: 1927, en: "part", ko: "부분", level: 'basic'},
  {id: 1928, en: "participate", ko: "참가하다", level: 'intermediate'},
  {id: 1929, en: "particle", ko: "입자", level: 'advanced'},
  {id: 1930, en: "particular", ko: "특수한", level: 'intermediate'},
  {id: 1931, en: "pass", ko: "지나가다", level: 'basic'},
  {id: 1932, en: "passage", ko: "통행, 통과", level: 'intermediate'},
  {id: 1933, en: "passenger", ko: "승객", level: 'intermediate'},
  {id: 1934, en: "passion", ko: "정열", level: 'intermediate'},
  {id: 1935, en: "passport", ko: "여권", level: 'intermediate'},
  {id: 1936, en: "past", ko: "과거", level: 'intermediate'},
  {id: 1937, en: "pat", ko: "톡톡 가볍게 치다", level: 'advanced'},
  {id: 1938, en: "patch", ko: "깁는 헝겊", level: 'advanced'},
  {id: 1939, en: "patent", ko: "전매특허권 전매특허의", level: 'advanced'},
  {id: 1940, en: "path", ko: "작은 길", level: 'intermediate'},
  {id: 1941, en: "patient", ko: "인내심이 강한 환자", level: 'intermediate'},
  {id: 1942, en: "patrol", ko: "순회", level: 'advanced'},
  {id: 1943, en: "pattern", ko: "모범", level: 'intermediate'},
  {id: 1944, en: "pause", ko: "중지", level: 'intermediate'},
  {id: 1945, en: "pave", ko: "(도로를)포장하다", level: 'advanced'},
  {id: 1946, en: "pay", ko: "지불하다", level: 'basic'},
  {id: 1947, en: "peace", ko: "평화", level: 'basic'},
  {id: 1948, en: "peak", ko: "(뾰족한)끝", level: 'intermediate'},
  {id: 1949, en: "pear", ko: "서양배", level: 'basic'},
  {id: 1950, en: "peasant", ko: "농부", level: 'advanced'},
  {id: 1951, en: "peel", ko: "껍질을 벗기다 벗어지다 껍질", level: 'intermediate'},
  {id: 1952, en: "peer", ko: "동료", level: 'intermediate'},
  {id: 1953, en: "penalty", ko: "벌", level: 'intermediate'},
  {id: 1954, en: "pencil", ko: "연필 연필로 쓰다", level: 'basic'},
  {id: 1955, en: "people", ko: "사람들", level: 'basic'},
  {id: 1956, en: "pepper", ko: "고추", level: 'intermediate'},
  {id: 1957, en: "per", ko: "-에 의하여", level: 'intermediate'},
  {id: 1958, en: "perceive", ko: "지각하다", level: 'intermediate'},
  {id: 1959, en: "perfect", ko: "완전한", level: 'intermediate'},
  {id: 1960, en: "perform", ko: "다하다", level: 'intermediate'},
  {id: 1961, en: "perhaps", ko: "아마", level: 'intermediate'},
  {id: 1962, en: "period", ko: "시간", level: 'intermediate'},
  {id: 1963, en: "permanent", ko: "영구의", level: 'intermediate'},
  {id: 1964, en: "permit", ko: "허가하다", level: 'intermediate'},
  {id: 1965, en: "persist", ko: "고집하다", level: 'advanced'},
  {id: 1966, en: "person", ko: "사람", level: 'intermediate'},
  {id: 1967, en: "personality", ko: "개성", level: 'intermediate'},
  {id: 1968, en: "perspective", ko: "원근법의 원근 화법", level: 'advanced'},
  {id: 1969, en: "persuade", ko: "설득하다", level: 'intermediate'},
  {id: 1970, en: "pet", ko: "애완동물", level: 'intermediate'},
  {id: 1971, en: "phase", ko: "국면", level: 'advanced'},
  {id: 1972, en: "phenomenon", ko: "현상", level: 'intermediate'},
  {id: 1973, en: "philosophy", ko: "철학", level: 'intermediate'},
  {id: 1974, en: "photograph", ko: "사진 촬영하다", level: 'intermediate'},
  {id: 1975, en: "phrase", ko: "구", level: 'intermediate'},
  {id: 1976, en: "physical", ko: "물질의", level: 'intermediate'},
  {id: 1977, en: "physics", ko: "물리학", level: 'intermediate'},
  {id: 1978, en: "pick", ko: "따다", level: 'basic'},
  {id: 1979, en: "picnic", ko: "소풍", level: 'basic'},
  {id: 1980, en: "picture", ko: "그림", level: 'basic'},
  {id: 1981, en: "piece", ko: "한 조각", level: 'intermediate'},
  {id: 1982, en: "pig", ko: "돼지", level: 'basic'},
  {id: 1983, en: "pile", ko: "쌓아 올린 것", level: 'intermediate'},
  {id: 1984, en: "pill", ko: "알약", level: 'intermediate'},
  {id: 1985, en: "pin", ko: "핀 핀으로 꽂다", level: 'intermediate'},
  {id: 1986, en: "pinch", ko: "꼬집다", level: 'advanced'},
  {id: 1987, en: "pine", ko: "소나무 수척해 지다", level: 'intermediate'},
  {id: 1988, en: "pink", ko: "연분홍색", level: 'basic'},
  {id: 1989, en: "pioneer", ko: "개척자", level: 'intermediate'},
  {id: 1990, en: "pitch", ko: "던지다", level: 'advanced'},
  {id: 1991, en: "pity", ko: "불쌍히 여김", level: 'intermediate'},
  {id: 1992, en: "place", ko: "장소", level: 'basic'},
  {id: 1993, en: "plain", ko: "분명한", level: 'intermediate'},
  {id: 1994, en: "plan", ko: "계획", level: 'basic'},
  {id: 1995, en: "planet", ko: "행성", level: 'intermediate'},
  {id: 1996, en: "plant", ko: "실물", level: 'intermediate'},
  {id: 1997, en: "plate", ko: "판", level: 'intermediate'},
  {id: 1998, en: "platform", ko: "단", level: 'intermediate'},
  {id: 1999, en: "play", ko: "놀다", level: 'basic'},
  {id: 2000, en: "pleasant", ko: "기분 좋은", level: 'intermediate'},
  {id: 2001, en: "please", ko: "기쁘게 하다", level: 'basic'},
  {id: 2002, en: "pleasure", ko: "즐거움", level: 'intermediate'},
  {id: 2003, en: "plenty", ko: "많음", level: 'intermediate'},
  {id: 2004, en: "plot", ko: "음모", level: 'intermediate'},
  {id: 2005, en: "plus", ko: "더하기의 -외에", level: 'intermediate'},
  {id: 2006, en: "P.M.", ko: "오후", level: 'basic'},
  {id: 2007, en: "pocket", ko: "포켓", level: 'basic'},
  {id: 2008, en: "poem", ko: "시", level: 'intermediate'},
  {id: 2009, en: "poet", ko: "시인", level: 'intermediate'},
  {id: 2010, en: "point", ko: "점", level: 'basic'},
  {id: 2011, en: "poison", ko: "독", level: 'intermediate'},
  {id: 2012, en: "polar", ko: "남극의", level: 'intermediate'},
  {id: 2013, en: "pole", ko: "폴란드사람", level: 'intermediate'},
  {id: 2014, en: "police", ko: "경찰 경비하다", level: 'basic'},
  {id: 2015, en: "policy", ko: "정책", level: 'intermediate'},
  {id: 2016, en: "polish", ko: "닦다, 갈다, 윤내다", level: 'advanced'},
  {id: 2017, en: "polite", ko: "공손한", level: 'intermediate'},
  {id: 2018, en: "politics", ko: "정치", level: 'intermediate'},
  {id: 2019, en: "poll", ko: "투표", level: 'intermediate'},
  {id: 2020, en: "pollute", ko: "-을 더럽히다", level: 'intermediate'},
  {id: 2021, en: "pond", ko: "못, 연못", level: 'intermediate'},
  {id: 2022, en: "pool", ko: "판돈", level: 'intermediate'},
  {id: 2023, en: "poor", ko: "가난한 부족한, 불충분한, 빈약한", level: 'basic'},
  {id: 2024, en: "pop", ko: "팝(뮤직)", level: 'intermediate'},
  {id: 2025, en: "pope", ko: "로마 교황  최고 권위자로 자처하는 사람", level: 'advanced'},
  {id: 2026, en: "popular", ko: "민중 의, 대중의", level: 'intermediate'},
  {id: 2027, en: "population", ko: "인구", level: 'intermediate'},
  {id: 2028, en: "pork", ko: "돼지고기", level: 'intermediate'},
  {id: 2029, en: "port", ko: "항구, 항만, 상항", level: 'intermediate'},
  {id: 2030, en: "portion", ko: "일부, 부분", level: 'advanced'},
  {id: 2031, en: "portrait", ko: "초상", level: 'intermediate'},
  {id: 2032, en: "pose", ko: "자세, 포즈  마음가짐  꾸민 태도", level: 'intermediate'},
  {id: 2033, en: "position", ko: "위치", level: 'intermediate'},
  {id: 2034, en: "positive", ko: "명확한, 의문의 여지가 없는, 부정할 수 없는", level: 'intermediate'},
  {id: 2035, en: "possess", ko: "소유하다", level: 'intermediate'},
  {id: 2036, en: "possible", ko: "가능한", level: 'intermediate'},
  {id: 2037, en: "post", ko: "기둥", level: 'intermediate'},
  {id: 2038, en: "poster", ko: "포스터", level: 'intermediate'},
  {id: 2039, en: "pot", ko: "단지", level: 'intermediate'},
  {id: 2040, en: "potato", ko: "감자", level: 'basic'},
  {id: 2041, en: "potential", ko: "가능한", level: 'intermediate'},
  {id: 2042, en: "pour", ko: "따르다", level: 'intermediate'},
  {id: 2043, en: "powder", ko: "가루", level: 'intermediate'},
  {id: 2044, en: "power", ko: "힘", level: 'basic'},
  {id: 2045, en: "practical", ko: "실제의", level: 'intermediate'},
  {id: 2046, en: "practice", ko: "연습", level: 'intermediate'},
  {id: 2047, en: "praise", ko: "칭찬", level: 'intermediate'},
  {id: 2048, en: "pray", ko: "빌다", level: 'intermediate'},
  {id: 2049, en: "preach", ko: "설교하다", level: 'advanced'},
  {id: 2050, en: "precede", ko: "-에 앞서다", level: 'advanced'},
  {id: 2051, en: "precious", ko: "비싼", level: 'intermediate'},
  {id: 2052, en: "precise", ko: "정확한", level: 'intermediate'},
  {id: 2053, en: "predator", ko: "약탈자", level: 'advanced'},
  {id: 2054, en: "predict", ko: "예언하다, 예보하다 예언하다", level: 'intermediate'},
  {id: 2055, en: "prefer", ko: "오히려 …을 좋아하다,", level: 'intermediate'},
  {id: 2056, en: "pregnant", ko: "임신한 충만한", level: 'intermediate'},
  {id: 2057, en: "prejudice", ko: "편견, 선입관", level: 'advanced'},
  {id: 2058, en: "premier", ko: "국무 총리, 수상", level: 'advanced'},
  {id: 2059, en: "premium", ko: "할증금,  액면 초과액, 프리미엄", level: 'advanced'},
  {id: 2060, en: "prepare", ko: "준비하 다, 마련하다, 채비를 갖추다", level: 'intermediate'},
  {id: 2061, en: "prescribe", ko: "명령하다, 지령하다", level: 'intermediate'},
  {id: 2062, en: "presence", ko: "존재, 현존, 실재  출석, 임석, 참석", level: 'intermediate'},
  {id: 2063, en: "present", ko: "있는, 존재하는", level: 'basic'},
  {id: 2064, en: "preserve", ko: "보호하다, 지키다", level: 'intermediate'},
  {id: 2065, en: "president", ko: "대통령 회장", level: 'intermediate'},
  {id: 2066, en: "press", ko: "강제로 모집하다", level: 'intermediate'},
  {id: 2067, en: "presume", ko: "가정하다", level: 'advanced'},
  {id: 2068, en: "pretend", ko: "핑계삼다", level: 'intermediate'},
  {id: 2069, en: "pretty", ko: "예쁜, 귀여운, 참 한, 조촐한", level: 'basic'},
  {id: 2070, en: "prevail", ko: "이기다, 극복하다, 압도하다 우세하다, 보급되다", level: 'advanced'},
  {id: 2071, en: "prevent", ko: "막다, 방해하다", level: 'intermediate'},
  {id: 2072, en: "previous", ko: "앞의, 이전의", level: 'intermediate'},
  {id: 2073, en: "prey", ko: "먹이", level: 'intermediate'},
  {id: 2074, en: "price", ko: "값, 가격, 대가, 정가", level: 'intermediate'},
  {id: 2075, en: "pride", ko: "자존심", level: 'intermediate'},
  {id: 2076, en: "priest", ko: "성직자", level: 'intermediate'},
  {id: 2077, en: "primary", ko: "첫째의, 제1위의, 수위의 초등의, 초보의", level: 'intermediate'},
  {id: 2078, en: "prime", ko: "수위의, 최초의, 원시적인", level: 'intermediate'},
  {id: 2079, en: "primitive", ko: "원시의, 초기의", level: 'intermediate'},
  {id: 2080, en: "prince", ko: "왕자, 태자, 세자, 대군", level: 'basic'},
  {id: 2081, en: "principal", ko: "주요한, 주된, 제일의, 앞장서는", level: 'intermediate'},
  {id: 2082, en: "principle", ko: "원리, 원칙, 법칙, 공리", level: 'intermediate'},
  {id: 2083, en: "print", ko: "인쇄하다, 프린트하다", level: 'basic'},
  {id: 2084, en: "prior", ko: "이전의, 앞의", level: 'advanced'},
  {id: 2085, en: "prison", ko: "교도소", level: 'intermediate'},
  {id: 2086, en: "privacy", ko: "남의 눈을 피함, 은거, 은둔, 은퇴 생활 사생활", level: 'intermediate'},
  {id: 2087, en: "private", ko: "사적인, 사사로운, 개인에 속한", level: 'intermediate'},
  {id: 2088, en: "privilege", ko: "특권, 특전, 특별 취급", level: 'advanced'},
  {id: 2089, en: "prize", ko: "상, 포상, 우등상, 선행상", level: 'basic'},
  {id: 2090, en: "probably", ko: "아마, 십중팔구", level: 'intermediate'},
  {id: 2091, en: "problem", ko: "문제", level: 'basic'},
  {id: 2092, en: "procedure", ko: "진행, 경과 절차", level: 'advanced'},
  {id: 2093, en: "proceed", ko: "나아가다, 가다", level: 'intermediate'},
  {id: 2094, en: "process", ko: "진행, 작용", level: 'intermediate'},
  {id: 2095, en: "produce", ko: "생산하다, 산출하다, 생기게 하다,", level: 'intermediate'},
  {id: 2096, en: "profession", ko: "직업 공언, 선언, 고백", level: 'intermediate'},
  {id: 2097, en: "professor", ko: "교수", level: 'intermediate'},
  {id: 2098, en: "profile", ko: "옆 얼굴, 반면상 인물 소개  태도, 자세", level: 'advanced'},
  {id: 2099, en: "profit", ko: "이익, 이득, 벌이", level: 'intermediate'},
  {id: 2100, en: "profound", ko: "깊은, 심원한", level: 'advanced'},
  {id: 2101, en: "progress", ko: "진행, 전진, 진척  진보, 향상, 발달, 발전", level: 'intermediate'},
  {id: 2102, en: "prohibit", ko: "금하다, 금지하다", level: 'advanced'},
  {id: 2103, en: "prominent", ko: "두드러진, 돌기한, 양각된 현저한, 탁월한, 중요한", level: 'advanced'},
  {id: 2104, en: "promise", ko: "약속, 서약, 계약", level: 'intermediate'},
  {id: 2105, en: "promote", ko: "승진시키다 진행시키다,", level: 'intermediate'},
  {id: 2106, en: "prompt", ko: "재빠른, 신속한, 즉시 …하는", level: 'advanced'},
  {id: 2107, en: "pronounce", ko: "발음하다, 음독하다", level: 'intermediate'},
  {id: 2108, en: "proof", ko: "증명", level: 'intermediate'},
  {id: 2109, en: "proper", ko: "고유의, 독특한, 본연의,  특유한", level: 'intermediate'},
  {id: 2110, en: "property", ko: "재산, 자산", level: 'intermediate'},
  {id: 2111, en: "proportion", ko: "비율, 비 균형, 조화", level: 'advanced'},
  {id: 2112, en: "propose", ko: "제의하다, 제출하다 추천하다, 지명하다", level: 'intermediate'},
  {id: 2113, en: "prospect", ko: "전망, 조망, 경치", level: 'intermediate'},
  {id: 2114, en: "prosper", ko: "번영하다", level: 'advanced'},
  {id: 2115, en: "protect", ko: "보호하다, 막다, 지키다, 비호하다", level: 'intermediate'},
  {id: 2116, en: "protein", ko: "단백질", level: 'intermediate'},
  {id: 2117, en: "protest", ko: "단언하다", level: 'intermediate'},
  {id: 2118, en: "proud", ko: "뽐내는, 자랑하는 자긍하는, 영광 으로 여기는", level: 'intermediate'},
  {id: 2119, en: "prove", ko: "시험하다, 실험하다, 경험하다, 시험해 보다", level: 'intermediate'},
  {id: 2120, en: "provide", ko: "준비하다, 미리 …에 대비하다  규정하다", level: 'intermediate'},
  {id: 2121, en: "province", ko: "주, 성, 도  범위, 영역, 분야", level: 'intermediate'},
  {id: 2122, en: "provoke", ko: "화나게 하다", level: 'advanced'},
  {id: 2123, en: "psychology", ko: "심리학", level: 'intermediate'},
  {id: 2124, en: "pub", ko: "펍(술집)", level: 'intermediate'},
  {id: 2125, en: "public", ko: "심리, 심리 상태", level: 'intermediate'},
  {id: 2126, en: "publish", ko: "발표 하다, 널리 알리다", level: 'intermediate'},
  {id: 2127, en: "pull", ko: "끌다, 당기다, 끌어 당기다, 잡아 끌다", level: 'intermediate'},
  {id: 2128, en: "pump", ko: "펌프 퍼올리다", level: 'intermediate'},
  {id: 2129, en: "punch", ko: "주먹질, 펀치  힘, 활기", level: 'intermediate'},
  {id: 2130, en: "punish", ko: "벌하다, 응징하다, 처형하다", level: 'intermediate'},
  {id: 2131, en: "pupil", ko: "흔히 국민학교 중학교 학생", level: 'intermediate'},
  {id: 2132, en: "puppy", ko: "강아지", level: 'basic'},
  {id: 2133, en: "purchase", ko: "사다, 구입하다", level: 'intermediate'},
  {id: 2134, en: "pure", ko: "순수한  깨끗한, 순전한, 결백한", level: 'intermediate'},
  {id: 2135, en: "purple", ko: "자줏빛의  새빨간  제왕의", level: 'intermediate'},
  {id: 2136, en: "purpose", ko: "목적", level: 'intermediate'},
  {id: 2137, en: "pursue", ko: "쫓다, 추적하다, 몰다", level: 'intermediate'},
  {id: 2138, en: "push", ko: "밀다, 밀치다, 밀어서 움직 이다, 밀어 내다", level: 'basic'},
  {id: 2139, en: "put", ko: "놓다, 두다", level: 'basic'},
  {id: 2140, en: "puzzle", ko: "당황, 혼란 괴롭히는 사람,  어려운 문제", level: 'basic'},
  {id: 2141, en: "qualify", ko: "자격을 부여하다", level: 'intermediate'},
  {id: 2142, en: "quality", ko: "질", level: 'intermediate'},
  {id: 2143, en: "quantity", ko: "양", level: 'intermediate'},
  {id: 2144, en: "quarter", ko: "4분의 1", level: 'intermediate'},
  {id: 2145, en: "queen", ko: "여왕", level: 'basic'},
  {id: 2146, en: "question", ko: "물음, 질문, 질의", level: 'basic'},
  {id: 2147, en: "questionnaire", ko: "질문표", level: 'advanced'},
  {id: 2148, en: "quick", ko: "빠른", level: 'basic'},
  {id: 2149, en: "quiet", ko: "조용한", level: 'basic'},
  {id: 2150, en: "quit", ko: "(의무,책임을)벗어난 떠나다", level: 'intermediate'},
  {id: 2151, en: "quite", ko: "아주", level: 'intermediate'},
  {id: 2152, en: "quote", ko: "인용하다", level: 'advanced'},
  {id: 2153, en: "rabbit", ko: "집토끼", level: 'basic'},
  {id: 2154, en: "race", ko: "인종", level: 'basic'},
  {id: 2155, en: "racial", ko: "인종(상)의", level: 'intermediate'},
  {id: 2156, en: "rage", ko: "격노", level: 'advanced'},
  {id: 2157, en: "rail", ko: "가로장", level: 'intermediate'},
  {id: 2158, en: "rain", ko: "비", level: 'basic'},
  {id: 2159, en: "rainbow", ko: "무지개", level: 'basic'},
  {id: 2160, en: "raise", ko: "올리다", level: 'intermediate'},
  {id: 2161, en: "rally", ko: "규합하다", level: 'advanced'},
  {id: 2162, en: "random", ko: "무작위의, 닥치는 대로의", level: 'intermediate'},
  {id: 2163, en: "range", ko: "다양성, 범위", level: 'intermediate'},
  {id: 2164, en: "rank", ko: "지위, 계급", level: 'intermediate'},
  {id: 2165, en: "rapid", ko: "빠른", level: 'intermediate'},
  {id: 2166, en: "rare", ko: "희귀한", level: 'intermediate'},
  {id: 2167, en: "rat", ko: "쥐", level: 'intermediate'},
  {id: 2168, en: "rate", ko: "속도, 비율", level: 'intermediate'},
  {id: 2169, en: "rather", ko: "오히려", level: 'intermediate'},
  {id: 2170, en: "rational", ko: "합리적인", level: 'advanced'},
  {id: 2171, en: "raw", ko: "날것의", level: 'intermediate'},
  {id: 2172, en: "reach", ko: "도착하다", level: 'intermediate'},
  {id: 2173, en: "react", ko: "반응을 나타내다", level: 'intermediate'},
  {id: 2174, en: "read", ko: "읽다", level: 'basic'},
  {id: 2175, en: "ready", ko: "준비가 된", level: 'basic'},
  {id: 2176, en: "real", ko: "실재하는", level: 'intermediate'},
  {id: 2177, en: "realize", ko: "깨닫다", level: 'intermediate'},
  {id: 2178, en: "rear", ko: "뒤", level: 'advanced'},
  {id: 2179, en: "reason", ko: "이유, 까닭, 이성", level: 'intermediate'},
  {id: 2180, en: "rebel", ko: "반역자", level: 'advanced'},
  {id: 2181, en: "recall", ko: "되부르다", level: 'intermediate'},
  {id: 2182, en: "receipt", ko: "영수중, 수령", level: 'intermediate'},
  {id: 2183, en: "receive", ko: "받다", level: 'intermediate'},
  {id: 2184, en: "recent", ko: "최근의", level: 'intermediate'},
  {id: 2185, en: "reception", ko: "받음", level: 'intermediate'},
  {id: 2186, en: "recipe", ko: "조리법", level: 'intermediate'},
  {id: 2187, en: "recognize", ko: "인정하다", level: 'intermediate'},
  {id: 2188, en: "recommend", ko: "추천하다", level: 'intermediate'},
  {id: 2189, en: "record", ko: "기록하다", level: 'intermediate'},
  {id: 2190, en: "recover", ko: "되찾다", level: 'intermediate'},
  {id: 2191, en: "recruit", ko: "신병", level: 'advanced'},
  {id: 2192, en: "recycle", ko: "재생 이용하다", level: 'intermediate'},
  {id: 2193, en: "red", ko: "붉은", level: 'basic'},
  {id: 2194, en: "reduce", ko: "줄이다", level: 'intermediate'},
  {id: 2195, en: "refer", ko: "조회시키다", level: 'intermediate'},
  {id: 2196, en: "refine", ko: "정제정련하다", level: 'advanced'},
  {id: 2197, en: "reflect", ko: "반사하다", level: 'intermediate'},
  {id: 2198, en: "reform", ko: "개정(개혁)하다", level: 'intermediate'},
  {id: 2199, en: "refrigerator", ko: "냉장고", level: 'intermediate'},
  {id: 2200, en: "refuse", ko: "거절하다", level: 'intermediate'},
  {id: 2201, en: "regard", ko: "주목해서 보다", level: 'intermediate'},
  {id: 2202, en: "region", ko: "지방", level: 'intermediate'},
  {id: 2203, en: "register", ko: "기록", level: 'intermediate'},
  {id: 2204, en: "regret", ko: "유감", level: 'intermediate'},
  {id: 2205, en: "regular", ko: "규칙적인", level: 'intermediate'},
  {id: 2206, en: "regulate", ko: "규정하다", level: 'advanced'},
  {id: 2207, en: "reinforce", ko: "보강하다", level: 'advanced'},
  {id: 2208, en: "reject", ko: "거절하다", level: 'intermediate'},
  {id: 2209, en: "relate", ko: "이야기하다", level: 'intermediate'},
  {id: 2210, en: "relative", ko: "친척", level: 'intermediate'},
  {id: 2211, en: "relax", ko: "늦추다", level: 'intermediate'},
  {id: 2212, en: "release", ko: "도와주다", level: 'intermediate'},
  {id: 2213, en: "relevant", ko: "관련된", level: 'advanced'},
  {id: 2214, en: "relieve", ko: "구출하다", level: 'intermediate'},
  {id: 2215, en: "religion", ko: "종교", level: 'intermediate'},
  {id: 2216, en: "reluctant", ko: "마음이 내키지 않는", level: 'advanced'},
  {id: 2217, en: "rely", ko: "믿다", level: 'intermediate'},
  {id: 2218, en: "remain", ko: "남다", level: 'intermediate'},
  {id: 2219, en: "remark", ko: "깨닫다", level: 'intermediate'},
  {id: 2220, en: "remedy", ko: "치료", level: 'intermediate'},
  {id: 2221, en: "remember", ko: "기억하고 있다", level: 'basic'},
  {id: 2222, en: "remind", ko: "생각나게 하다", level: 'intermediate'},
  {id: 2223, en: "remote", ko: "먼", level: 'intermediate'},
  {id: 2224, en: "remove", ko: "옮기다", level: 'intermediate'},
  {id: 2225, en: "rent", ko: "지대", level: 'intermediate'},
  {id: 2226, en: "repair", ko: "수선(수정)하다", level: 'intermediate'},
  {id: 2227, en: "repeat", ko: "반복하다", level: 'intermediate'},
  {id: 2228, en: "replace", ko: "되돌려 놓다", level: 'intermediate'},
  {id: 2229, en: "reply", ko: "대답하다", level: 'intermediate'},
  {id: 2230, en: "report", ko: "보고", level: 'intermediate'},
  {id: 2231, en: "represent", ko: "표현(묘사)하다", level: 'intermediate'},
  {id: 2232, en: "republic", ko: "공화국", level: 'intermediate'},
  {id: 2233, en: "reputation", ko: "평판", level: 'advanced'},
  {id: 2234, en: "request", ko: "부탁하다", level: 'intermediate'},
  {id: 2235, en: "require", ko: "요구하다", level: 'intermediate'},
  {id: 2236, en: "rescue", ko: "구하다", level: 'intermediate'},
  {id: 2237, en: "research", ko: "연구", level: 'intermediate'},
  {id: 2238, en: "resemble", ko: "닮다", level: 'intermediate'},
  {id: 2239, en: "reserve", ko: "따로 두다", level: 'intermediate'},
  {id: 2240, en: "reside", ko: "거주하다", level: 'advanced'},
  {id: 2241, en: "resign", ko: "사임하다", level: 'advanced'},
  {id: 2242, en: "resist", ko: "저항하다", level: 'intermediate'},
  {id: 2243, en: "resolve", ko: "분해하다", level: 'intermediate'},
  {id: 2244, en: "resort", ko: "(자주)가다", level: 'intermediate'},
  {id: 2245, en: "resource", ko: "자원", level: 'intermediate'},
  {id: 2246, en: "respect", ko: "존경하다", level: 'intermediate'},
  {id: 2247, en: "respective", ko: "각각의", level: 'advanced'},
  {id: 2248, en: "respond", ko: "대답하다", level: 'intermediate'},
  {id: 2249, en: "responsible", ko: "책임을 져야할", level: 'intermediate'},
  {id: 2250, en: "rest", ko: "휴식", level: 'intermediate'},
  {id: 2251, en: "restaurant", ko: "요리점", level: 'basic'},
  {id: 2252, en: "restore", ko: "반환하다", level: 'intermediate'},
  {id: 2253, en: "restrain", ko: "제지하다", level: 'advanced'},
  {id: 2254, en: "restrict", ko: "제한하다", level: 'advanced'},
  {id: 2255, en: "restroom", ko: "화장실", level: 'basic'},
  {id: 2256, en: "result", ko: "결과", level: 'intermediate'},
  {id: 2257, en: "resume", ko: "다시 잡다", level: 'advanced'},
  {id: 2258, en: "retail", ko: "소매", level: 'advanced'},
  {id: 2259, en: "retain", ko: "보유하다", level: 'advanced'},
  {id: 2260, en: "retire", ko: "퇴직하다", level: 'intermediate'},
  {id: 2261, en: "retreat", ko: "후퇴", level: 'advanced'},
  {id: 2262, en: "return", ko: "돌아가다", level: 'basic'},
  {id: 2263, en: "reveal", ko: "나타내다", level: 'intermediate'},
  {id: 2264, en: "revenge", ko: "복수", level: 'advanced'},
  {id: 2265, en: "reverse", ko: "역", level: 'advanced'},
  {id: 2266, en: "review", ko: "재조사", level: 'intermediate'},
  {id: 2267, en: "revise", ko: "교정하다", level: 'intermediate'},
  {id: 2268, en: "revive", ko: "소생하다", level: 'intermediate'},
  {id: 2269, en: "revolution", ko: "혁명", level: 'intermediate'},
  {id: 2270, en: "reward", ko: "보수", level: 'intermediate'},
  {id: 2271, en: "rhythm", ko: "율동", level: 'intermediate'},
  {id: 2272, en: "rice", ko: "쌀", level: 'intermediate'},
  {id: 2273, en: "rich", ko: "부자인", level: 'basic'},
  {id: 2274, en: "rid", ko: "면하게하다", level: 'advanced'},
  {id: 2275, en: "ride", ko: "타다", level: 'intermediate'},
  {id: 2276, en: "ridiculous", ko: "어리석은", level: 'advanced'},
  {id: 2277, en: "right", ko: "올바른", level: 'basic'},
  {id: 2278, en: "ring", ko: "고리", level: 'basic'},
  {id: 2279, en: "riot", ko: "폭동, 소요, 소동   야단법석, 다채로움,", level: 'advanced'},
  {id: 2280, en: "rise", ko: "올리다", level: 'intermediate'},
  {id: 2281, en: "risk", ko: "위험 걸다", level: 'intermediate'},
  {id: 2282, en: "rival", ko: "경쟁자 경쟁하는 경쟁하다", level: 'intermediate'},
  {id: 2283, en: "river", ko: "강", level: 'basic'},
  {id: 2284, en: "road", ko: "길", level: 'basic'},
  {id: 2285, en: "roar", ko: "으르렁거리다 으르렁소리", level: 'advanced'},
  {id: 2286, en: "roast", ko: "불에 쬐어 굽다 불고기 구운", level: 'intermediate'},
  {id: 2287, en: "rob", ko: "강탈하다, 약탈하다, 빼앗다", level: 'intermediate'},
  {id: 2288, en: "rock", ko: "바위", level: 'basic'},
  {id: 2289, en: "rod", ko: "막대", level: 'advanced'},
  {id: 2290, en: "role", ko: "(배우의)역", level: 'intermediate'},
  {id: 2291, en: "roll", ko: "구르다", level: 'intermediate'},
  {id: 2292, en: "romantic", ko: "전기소설적인", level: 'intermediate'},
  {id: 2293, en: "roof", ko: "지붕", level: 'basic'},
  {id: 2294, en: "room", ko: "방", level: 'basic'},
  {id: 2295, en: "root", ko: "뿌리", level: 'intermediate'},
  {id: 2296, en: "rope", ko: "새끼", level: 'intermediate'},
  {id: 2297, en: "rot", ko: "썩다", level: 'advanced'},
  {id: 2298, en: "rough", ko: "거친", level: 'intermediate'},
  {id: 2299, en: "round", ko: "둥근 원 돌아서", level: 'intermediate'},
  {id: 2300, en: "route", ko: "길", level: 'intermediate'},
  {id: 2301, en: "routine", ko: "정해진 일", level: 'intermediate'},
  {id: 2302, en: "row", ko: "줄", level: 'intermediate'},
  {id: 2303, en: "royal", ko: "왕의", level: 'intermediate'},
  {id: 2304, en: "rub", ko: "마찰하다", level: 'intermediate'},
  {id: 2305, en: "rubber", ko: "맛사지사", level: 'intermediate'},
  {id: 2306, en: "rude", ko: "버릇없는", level: 'intermediate'},
  {id: 2307, en: "ruin", ko: "파멸", level: 'intermediate'},
  {id: 2308, en: "rule", ko: "규칙", level: 'intermediate'},
  {id: 2309, en: "rumor", ko: "소문", level: 'intermediate'},
  {id: 2310, en: "run", ko: "달리다", level: 'basic'},
  {id: 2311, en: "rural", ko: "시골의", level: 'intermediate'},
  {id: 2312, en: "rush", ko: "돌진하다", level: 'intermediate'},
  {id: 2313, en: "sack", ko: "마대", level: 'advanced'},
  {id: 2314, en: "sacred", ko: "신성한", level: 'intermediate'},
  {id: 2315, en: "sacrifice", ko: "희생", level: 'intermediate'},
  {id: 2316, en: "sad", ko: "슬픈", level: 'basic'},
  {id: 2317, en: "safe", ko: "안전한", level: 'basic'},
  {id: 2318, en: "sail", ko: "돛", level: 'intermediate'},
  {id: 2319, en: "salary", ko: "봉급 봉급을 주다", level: 'intermediate'},
  {id: 2320, en: "sale", ko: "판매", level: 'basic'},
  {id: 2321, en: "salon", ko: "객실", level: 'advanced'},
  {id: 2322, en: "salt", ko: "소금", level: 'basic'},
  {id: 2323, en: "same", ko: "같은", level: 'basic'},
  {id: 2324, en: "sand", ko: "모래사장", level: 'basic'},
  {id: 2325, en: "satellite", ko: "위성", level: 'intermediate'},
  {id: 2326, en: "satisfy", ko: "만족시키다", level: 'intermediate'},
  {id: 2327, en: "save", ko: "위험에서 구하다", level: 'basic'},
  {id: 2328, en: "say", ko: "말하다", level: 'basic'},
  {id: 2329, en: "scale", ko: "비늘(모양의 것)", level: 'intermediate'},
  {id: 2330, en: "scan", ko: "시의 운율을살피다", level: 'intermediate'},
  {id: 2331, en: "scandal", ko: "추문", level: 'intermediate'},
  {id: 2332, en: "scarce", ko: "부족한", level: 'advanced'},
  {id: 2333, en: "scare", ko: "위협하다", level: 'intermediate'},
  {id: 2334, en: "scatter", ko: "뿔뿔이 흩어 버리다", level: 'advanced'},
  {id: 2335, en: "scene", ko: "장면", level: 'intermediate'},
  {id: 2336, en: "scheme", ko: "계획", level: 'intermediate'},
  {id: 2337, en: "scholar", ko: "학자", level: 'intermediate'},
  {id: 2338, en: "school", ko: "학교", level: 'basic'},
  {id: 2339, en: "science", ko: "과학", level: 'basic'},
  {id: 2340, en: "scissors", ko: "가위", level: 'basic'},
  {id: 2341, en: "scold", ko: "꾸짖다 잔소리 심한 사람", level: 'intermediate'},
  {id: 2342, en: "scope", ko: "범위", level: 'advanced'},
  {id: 2343, en: "score", ko: "득점", level: 'basic'},
  {id: 2344, en: "scramble", ko: "기다", level: 'intermediate'},
  {id: 2345, en: "scratch", ko: "할퀴다, 할퀴어 상처 를 내다  긁다", level: 'intermediate'},
  {id: 2346, en: "scream", ko: "비명을 지르다", level: 'intermediate'},
  {id: 2347, en: "screen", ko: "병풍", level: 'intermediate'},
  {id: 2348, en: "screw", ko: "나사", level: 'advanced'},
  {id: 2349, en: "scrub", ko: "(관목의)숲", level: 'advanced'},
  {id: 2350, en: "sculpture", ko: "조각 조각하다", level: 'advanced'},
  {id: 2351, en: "sea", ko: "바다", level: 'basic'},
  {id: 2352, en: "seal", ko: "인장", level: 'intermediate'},
  {id: 2353, en: "search", ko: "찾다", level: 'intermediate'},
  {id: 2354, en: "season", ko: "계절", level: 'basic'},
  {id: 2355, en: "seat", ko: "좌석", level: 'intermediate'},
  {id: 2356, en: "secret", ko: "비밀의", level: 'intermediate'},
  {id: 2357, en: "secretary", ko: "비서", level: 'intermediate'},
  {id: 2358, en: "sector", ko: "부채꼴", level: 'intermediate'},
  {id: 2359, en: "secure", ko: "안전한", level: 'intermediate'},
  {id: 2360, en: "see", ko: "보다", level: 'basic'},
  {id: 2361, en: "seed", ko: "씨앗", level: 'intermediate'},
  {id: 2362, en: "seek", ko: "찾다", level: 'intermediate'},
  {id: 2363, en: "seem", ko: "-으로 보이다", level: 'intermediate'},
  {id: 2364, en: "seize", ko: "붙잡다", level: 'advanced'},
  {id: 2365, en: "select", ko: "고르다", level: 'intermediate'},
  {id: 2366, en: "self", ko: "자기", level: 'intermediate'},
  {id: 2367, en: "sell", ko: "팔다", level: 'basic'},
  {id: 2368, en: "send", ko: "보내다", level: 'basic'},
  {id: 2369, en: "senior", ko: "연상의", level: 'intermediate'},
  {id: 2370, en: "sensation", ko: "감각", level: 'intermediate'},
  {id: 2371, en: "sense", ko: "감각", level: 'intermediate'},
  {id: 2372, en: "sensible", ko: "분별있는", level: 'intermediate'},
  {id: 2373, en: "sentence", ko: "문장", level: 'intermediate'},
  {id: 2374, en: "sentiment", ko: "정서", level: 'advanced'},
  {id: 2375, en: "separate", ko: "분리된", level: 'intermediate'},
  {id: 2376, en: "sequence", ko: "연속", level: 'advanced'},
  {id: 2377, en: "series", ko: "연속", level: 'intermediate'},
  {id: 2378, en: "serious", ko: "진지한", level: 'intermediate'},
  {id: 2379, en: "serve", ko: "섬기다", level: 'intermediate'},
  {id: 2380, en: "session", ko: "개회", level: 'intermediate'},
  {id: 2381, en: "settle", ko: "등받이가 높은 긴 의자 놓다", level: 'intermediate'},
  {id: 2382, en: "several", ko: "수개의", level: 'intermediate'},
  {id: 2383, en: "severe", ko: "호된", level: 'intermediate'},
  {id: 2384, en: "sew", ko: "꿰매다", level: 'intermediate'},
  {id: 2385, en: "sex", ko: "성", level: 'intermediate'},
  {id: 2386, en: "shade", ko: "그늘", level: 'intermediate'},
  {id: 2387, en: "shadow", ko: "그림자", level: 'intermediate'},
  {id: 2388, en: "shake", ko: "흔들어 움직이다", level: 'intermediate'},
  {id: 2389, en: "shall", ko: "-하겠다", level: 'intermediate'},
  {id: 2390, en: "shallow", ko: "얕은 얕은 곳 얕아지다", level: 'intermediate'},
  {id: 2391, en: "shame", ko: "부끄럼", level: 'intermediate'},
  {id: 2392, en: "shape", ko: "모양", level: 'intermediate'},
  {id: 2393, en: "share", ko: "몫", level: 'intermediate'},
  {id: 2394, en: "sharp", ko: "날카로운", level: 'intermediate'},
  {id: 2395, en: "shave", ko: "깎다", level: 'intermediate'},
  {id: 2396, en: "she", ko: "그녀는", level: 'basic'},
  {id: 2397, en: "sheep", ko: "양", level: 'intermediate'},
  {id: 2398, en: "sheet", ko: "깔천", level: 'intermediate'},
  {id: 2399, en: "shelf", ko: "선반", level: 'intermediate'},
  {id: 2400, en: "shell", ko: "겉껍질", level: 'intermediate'},
  {id: 2401, en: "shelter", ko: "피난처", level: 'advanced'},
  {id: 2402, en: "shield", ko: "방패", level: 'advanced'},
  {id: 2403, en: "shift", ko: "옮기다", level: 'intermediate'},
  {id: 2404, en: "shine", ko: "빛나다", level: 'intermediate'},
  {id: 2405, en: "ship", ko: "배", level: 'basic'},
  {id: 2406, en: "shock", ko: "격돌", level: 'basic'},
  {id: 2407, en: "shoe", ko: "구두", level: 'basic'},
  {id: 2408, en: "shoot", ko: "쏘다", level: 'intermediate'},
  {id: 2409, en: "shop", ko: "상점", level: 'basic'},
  {id: 2410, en: "shore", ko: "물가", level: 'intermediate'},
  {id: 2411, en: "short", ko: "짧은", level: 'basic'},
  {id: 2412, en: "should", ko: "[shall의 과거] ...해야 한다", level: 'basic'},
  {id: 2413, en: "shoulder", ko: "어깨", level: 'intermediate'},
  {id: 2414, en: "shout", ko: "외치다", level: 'intermediate'},
  {id: 2415, en: "show", ko: "보이다", level: 'basic'},
  {id: 2416, en: "shower", ko: "소나기 빗발치듯 퍼붓다(쏟다)", level: 'intermediate'},
  {id: 2417, en: "shrink", ko: "줄어들다", level: 'advanced'},
  {id: 2418, en: "shut", ko: "닫다", level: 'intermediate'},
  {id: 2419, en: "shy", ko: "수줍은", level: 'basic'},
  {id: 2420, en: "sick", ko: "병난", level: 'basic'},
  {id: 2421, en: "side", ko: "쪽", level: 'basic'},
  {id: 2422, en: "sigh", ko: "한숨", level: 'intermediate'},
  {id: 2423, en: "sight", ko: "광경", level: 'intermediate'},
  {id: 2424, en: "sign", ko: "부호", level: 'intermediate'},
  {id: 2425, en: "significant", ko: "중요한", level: 'intermediate'},
  {id: 2426, en: "silent", ko: "조용한", level: 'intermediate'},
  {id: 2427, en: "silk", ko: "비단", level: 'intermediate'},
  {id: 2428, en: "silly", ko: "어리석은 바보", level: 'intermediate'},
  {id: 2429, en: "silver", ko: "은", level: 'intermediate'},
  {id: 2430, en: "similar", ko: "유사한", level: 'intermediate'},
  {id: 2431, en: "simple", ko: "단일의", level: 'intermediate'},
  {id: 2432, en: "simulate", ko: "흉내내다", level: 'advanced'},
  {id: 2433, en: "simultaneous", ko: "동시에 일어나는(존재하는)", level: 'advanced'},
  {id: 2434, en: "sin", ko: "사인", level: 'intermediate'},
  {id: 2435, en: "since", ko: "-이래", level: 'intermediate'},
  {id: 2436, en: "sing", ko: "노래하다", level: 'basic'},
  {id: 2437, en: "single", ko: "단 하나의", level: 'intermediate'},
  {id: 2438, en: "sink", ko: "가라앉다", level: 'intermediate'},
  {id: 2439, en: "sister", ko: "여자형제", level: 'basic'},
  {id: 2440, en: "sit", ko: "앉다", level: 'basic'},
  {id: 2441, en: "site", ko: "부지", level: 'intermediate'},
  {id: 2442, en: "situation", ko: "장소", level: 'intermediate'},
  {id: 2443, en: "size", ko: "크기", level: 'basic'},
  {id: 2444, en: "skill", ko: "숙련", level: 'intermediate'},
  {id: 2445, en: "skin", ko: "피부", level: 'basic'},
  {id: 2446, en: "skip", ko: "도약", level: 'intermediate'},
  {id: 2447, en: "skirt", ko: "스커어트", level: 'basic'},
  {id: 2448, en: "sky", ko: "하늘", level: 'basic'},
  {id: 2449, en: "slaughter", ko: "도살", level: 'advanced'},
  {id: 2450, en: "slave", ko: "노예 노예처럼 일하다", level: 'intermediate'},
  {id: 2451, en: "sleep", ko: "잠자다", level: 'basic'},
  {id: 2452, en: "slice", ko: "얇은조각", level: 'intermediate'},
  {id: 2453, en: "slide", ko: "미끄러지다", level: 'intermediate'},
  {id: 2454, en: "slight", ko: "약간의", level: 'advanced'},
  {id: 2455, en: "slim", ko: "호리호리한", level: 'intermediate'},
  {id: 2456, en: "slip", ko: "(때가)어느덧 지나가다", level: 'intermediate'},
  {id: 2457, en: "slope", ko: "비탈", level: 'advanced'},
  {id: 2458, en: "slow", ko: "느린", level: 'basic'},
  {id: 2459, en: "small", ko: "작은 작은 부분 적게", level: 'basic'},
  {id: 2460, en: "smart", ko: "재치있는", level: 'basic'},
  {id: 2461, en: "smash", ko: "박살내다", level: 'intermediate'},
  {id: 2462, en: "smell", ko: "냄새", level: 'basic'},
  {id: 2463, en: "smile", ko: "미소짓다 미소", level: 'basic'},
  {id: 2464, en: "smoke", ko: "연기", level: 'intermediate'},
  {id: 2465, en: "smooth", ko: "매끄러운", level: 'intermediate'},
  {id: 2466, en: "snake", ko: "뱀", level: 'intermediate'},
  {id: 2467, en: "snap", ko: "덥석 물다", level: 'intermediate'},
  {id: 2468, en: "sneak", ko: "몰래 움직이다", level: 'advanced'},
  {id: 2469, en: "sniff", ko: "코를 킁킁거리다", level: 'advanced'},
  {id: 2470, en: "snow", ko: "눈 눈이 내리다", level: 'basic'},
  {id: 2471, en: "so", ko: "그와 같이", level: 'basic'},
  {id: 2472, en: "soak", ko: "담그다", level: 'intermediate'},
  {id: 2473, en: "soap", ko: "비누 비누로 씻다", level: 'intermediate'},
  {id: 2474, en: "soccer", ko: "축구", level: 'basic'},
  {id: 2475, en: "social", ko: "사회의", level: 'intermediate'},
  {id: 2476, en: "society", ko: "사회", level: 'intermediate'},
  {id: 2477, en: "sociology", ko: "사회학", level: 'intermediate'},
  {id: 2478, en: "sock", ko: "짧은 양말", level: 'basic'},
  {id: 2479, en: "soft", ko: "부드러운", level: 'basic'},
  {id: 2480, en: "software", ko: "소프트웨어", level: 'intermediate'},
  {id: 2481, en: "soil", ko: "흙", level: 'intermediate'},
  {id: 2482, en: "soldier", ko: "군인", level: 'intermediate'},
  {id: 2483, en: "sole", ko: "유일한 발바닥", level: 'advanced'},
  {id: 2484, en: "solid", ko: "고체의", level: 'intermediate'},
  {id: 2485, en: "solo", ko: "독주", level: 'intermediate'},
  {id: 2486, en: "solve", ko: "해결하다", level: 'intermediate'},
  {id: 2487, en: "some", ko: "얼만가의", level: 'basic'},
  {id: 2488, en: "somewhat", ko: "약간", level: 'intermediate'},
  {id: 2489, en: "son", ko: "아들", level: 'basic'},
  {id: 2490, en: "song", ko: "노래", level: 'basic'},
  {id: 2491, en: "soon", ko: "얼마 안 가서", level: 'intermediate'},
  {id: 2492, en: "sophisticated", ko: "물정에 닳고 닳은", level: 'advanced'},
  {id: 2493, en: "sore", ko: "슬픈", level: 'intermediate'},
  {id: 2494, en: "sorry", ko: "가엾은", level: 'basic'},
  {id: 2495, en: "sort", ko: "종류", level: 'intermediate'},
  {id: 2496, en: "soul", ko: "혼", level: 'intermediate'},
  {id: 2497, en: "sound", ko: "소리", level: 'basic'},
  {id: 2498, en: "sour", ko: "시큼한 시어지다 시큼한 것", level: 'basic'},
  {id: 2499, en: "source", ko: "원천", level: 'intermediate'},
  {id: 2500, en: "south", ko: "남쪽 남쪽의 남으로", level: 'basic'},
  {id: 2501, en: "space", ko: "공간", level: 'basic'},
  {id: 2502, en: "span", ko: "한 뼘", level: 'advanced'},
  {id: 2503, en: "spare", ko: "여분의", level: 'intermediate'},
  {id: 2504, en: "spark", ko: "불꽃", level: 'intermediate'},
  {id: 2505, en: "speak", ko: "이야기하다", level: 'basic'},
  {id: 2506, en: "special", ko: "특별한", level: 'intermediate'},
  {id: 2507, en: "species", ko: "종", level: 'intermediate'},
  {id: 2508, en: "specific", ko: "특정한", level: 'intermediate'},
  {id: 2509, en: "spectacle", ko: "광경", level: 'advanced'},
  {id: 2510, en: "spectrum", ko: "스펙트럼", level: 'advanced'},
  {id: 2511, en: "speech", ko: "연설", level: 'intermediate'},
  {id: 2512, en: "speed", ko: "속도", level: 'basic'},
  {id: 2513, en: "spell", ko: "철자하다", level: 'intermediate'},
  {id: 2514, en: "spend", ko: "소비하다", level: 'intermediate'},
  {id: 2515, en: "sphere", ko: "구", level: 'advanced'},
  {id: 2516, en: "spill", ko: "엎지르다", level: 'advanced'},
  {id: 2517, en: "spin", ko: "잣다", level: 'intermediate'},
  {id: 2518, en: "spirit", ko: "정신", level: 'intermediate'},
  {id: 2519, en: "spit", ko: "침을 뱉다", level: 'advanced'},
  {id: 2520, en: "spite", ko: "악의", level: 'advanced'},
  {id: 2521, en: "splash", ko: "튀기다", level: 'advanced'},
  {id: 2522, en: "split", ko: "쪼개다", level: 'advanced'},
  {id: 2523, en: "spoil", ko: "망쳐놓다", level: 'intermediate'},
  {id: 2524, en: "spoon", ko: "숟가락", level: 'basic'},
  {id: 2525, en: "spot", ko: "장소", level: 'intermediate'},
  {id: 2526, en: "spouse", ko: "배우자", level: 'advanced'},
  {id: 2527, en: "spread", ko: "펴다", level: 'intermediate'},
  {id: 2528, en: "square", ko: "정사각형의", level: 'intermediate'},
  {id: 2529, en: "squeeze", ko: "압착하다", level: 'intermediate'},
  {id: 2530, en: "stable", ko: "안정된", level: 'intermediate'},
  {id: 2531, en: "stack", ko: "낟가리", level: 'advanced'},
  {id: 2532, en: "stage", ko: "무대", level: 'intermediate'},
  {id: 2533, en: "stain", ko: "더럽히다", level: 'intermediate'},
  {id: 2534, en: "stairs", ko: "계단", level: 'intermediate'},
  {id: 2535, en: "stamp", ko: "도장", level: 'intermediate'},
  {id: 2536, en: "stand", ko: "서다", level: 'basic'},
  {id: 2537, en: "standard", ko: "표준", level: 'intermediate'},
  {id: 2538, en: "stare", ko: "응시하다", level: 'intermediate'},
  {id: 2539, en: "start", ko: "시작하다", level: 'basic'},
  {id: 2540, en: "starve", ko: "굶어 죽다", level: 'advanced'},
  {id: 2541, en: "state", ko: "상태", level: 'intermediate'},
  {id: 2542, en: "station", ko: "역", level: 'intermediate'},
  {id: 2543, en: "statistic", ko: "통계의 통계량", level: 'advanced'},
  {id: 2544, en: "statue", ko: "조상", level: 'intermediate'},
  {id: 2545, en: "status", ko: "신분", level: 'intermediate'},
  {id: 2546, en: "stay", ko: "머무르다", level: 'basic'},
  {id: 2547, en: "steady", ko: "확고한", level: 'intermediate'},
  {id: 2548, en: "steal", ko: "훔치다", level: 'intermediate'},
  {id: 2549, en: "steam", ko: "증기", level: 'intermediate'},
  {id: 2550, en: "steel", ko: "강철", level: 'intermediate'},
  {id: 2551, en: "steep", ko: "가파른 -에 담그다 잠기다 담그기", level: 'advanced'},
  {id: 2552, en: "stem", ko: "줄기", level: 'intermediate'},
  {id: 2553, en: "step", ko: "걷다", level: 'intermediate'},
  {id: 2554, en: "stick", ko: "나무토막", level: 'intermediate'},
  {id: 2555, en: "stiff", ko: "굳은", level: 'advanced'},
  {id: 2556, en: "still", ko: "소리가 없는 아직(도)", level: 'intermediate'},
  {id: 2557, en: "stimulate", ko: "자극하다", level: 'advanced'},
  {id: 2558, en: "stir", ko: "휘젓다", level: 'advanced'},
  {id: 2559, en: "stitch", ko: "한 바늘", level: 'advanced'},
  {id: 2560, en: "stock", ko: "줄기", level: 'intermediate'},
  {id: 2561, en: "stomach", ko: "위", level: 'intermediate'},
  {id: 2562, en: "stone", ko: "돌", level: 'basic'},
  {id: 2563, en: "stop", ko: "멈추다", level: 'basic'},
  {id: 2564, en: "store", ko: "가게", level: 'basic'},
  {id: 2565, en: "storm", ko: "폭풍", level: 'intermediate'},
  {id: 2566, en: "story", ko: "이야기, (건물의)층", level: 'basic'},
  {id: 2567, en: "stove", ko: "stave의 과거(분사)", level: 'intermediate'},
  {id: 2568, en: "straight", ko: "곧은", level: 'intermediate'},
  {id: 2569, en: "strain", ko: "잡아당기다", level: 'advanced'},
  {id: 2570, en: "strange", ko: "이상한", level: 'intermediate'},
  {id: 2571, en: "strategy", ko: "용병학", level: 'intermediate'},
  {id: 2572, en: "straw", ko: "짚", level: 'intermediate'},
  {id: 2573, en: "strawberry", ko: "딸기", level: 'basic'},
  {id: 2574, en: "stream", ko: "시내", level: 'intermediate'},
  {id: 2575, en: "street", ko: "거리", level: 'basic'},
  {id: 2576, en: "stress", ko: "압박", level: 'basic'},
  {id: 2577, en: "stretch", ko: "뻗치다", level: 'intermediate'},
  {id: 2578, en: "strict", ko: "엄중한", level: 'intermediate'},
  {id: 2579, en: "strike", ko: "치다", level: 'intermediate'},
  {id: 2580, en: "string", ko: "끈", level: 'intermediate'},
  {id: 2581, en: "strip", ko: "벗기다", level: 'advanced'},
  {id: 2582, en: "stripe", ko: "줄무늬", level: 'intermediate'},
  {id: 2583, en: "stroke", ko: "한번치기", level: 'advanced'},
  {id: 2584, en: "strong", ko: "강한", level: 'basic'},
  {id: 2585, en: "structure", ko: "구조", level: 'intermediate'},
  {id: 2586, en: "struggle", ko: "버둥거리다", level: 'intermediate'},
  {id: 2587, en: "student", ko: "학생", level: 'basic'},
  {id: 2588, en: "study", ko: "학문", level: 'basic'},
  {id: 2589, en: "stuff", ko: "재료", level: 'intermediate'},
  {id: 2590, en: "subject", ko: "복종시키다", level: 'intermediate'},
  {id: 2591, en: "subjective", ko: "주관의", level: 'advanced'},
  {id: 2592, en: "submarine", ko: "잠수함", level: 'intermediate'},
  {id: 2593, en: "submit", ko: "복종시키다", level: 'advanced'},
  {id: 2594, en: "subscribe", ko: "서명승락하다", level: 'advanced'},
  {id: 2595, en: "substance", ko: "물질", level: 'advanced'},
  {id: 2596, en: "substantial", ko: "실체의", level: 'advanced'},
  {id: 2597, en: "substitute", ko: "대용하다 대신하다 대리(인)", level: 'advanced'},
  {id: 2598, en: "subtle", ko: "미묘한", level: 'advanced'},
  {id: 2599, en: "suburb", ko: "교외", level: 'intermediate'},
  {id: 2600, en: "subway", ko: "지하도", level: 'basic'},
  {id: 2601, en: "succeed", ko: "성공하다", level: 'intermediate'},
  {id: 2602, en: "such", ko: "이러한", level: 'intermediate'},
  {id: 2603, en: "suck", ko: "빨다", level: 'advanced'},
  {id: 2604, en: "sudden", ko: "별안간의", level: 'intermediate'},
  {id: 2605, en: "suffer", ko: "경험하다", level: 'intermediate'},
  {id: 2606, en: "sufficient", ko: "충분한", level: 'intermediate'},
  {id: 2607, en: "sugar", ko: "설탕", level: 'basic'},
  {id: 2608, en: "suggest", ko: "암시하다", level: 'intermediate'},
  {id: 2609, en: "suicide", ko: "자살 자살하다", level: 'intermediate'},
  {id: 2610, en: "suit", ko: "소송", level: 'intermediate'},
  {id: 2611, en: "suite", ko: "수행원", level: 'advanced'},
  {id: 2612, en: "sum", ko: "총계", level: 'intermediate'},
  {id: 2613, en: "summary", ko: "요약", level: 'intermediate'},
  {id: 2614, en: "summit", ko: "꼭대기", level: 'intermediate'},
  {id: 2615, en: "sun", ko: "태양", level: 'basic'},
  {id: 2616, en: "super", ko: "임시고용배우", level: 'intermediate'},
  {id: 2617, en: "superb", ko: "장려한", level: 'intermediate'},
  {id: 2618, en: "superior", ko: "뛰어난", level: 'intermediate'},
  {id: 2619, en: "supervise", ko: "감독하다", level: 'advanced'},
  {id: 2620, en: "supper", ko: "저녁식사", level: 'basic'},
  {id: 2621, en: "supplement", ko: "부록", level: 'advanced'},
  {id: 2622, en: "supply", ko: "공급하다", level: 'intermediate'},
  {id: 2623, en: "support", ko: "지탱하다", level: 'intermediate'},
  {id: 2624, en: "suppose", ko: "상상하다", level: 'intermediate'},
  {id: 2625, en: "sure", ko: "확신하는, 확실한 , 틀림없는", level: 'intermediate'},
  {id: 2626, en: "surface", ko: "표면", level: 'intermediate'},
  {id: 2627, en: "surgery", ko: "외과", level: 'intermediate'},
  {id: 2628, en: "surprise", ko: "놀람", level: 'intermediate'},
  {id: 2629, en: "surrender", ko: "넘겨주다", level: 'advanced'},
  {id: 2630, en: "surround", ko: "에워싸다", level: 'intermediate'},
  {id: 2631, en: "survey", ko: "둘러보다", level: 'intermediate'},
  {id: 2632, en: "survive", ko: "살아 남다", level: 'intermediate'},
  {id: 2633, en: "suspect", ko: "짐작하다", level: 'intermediate'},
  {id: 2634, en: "suspend", ko: "매달다", level: 'advanced'},
  {id: 2635, en: "sustain", ko: "떠받치다", level: 'advanced'},
  {id: 2636, en: "swallow", ko: "삼키다", level: 'intermediate'},
  {id: 2637, en: "swear", ko: "맹세하다", level: 'advanced'},
  {id: 2638, en: "sweat", ko: "땀", level: 'intermediate'},
  {id: 2639, en: "sweep", ko: "청소하다", level: 'advanced'},
  {id: 2640, en: "sweet", ko: "단", level: 'intermediate'},
  {id: 2641, en: "swell", ko: "부풀다", level: 'advanced'},
  {id: 2642, en: "swift", ko: "빠른", level: 'advanced'},
  {id: 2643, en: "swim", ko: "헤엄치다", level: 'basic'},
  {id: 2644, en: "swing", ko: "흔들리다", level: 'intermediate'},
  {id: 2645, en: "switch", ko: "회초리", level: 'intermediate'},
  {id: 2646, en: "symbol", ko: "상징", level: 'intermediate'},
  {id: 2647, en: "sympathy", ko: "동정", level: 'intermediate'},
  {id: 2648, en: "symphony", ko: "교향곡", level: 'intermediate'},
  {id: 2649, en: "symptom", ko: "조짐", level: 'intermediate'},
  {id: 2650, en: "system", ko: "조직", level: 'intermediate'},
  {id: 2651, en: "table", ko: "테이블", level: 'basic'},
  {id: 2652, en: "tackle", ko: "고패", level: 'intermediate'},
  {id: 2653, en: "tag", ko: "손잡이가죽", level: 'intermediate'},
  {id: 2654, en: "tail", ko: "꼬리", level: 'basic'},
  {id: 2655, en: "take", ko: "잡다", level: 'basic'},
  {id: 2656, en: "tale", ko: "이야기", level: 'intermediate'},
  {id: 2657, en: "talent", ko: "재주", level: 'intermediate'},
  {id: 2658, en: "talk", ko: "말하다", level: 'basic'},
  {id: 2659, en: "tall", ko: "키큰", level: 'basic'},
  {id: 2660, en: "tap", ko: "가볍게 치기", level: 'intermediate'},
  {id: 2661, en: "tape", ko: "테이프", level: 'basic'},
  {id: 2662, en: "target", ko: "과녁", level: 'intermediate'},
  {id: 2663, en: "task", ko: "일", level: 'intermediate'},
  {id: 2664, en: "taste", ko: "맛", level: 'basic'},
  {id: 2665, en: "tattoo", ko: "귀영나팔", level: 'intermediate'},
  {id: 2666, en: "tax", ko: "세금", level: 'intermediate'},
  {id: 2667, en: "tea", ko: "차", level: 'intermediate'},
  {id: 2668, en: "teach", ko: "가르치다", level: 'basic'},
  {id: 2669, en: "tear", ko: "눈물", level: 'intermediate'},
  {id: 2670, en: "tease", ko: "괴롭히다", level: 'advanced'},
  {id: 2671, en: "teen", ko: "슬픔", level: 'basic'},
  {id: 2672, en: "teenage", ko: "10대", level: 'intermediate'},
  {id: 2673, en: "telegraph", ko: "전신", level: 'advanced'},
  {id: 2674, en: "telephone", ko: "전화", level: 'basic'},
  {id: 2675, en: "tell", ko: "말하다", level: 'basic'},
  {id: 2676, en: "temperature", ko: "온도", level: 'intermediate'},
  {id: 2677, en: "temple", ko: "관자놀이", level: 'intermediate'},
  {id: 2678, en: "temporary", ko: "일시적인", level: 'advanced'},
  {id: 2679, en: "tempt", ko: "유혹하다", level: 'advanced'},
  {id: 2680, en: "tenant", ko: "차지인", level: 'advanced'},
  {id: 2681, en: "tend", ko: "(-의)경향이 있다", level: 'intermediate'},
  {id: 2682, en: "tender", ko: "제공", level: 'intermediate'},
  {id: 2683, en: "tense", ko: "시제", level: 'intermediate'},
  {id: 2684, en: "term", ko: "기간", level: 'intermediate'},
  {id: 2685, en: "terminal", ko: "종점의", level: 'intermediate'},
  {id: 2686, en: "terminate", ko: "끝내다", level: 'advanced'},
  {id: 2687, en: "terrace", ko: "계단모양의 뜰(광장)", level: 'advanced'},
  {id: 2688, en: "terrible", ko: "무시무시한", level: 'intermediate'},
  {id: 2689, en: "terrific", ko: "무서운", level: 'intermediate'},
  {id: 2690, en: "territory", ko: "영토", level: 'intermediate'},
  {id: 2691, en: "test", ko: "시험", level: 'basic'},
  {id: 2692, en: "testify", ko: "증명하다", level: 'advanced'},
  {id: 2693, en: "text", ko: "원문", level: 'intermediate'},
  {id: 2694, en: "textbook", ko: "교과서", level: 'basic'},
  {id: 2695, en: "than", ko: "-보다도", level: 'basic'},
  {id: 2696, en: "thank", ko: "감사하다 감사", level: 'basic'},
  {id: 2697, en: "that", ko: "저", level: 'basic'},
  {id: 2698, en: "the", ko: "art.저", level: 'basic'},
  {id: 2699, en: "theater", ko: "=theatre 극장", level: 'intermediate'},
  {id: 2700, en: "theme", ko: "논제", level: 'intermediate'},
  {id: 2701, en: "then", ko: "그때", level: 'intermediate'},
  {id: 2702, en: "theory", ko: "이론", level: 'intermediate'},
  {id: 2703, en: "therapy", ko: "치료법", level: 'advanced'},
  {id: 2704, en: "there", ko: "거기에", level: 'basic'},
  {id: 2705, en: "therefore", ko: "그런 까닭에", level: 'intermediate'},
  {id: 2706, en: "they", ko: "그들", level: 'basic'},
  {id: 2707, en: "thick", ko: "두꺼운", level: 'intermediate'},
  {id: 2708, en: "thief", ko: "도둑", level: 'intermediate'},
  {id: 2709, en: "thin", ko: "얇은", level: 'intermediate'},
  {id: 2710, en: "thing", ko: "물건", level: 'basic'},
  {id: 2711, en: "think", ko: "생각하다", level: 'basic'},
  {id: 2712, en: "thirst", ko: "갈증", level: 'basic'},
  {id: 2713, en: "this", ko: "이, 이것", level: 'basic'},
  {id: 2714, en: "thorough", ko: "완전한", level: 'intermediate'},
  {id: 2715, en: "though", ko: "-임에도 불구하고 그러나", level: 'intermediate'},
  {id: 2716, en: "thousand", ko: "천(1000)", level: 'intermediate'},
  {id: 2717, en: "thread", ko: "실", level: 'advanced'},
  {id: 2718, en: "threat", ko: "협박", level: 'intermediate'},
  {id: 2719, en: "thrill", ko: "오싹하다 오싹함", level: 'intermediate'},
  {id: 2720, en: "throat", ko: "목", level: 'intermediate'},
  {id: 2721, en: "through", ko: "(-을)통하여 통하여 직통의", level: 'intermediate'},
  {id: 2722, en: "throw", ko: "던지다", level: 'intermediate'},
  {id: 2723, en: "thumb", ko: "엄지손가락 엄지손가락으로 만지다", level: 'intermediate'},
  {id: 2724, en: "thus", ko: "이렇게", level: 'intermediate'},
  {id: 2725, en: "tick", ko: "시계소리", level: 'advanced'},
  {id: 2726, en: "tide", ko: "조수", level: 'intermediate'},
  {id: 2727, en: "tidy", ko: "말쑥한", level: 'intermediate'},
  {id: 2728, en: "tie", ko: "매다", level: 'intermediate'},
  {id: 2729, en: "tiger", ko: "호랑이", level: 'basic'},
  {id: 2730, en: "tight", ko: "단단한", level: 'intermediate'},
  {id: 2731, en: "till", ko: "-까지", level: 'intermediate'},
  {id: 2732, en: "timber", ko: "수목, 목재, 재목", level: 'advanced'},
  {id: 2733, en: "time", ko: "때", level: 'basic'},
  {id: 2734, en: "tin", ko: "주석", level: 'intermediate'},
  {id: 2735, en: "tiny", ko: "자그마한", level: 'intermediate'},
  {id: 2736, en: "tip", ko: "끝", level: 'intermediate'},
  {id: 2737, en: "tire", ko: "피로하게 하다", level: 'intermediate'},
  {id: 2738, en: "tissue", ko: "조직", level: 'intermediate'},
  {id: 2739, en: "title", ko: "표제", level: 'intermediate'},
  {id: 2740, en: "to", ko: "-로", level: 'basic'},
  {id: 2741, en: "tobacco", ko: "담배", level: 'intermediate'},
  {id: 2742, en: "today", ko: "오늘은", level: 'basic'},
  {id: 2743, en: "toe", ko: "발가락", level: 'intermediate'},
  {id: 2744, en: "together", ko: "같이", level: 'basic'},
  {id: 2745, en: "toilet", ko: "화장실", level: 'intermediate'},
  {id: 2746, en: "tomorrow", ko: "내일(은)", level: 'basic'},
  {id: 2747, en: "tone", ko: "음조", level: 'intermediate'},
  {id: 2748, en: "tongue", ko: "혀", level: 'intermediate'},
  {id: 2749, en: "tonight", ko: "오늘밤에 오늘밤", level: 'basic'},
  {id: 2750, en: "too", ko: "(-도)또한", level: 'basic'},
  {id: 2751, en: "tool", ko: "사용세", level: 'intermediate'},
  {id: 2752, en: "tooth", ko: "이", level: 'basic'},
  {id: 2753, en: "top", ko: "정상", level: 'basic'},
  {id: 2754, en: "torture", ko: "고문", level: 'advanced'},
  {id: 2755, en: "toss", ko: "던지다", level: 'intermediate'},
  {id: 2756, en: "total", ko: "총계 전체의 합계하다", level: 'intermediate'},
  {id: 2757, en: "touch", ko: "닿다", level: 'basic'},
  {id: 2758, en: "tough", ko: "단단한", level: 'intermediate'},
  {id: 2759, en: "tour", ko: "일주", level: 'basic'},
  {id: 2760, en: "toward", ko: "-쪽으로", level: 'intermediate'},
  {id: 2761, en: "tower", ko: "탑", level: 'basic'},
  {id: 2762, en: "town", ko: "읍", level: 'basic'},
  {id: 2763, en: "toxic", ko: "독의", level: 'intermediate'},
  {id: 2764, en: "toy", ko: "장난감 장난하다", level: 'basic'},
  {id: 2765, en: "trace", ko: "발자국", level: 'intermediate'},
  {id: 2766, en: "trade", ko: "매매", level: 'intermediate'},
  {id: 2767, en: "tradition", ko: "전설", level: 'intermediate'},
  {id: 2768, en: "traffic", ko: "교통", level: 'intermediate'},
  {id: 2769, en: "tragic", ko: "비극의", level: 'intermediate'},
  {id: 2770, en: "trail", ko: "질질 끌다", level: 'advanced'},
  {id: 2771, en: "train", ko: "기차", level: 'basic'},
  {id: 2772, en: "transact", ko: "처리하다", level: 'advanced'},
  {id: 2773, en: "transfer", ko: "옮기다", level: 'intermediate'},
  {id: 2774, en: "transform", ko: "변형(변용,변태)시키다", level: 'intermediate'},
  {id: 2775, en: "transition", ko: "변천", level: 'advanced'},
  {id: 2776, en: "translate", ko: "번역하다", level: 'intermediate'},
  {id: 2777, en: "transmit", ko: "보내다", level: 'advanced'},
  {id: 2778, en: "transport", ko: "수송(운송)하다", level: 'intermediate'},
  {id: 2779, en: "trap", ko: "덫", level: 'intermediate'},
  {id: 2780, en: "travel", ko: "여행하다", level: 'basic'},
  {id: 2781, en: "tray", ko: "쟁반", level: 'intermediate'},
  {id: 2782, en: "treasure", ko: "보물", level: 'intermediate'},
  {id: 2783, en: "treat", ko: "대우하다", level: 'intermediate'},
  {id: 2784, en: "treaty", ko: "조약", level: 'advanced'},
  {id: 2785, en: "tree", ko: "나무", level: 'basic'},
  {id: 2786, en: "tremendous", ko: "무서운", level: 'advanced'},
  {id: 2787, en: "trend", ko: "동향, 추세", level: 'intermediate'},
  {id: 2788, en: "trial", ko: "시험", level: 'intermediate'},
  {id: 2789, en: "triangle", ko: "삼각형", level: 'basic'},
  {id: 2790, en: "tribe", ko: "종족", level: 'intermediate'},
  {id: 2791, en: "trick", ko: "책략", level: 'intermediate'},
  {id: 2792, en: "trigger", ko: "방아쇠 재빠른", level: 'advanced'},
  {id: 2793, en: "trim", ko: "산뜻한 정돈하다", level: 'advanced'},
  {id: 2794, en: "trip", ko: "여행", level: 'basic'},
  {id: 2795, en: "triumph", ko: "승리", level: 'intermediate'},
  {id: 2796, en: "troop", ko: "병력, 군대", level: 'intermediate'},
  {id: 2797, en: "trophy", ko: "전리품", level: 'intermediate'},
  {id: 2798, en: "trouble", ko: "고생", level: 'intermediate'},
  {id: 2799, en: "trouser", ko: "돈을 좀 받다[벌다], 바지", level: 'intermediate'},
  {id: 2800, en: "true", ko: "진실", level: 'basic'},
  {id: 2801, en: "trunk", ko: "줄기", level: 'intermediate'},
  {id: 2802, en: "trust", ko: "신용", level: 'intermediate'},
  {id: 2803, en: "truth", ko: "진리", level: 'intermediate'},
  {id: 2804, en: "try", ko: "시험해보다", level: 'basic'},
  {id: 2805, en: "tube", ko: "관", level: 'intermediate'},
  {id: 2806, en: "tune", ko: "곡, 곡조", level: 'intermediate'},
  {id: 2807, en: "tunnel", ko: "터널", level: 'intermediate'},
  {id: 2808, en: "turn", ko: "돌리다", level: 'basic'},
  {id: 2809, en: "turnover", ko: "전복", level: 'advanced'},
  {id: 2810, en: "tutor", ko: "가정교사", level: 'intermediate'},
  {id: 2811, en: "twice", ko: "두 번", level: 'basic'},
  {id: 2812, en: "twin", ko: "쌍동이", level: 'intermediate'},
  {id: 2813, en: "twist", ko: "꼬이다", level: 'intermediate'},
  {id: 2814, en: "type", ko: "형(태), 유형", level: 'basic'},
  {id: 2815, en: "typical", ko: "전형적인", level: 'intermediate'},
  {id: 2816, en: "ugly", ko: "못생긴, 추한", level: 'basic'},
  {id: 2817, en: "ultimate", ko: "궁극적인, 최후의", level: 'intermediate'},
  {id: 2818, en: "umbrella", ko: "우산", level: 'basic'},
  {id: 2819, en: "uncle", ko: "아저씨", level: 'basic'},
  {id: 2820, en: "under", ko: "-아래에", level: 'basic'},
  {id: 2821, en: "undergo", ko: "(영향 등을)받다", level: 'advanced'},
  {id: 2822, en: "underlie", ko: "-의 밑에 있다", level: 'advanced'},
  {id: 2823, en: "undermine", ko: "약화시키다, -밑을 파다", level: 'advanced'},
  {id: 2824, en: "understand", ko: "이해하다", level: 'basic'},
  {id: 2825, en: "undertake", ko: "떠맡다", level: 'advanced'},
  {id: 2826, en: "uniform", ko: "제복, 한결같은", level: 'intermediate'},
  {id: 2827, en: "unify", ko: "하나로 하다", level: 'intermediate'},
  {id: 2828, en: "union", ko: "결합", level: 'intermediate'},
  {id: 2829, en: "unique", ko: "유일무이한", level: 'intermediate'},
  {id: 2830, en: "unit", ko: "단위", level: 'intermediate'},
  {id: 2831, en: "unite", ko: "결합하다", level: 'intermediate'},
  {id: 2832, en: "universe", ko: "우주", level: 'intermediate'},
  {id: 2833, en: "university", ko: "대학", level: 'intermediate'},
  {id: 2834, en: "unless", ko: "-하지 않으면", level: 'intermediate'},
  {id: 2835, en: "until", ko: "-까지", level: 'intermediate'},
  {id: 2836, en: "up", ko: "위로", level: 'basic'},
  {id: 2837, en: "update", ko: "새롭게 하다 최신정보", level: 'intermediate'},
  {id: 2838, en: "upon", ko: "-의 위에", level: 'intermediate'},
  {id: 2839, en: "upper", ko: "위쪽의", level: 'intermediate'},
  {id: 2840, en: "upset", ko: "뒤집어 엎다", level: 'intermediate'},
  {id: 2841, en: "upward", ko: "위로 향한", level: 'intermediate'},
  {id: 2842, en: "urban", ko: "도시의", level: 'intermediate'},
  {id: 2843, en: "urge", ko: "몰아대다", level: 'intermediate'},
  {id: 2844, en: "urgent", ko: "긴급한", level: 'intermediate'},
  {id: 2845, en: "use", ko: "쓰다", level: 'basic'},
  {id: 2846, en: "usual", ko: "평소의", level: 'intermediate'},
  {id: 2847, en: "utilize", ko: "-을 이용하다", level: 'advanced'},
  {id: 2848, en: "utter", ko: "전적인", level: 'advanced'},
  {id: 2849, en: "vacation", ko: "휴가", level: 'intermediate'},
  {id: 2850, en: "vacuum", ko: "진공", level: 'intermediate'},
  {id: 2851, en: "vague", ko: "막연한", level: 'advanced'},
  {id: 2852, en: "valid", ko: "유효한", level: 'advanced'},
  {id: 2853, en: "valley", ko: "골짜기", level: 'intermediate'},
  {id: 2854, en: "value", ko: "가치", level: 'intermediate'},
  {id: 2855, en: "van", ko: "유개 화물차, 밴, 승합차", level: 'intermediate'},
  {id: 2856, en: "vanish", ko: "자취를 감추다", level: 'advanced'},
  {id: 2857, en: "various", ko: "여러 가지의, 다양한", level: 'intermediate'},
  {id: 2858, en: "vary", ko: "바꾸다", level: 'intermediate'},
  {id: 2859, en: "vast", ko: "광대한, 광막한 막대한", level: 'intermediate'},
  {id: 2860, en: "vegetable", ko: "식물, 야채, 채소", level: 'basic'},
  {id: 2861, en: "vehicle", ko: "운반 기구, 운송 수단, 수레, 차량, 탈것", level: 'intermediate'},
  {id: 2862, en: "venture", ko: "모험", level: 'intermediate'},
  {
    id: 2863,
    en: "verbal",
    ko: "말의, 말에 관한, 언어상의, 말로 나타낸, 말로 된",
    level: 'advanced'
  },
  {id: 2864, en: "verse", ko: "시의 한 줄, 시구  일련의 시구", level: 'advanced'},
  {id: 2865, en: "version", ko: "번역, 번역문 개작, 각색, 번안", level: 'intermediate'},
  {id: 2866, en: "versus", ko: "…대, …에 대한", level: 'intermediate'},
  {id: 2867, en: "vertical", ko: "수평면에 직각인, 수직의", level: 'advanced'},
  {id: 2868, en: "very", ko: "매우", level: 'basic'},
  {id: 2869, en: "vessel", ko: "그릇", level: 'advanced'},
  {id: 2870, en: "veteran", ko: "노련가, 경험 많은 대가, 베테랑", level: 'advanced'},
  {id: 2871, en: "veterinarian", ko: "수의사", level: 'advanced'},
  {id: 2872, en: "via", ko: "…을 거쳐, …을 경유하여", level: 'intermediate'},
  {id: 2873, en: "vice", ko: "악덕,  비행, 타락 행위", level: 'advanced'},
  {id: 2874, en: "victim", ko: "희생, 산 제물, 인신 제물", level: 'intermediate'},
  {id: 2875, en: "victory", ko: "승리, 전승", level: 'intermediate'},
  {id: 2876, en: "view", ko: "봄, 관찰, 개관, 실지 검증  보는 힘, 시계, 시야", level: 'intermediate'},
  {id: 2877, en: "vigorous", ko: "정력적인, 강건한, 활기 있는, 격렬한", level: 'advanced'},
  {id: 2878, en: "village", ko: "마을, 촌락", level: 'intermediate'},
  {id: 2879, en: "violent", ko: "격렬한, 맹렬한", level: 'intermediate'},
  {id: 2880, en: "virgin", ko: "처녀, 동정녀, 미혼 여성, 동정녀 마리아", level: 'advanced'},
  {id: 2881, en: "virtual", ko: "사실상의, 실질상의, 실제의  허상의", level: 'advanced'},
  {id: 2882, en: "virtue", ko: "덕, 덕행, 선, 선행", level: 'advanced'},
  {id: 2883, en: "visible", ko: "눈에 보이는,  볼 수 있는", level: 'intermediate'},
  {id: 2884, en: "visit", ko: "방문하다, …의 손님으로 묵다", level: 'basic'},
  {id: 2885, en: "visual", ko: "시각의, 물건을 보기 위한", level: 'intermediate'},
  {id: 2886, en: "vital", ko: "생명의, 생명에 관한, 생명유지에 필요한, 살아 있는", level: 'advanced'},
  {id: 2887, en: "vivid", ko: "발랄한, 약동적인, 힘찬, 생기있는", level: 'advanced'},
  {id: 2888, en: "vocabulary", ko: "어휘, 용어수, 용어 범위", level: 'intermediate'},
  {id: 2889, en: "vocation", ko: "천직, 사명 직업, 생업, 장사  적성, 소질, 재능", level: 'advanced'},
  {id: 2890, en: "voice", ko: "목소리, 음성, 음성", level: 'basic'},
  {id: 2891, en: "volume", ko: "용량, 양, (책 등을 세는 단위)권", level: 'intermediate'},
  {id: 2892, en: "voluntary", ko: "자발적인, 수의의", level: 'intermediate'},
  {id: 2893, en: "vote", ko: "찬부 표시, 투표, 표결", level: 'intermediate'},
  {id: 2894, en: "voyage", ko: "여행", level: 'intermediate'},
  {id: 2895, en: "wage", ko: "임금", level: 'intermediate'},
  {id: 2896, en: "wagon", ko: "짐마차", level: 'advanced'},
  {id: 2897, en: "wait", ko: "기다리다", level: 'basic'},
  {id: 2898, en: "wake", ko: "잠깨다", level: 'basic'},
  {id: 2899, en: "walk", ko: "걷다", level: 'basic'},
  {id: 2900, en: "wall", ko: "벽", level: 'basic'},
  {id: 2901, en: "wander", ko: "헤매다", level: 'advanced'},
  {id: 2902, en: "want", ko: "결핍", level: 'basic'},
  {id: 2903, en: "war", ko: "전쟁", level: 'basic'},
  {id: 2904, en: "warehouse", ko: "창고", level: 'advanced'},
  {id: 2905, en: "warm", ko: "따뜻한", level: 'basic'},
  {id: 2906, en: "warn", ko: "경고하다", level: 'intermediate'},
  {id: 2907, en: "warrant", ko: "보증하다 보증", level: 'advanced'},
  {id: 2908, en: "warrior", ko: "병사", level: 'advanced'},
  {id: 2909, en: "wash", ko: "씻다", level: 'basic'},
  {id: 2910, en: "waste", ko: "낭비하다", level: 'intermediate'},
  {id: 2911, en: "watch", ko: "손목시계", level: 'basic'},
  {id: 2912, en: "water", ko: "물", level: 'basic'},
  {id: 2913, en: "watermelon", ko: "수박", level: 'basic'},
  {id: 2914, en: "wave", ko: "물결", level: 'intermediate'},
  {id: 2915, en: "way", ko: "길", level: 'basic'},
  {id: 2916, en: "we", ko: "우리", level: 'basic'},
  {id: 2917, en: "weak", ko: "약한", level: 'intermediate'},
  {id: 2918, en: "wealth", ko: "재산", level: 'intermediate'},
  {id: 2919, en: "weapon", ko: "무기", level: 'intermediate'},
  {id: 2920, en: "wear", ko: "입다", level: 'basic'},
  {id: 2921, en: "weather", ko: "날씨", level: 'basic'},
  {id: 2922, en: "weave", ko: "짜다", level: 'advanced'},
  {id: 2923, en: "wedding", ko: "혼례", level: 'basic'},
  {id: 2924, en: "weed", ko: "잡초 잡초를 뽑다", level: 'advanced'},
  {id: 2925, en: "week", ko: "주", level: 'basic'},
  {id: 2926, en: "weekend", ko: "주말 주말의 주말을 지내다", level: 'basic'},
  {id: 2927, en: "weigh", ko: "무게를 달다", level: 'intermediate'},
  {id: 2928, en: "weight", ko: "무게", level: 'basic'},
  {id: 2929, en: "weird", ko: "불가사의한", level: 'intermediate'},
  {id: 2930, en: "welcome", ko: "환영 환영받는", level: 'basic'},
  {id: 2931, en: "welfare", ko: "행복", level: 'intermediate'},
  {id: 2932, en: "well", ko: "잘, 좋게, 제대로", level: 'basic'},
  {id: 2933, en: "west", ko: "서쪽", level: 'basic'},
  {id: 2934, en: "wet", ko: "축축한", level: 'basic'},
  {id: 2935, en: "whale", ko: "고래", level: 'intermediate'},
  {id: 2936, en: "what", ko: "무엇 무슨", level: 'basic'},
  {id: 2937, en: "wheat", ko: "밀", level: 'intermediate'},
  {id: 2938, en: "wheel", ko: "바퀴", level: 'intermediate'},
  {id: 2939, en: "when", ko: "언제", level: 'basic'},
  {id: 2940, en: "where", ko: "어디에 (-하는)곳에 pr.어디 (문제의)장소", level: 'basic'},
  {id: 2941, en: "whereas", ko: "cnj.(-인)까닭에", level: 'advanced'},
  {id: 2942, en: "whether", ko: "-인지 어떤지", level: 'intermediate'},
  {id: 2943, en: "which", ko: "어느 쪽", level: 'intermediate'},
  {id: 2944, en: "while", ko: "동안 -하는 동안", level: 'intermediate'},
  {id: 2945, en: "whip", ko: "채찍 채찍질하다", level: 'advanced'},
  {id: 2946, en: "whisper", ko: "속삭이다", level: 'intermediate'},
  {id: 2947, en: "whistle", ko: "휘파람", level: 'intermediate'},
  {id: 2948, en: "white", ko: "흰", level: 'basic'},
  {id: 2949, en: "who", ko: "누구", level: 'basic'},
  {id: 2950, en: "whole", ko: "전체의", level: 'intermediate'},
  {id: 2951, en: "why", ko: "왜", level: 'basic'},
  {id: 2952, en: "wicked", ko: "사악한", level: 'advanced'},
  {id: 2953, en: "wide", ko: "폭넓은", level: 'intermediate'},
  {id: 2954, en: "widespread", ko: "널리 보급되어 있는", level: 'intermediate'},
  {id: 2955, en: "widow", ko: "미망인", level: 'advanced'},
  {id: 2956, en: "wife", ko: "아내", level: 'basic'},
  {id: 2957, en: "wild", ko: "야생의", level: 'intermediate'},
  {id: 2958, en: "will", ko: "의지", level: 'basic'},
  {id: 2959, en: "win", ko: "이기다", level: 'basic'},
  {id: 2960, en: "wind", ko: "바람", level: 'basic'},
  {id: 2961, en: "window", ko: "창문, 창", level: 'basic'},
  {id: 2962, en: "wing", ko: "날개", level: 'intermediate'},
  {id: 2963, en: "wipe", ko: "닦다", level: 'intermediate'},
  {id: 2964, en: "wire", ko: "철사", level: 'intermediate'},
  {id: 2965, en: "wise", ko: "슬기로운", level: 'intermediate'},
  {id: 2966, en: "wish", ko: "바라다", level: 'basic'},
  {id: 2967, en: "wit", ko: "기지", level: 'intermediate'},
  {id: 2968, en: "with", ko: "함께", level: 'basic'},
  {id: 2969, en: "withdraw", ko: "물러나다", level: 'advanced'},
  {id: 2970, en: "within", ko: "prop.-의 안쪽에 안으로 내부", level: 'intermediate'},
  {id: 2971, en: "without", ko: "prop.-없이 밖은", level: 'intermediate'},
  {id: 2972, en: "witness", ko: "증언", level: 'intermediate'},
  {id: 2973, en: "woman", ko: "부인", level: 'basic'},
  {id: 2974, en: "wonder", ko: "경이", level: 'intermediate'},
  {id: 2975, en: "wood", ko: "숲", level: 'basic'},
  {id: 2976, en: "wool", ko: "양모", level: 'intermediate'},
  {id: 2977, en: "word", ko: "낱말", level: 'basic'},
  {id: 2978, en: "work", ko: "일", level: 'basic'},
  {id: 2979, en: "world", ko: "세계", level: 'basic'},
  {id: 2980, en: "worry", ko: "근심하다", level: 'basic'},
  {id: 2981, en: "worship", ko: "숭배", level: 'intermediate'},
  {id: 2982, en: "worth", ko: "가치가 있는 가치", level: 'intermediate'},
  {id: 2983, en: "would", ko: "[will의 과거] ...일[할] 것이다", level: 'intermediate'},
  {id: 2984, en: "wound", ko: "부상", level: 'intermediate'},
  {id: 2985, en: "wrap", ko: "싸다", level: 'intermediate'},
  {id: 2986, en: "wreck", ko: "난파", level: 'advanced'},
  {id: 2987, en: "write", ko: "쓰다", level: 'basic'},
  {id: 2988, en: "wrong", ko: "나쁜", level: 'basic'},
  {id: 2989, en: "year", ko: "연", level: 'basic'},
  {id: 2990, en: "yell", ko: "고함치다", level: 'intermediate'},
  {id: 2991, en: "yellow", ko: "노란색", level: 'basic'},
  {id: 2992, en: "yes", ko: "(질문에 대한 답으로)네, 응, 그래", level: 'basic'},
  {id: 2993, en: "yesterday", ko: "어제", level: 'basic'},
  {id: 2994, en: "yet", ko: "아직", level: 'intermediate'},
  {id: 2995, en: "yield", ko: "산출하다", level: 'advanced'},
  {id: 2996, en: "you", ko: "너, 당신", level: 'basic'},
  {id: 2997, en: "young", ko: "젊은", level: 'basic'},
  {id: 2998, en: "zebra", ko: "얼룩말", level: 'basic'},
  {id: 2999, en: "zone", ko: "지역, 구역", level: 'intermediate'},
  {id: 3000, en: "zoo", ko: "동물원", level: 'basic'}
]